webpackJsonp([39],{

/***/ 1186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;__webpack_require__(2726);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRouter=__webpack_require__(3);var _reactRedux=__webpack_require__(13);var _reactReduxI18n=__webpack_require__(15);var _Uri=__webpack_require__(17);var _String=__webpack_require__(149);var _Photos=__webpack_require__(43);var _Routes=__webpack_require__(8);var _Tracking=__webpack_require__(121);var _Head=__webpack_require__(115);var _Head2=_interopRequireDefault(_Head);var _Button=__webpack_require__(28);var _Button2=_interopRequireDefault(_Button);var _Searchbar=__webpack_require__(155);var _Searchbar2=_interopRequireDefault(_Searchbar);var _Tabs=__webpack_require__(1634);var _Tabs2=_interopRequireDefault(_Tabs);var _Tab=__webpack_require__(1548);var _Tab2=_interopRequireDefault(_Tab);var _Gallery=__webpack_require__(1254);var _Gallery2=_interopRequireDefault(_Gallery);var _trending=__webpack_require__(3164);var _trending2=_interopRequireDefault(_trending);var _curated=__webpack_require__(3163);var _curated2=_interopRequireDefault(_curated);var _albums=__webpack_require__(3162);var _albums2=_interopRequireDefault(_albums);var _users=__webpack_require__(3165);var _users2=_interopRequireDefault(_users);var _cart=__webpack_require__(235);var _creditPackages=__webpack_require__(1657);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Market=(_dec=(0,_reactRedux.connect)(function(state){return{creditPackages:state.creditPackages,currentPolicies:state.user.currentPolicies};},{fetchCreditPackages:_creditPackages.fetchCreditPackages,setSelectedPackage:_cart.setSelectedPackage}),_dec(_class=(_temp=_class2=function(_React$Component){_inherits(Market,_React$Component);function Market(props){_classCallCheck(this,Market);//Parse trending photos
var _this=_possibleConstructorReturn(this,(Market.__proto__||Object.getPrototypeOf(Market)).call(this,props));_this.componentDidMount=function(){(0,_Tracking.trackEvent)('viewContent',{contentType:'market',contentName:'market'});if(!_this.props.creditPackages.packages.length){_this.props.fetchCreditPackages();}};_this.setSelectedPackage=function(selectedPackage){_this.props.setSelectedPackage(selectedPackage,'package','market').then(function(response){(0,_Uri.redirect)((0,_Routes.getRouteByName)('payment').path);});};var trendingPhotosArray=_trending2.default.map(function(trendingPhoto){return _extends({},trendingPhoto,{hash:(0,_String.hashCode)(new Date().getHours()+new Date().getMinutes()+trendingPhoto.id)});});var trendingPhotosShuffled=trendingPhotosArray.sort(function(a,b){return a.hash<b.hash?-1:a.hash>b.hash?1:0;});trendingPhotosShuffled=trendingPhotosShuffled.slice(0,40);trendingPhotosShuffled=trendingPhotosShuffled.filter(function(photo){return photo&&typeof photo.id!=='undefined';});var curatedAlbumsPhotos=_curated2.default.filter(function(photo){return photo&&typeof photo.id!=='undefined';});var usersPhotos=_users2.default.filter(function(photo){return photo&&typeof photo.id!=='undefined';});var userAlbumsPhotos=_albums2.default.filter(function(photo){return photo&&typeof photo.id!=='undefined';});_this.state={trendingPhotos:trendingPhotosShuffled.map(function(photo){return _extends({},photo,{href:(0,_Routes.getRouteByName)('singlePhoto',{slug:(0,_Photos.getFullSlug)(photo)}).path});}),curatedAlbums:curatedAlbumsPhotos.map(function(photo){return _extends({},photo,{href:(0,_Routes.getRouteByName)('album',{username:photo.username,slug:photo.id}).path});}),users:usersPhotos.filter(function(photo){return photo&&photo.user;}).map(function(photo){return _extends({},photo,{href:(0,_Routes.getRouteByName)('user',{username:photo.user.username}).path});}),userAlbums:userAlbumsPhotos.map(function(photo){return _extends({},photo,{href:(0,_Routes.getRouteByName)('album',{username:photo.username,slug:photo.id}).path});})};return _this;}_createClass(Market,[{key:'render',value:function render(){var _this2=this;var currentPolicies=this.props.currentPolicies;return _react2.default.createElement('div',{className:'container-market'},_react2.default.createElement(_Head2.default,{title:'Market - Authentic, Royalty-Free Stock Photos and Images',description:'Buy real photos by real people! Launch themed photo missions and choose best content. Build your customized commercial photo library for web or print.',robots:'index, follow',canonical:(0,_Routes.getRouteByName)('market').path}),_react2.default.createElement('section',{className:'section-hero'},_react2.default.createElement('div',{className:'centered-content'},_react2.default.createElement('h1',null,'Over 40 million creative photos',_react2.default.createElement('br',null),'for commercial use'),_react2.default.createElement('div',{className:'searchbar-container'},_react2.default.createElement(_Searchbar2.default,{query:this.props.params?this.props.params.query:'',placeholder:'Search high quality images e.g. yellow bird or halloween'}))),_react2.default.createElement('div',{className:'author-info'},_react2.default.createElement('h3',null,'Photo by: ',_react2.default.createElement('a',{href:'/users/jordandeckertmedia'},_react2.default.createElement('strong',null,'jordandeckertmedia'))),_react2.default.createElement(_reactRouter.Link,{to:(0,_Routes.getRouteByName)('singlePhoto',{slug:"surfs-tide-9f69309a-1b7c-4e5d-be4c-0ac8ae7cbb7e"}).path},'Buy this Photo'))),_react2.default.createElement('section',{className:'section-tabs-gallery'},_react2.default.createElement(_Tabs2.default,null,_react2.default.createElement(_Tab2.default,{title:'Trending Images',active:true},_react2.default.createElement('div',{className:'container-fluid'},_react2.default.createElement(_Gallery2.default,{photos:this.state.trendingPhotos}))),_react2.default.createElement(_Tab2.default,{title:'Theme Collections'},_react2.default.createElement('div',{className:'container-fluid'},_react2.default.createElement(_Gallery2.default,{overlayType:'static',photos:this.state.curatedAlbums}))),_react2.default.createElement(_Tab2.default,{title:'Featured Photographers'},_react2.default.createElement('div',{className:'container-fluid'},_react2.default.createElement(_Gallery2.default,{overlayType:'user',photos:this.state.users}))),_react2.default.createElement(_Tab2.default,{title:'Selected Albums'},_react2.default.createElement('div',{className:'container-fluid'},_react2.default.createElement(_Gallery2.default,{overlayType:'static',photos:this.state.userAlbums}))))),!currentPolicies.buyCredits?null:_react2.default.createElement('section',{className:'section-pricing'},_react2.default.createElement('div',{className:'container-fluid'},_react2.default.createElement('h3',{className:'pricing-headline'},'Choose one easy plan'),_react2.default.createElement('div',{className:'packages custom-scrollbar'},_react2.default.createElement('div',{className:'package-box single'},_react2.default.createElement('h3',{className:'package-name'},'Single photo'),_react2.default.createElement('span',{className:'package-price'},_react2.default.createElement('sup',null,'$'),'10.00'),_react2.default.createElement('div',{className:'package-features'},_react2.default.createElement('p',{className:'package-feature'},'Royalty free'),_react2.default.createElement('p',{className:'package-feature'},'Unlimited reproductions'),_react2.default.createElement('p',{className:'package-feature'},'Worldwide usage'))),this.props.creditPackages.packages.map(function(creditPackage){if(creditPackage.credits===500){return null;}return _react2.default.createElement('div',{key:creditPackage.id,className:'package-box '+(creditPackage.credits===200?'highlighted':'')},_react2.default.createElement('div',{className:'promo'},_react2.default.createElement('span',{className:'promo-text'},'MOST POPULAR')),_react2.default.createElement('h3',{className:'package-name'},creditPackage.worthPhotos,' photos'),_react2.default.createElement('span',{className:'package-price'},_react2.default.createElement('sup',null,'$'),creditPackage.price.toFixed(2)),_react2.default.createElement('div',{className:'package-features'},_react2.default.createElement('p',{className:'package-feature'},'You save ',_react2.default.createElement('strong',null,creditPackage.discountPercentage,'%'))),_react2.default.createElement(_Button2.default,{layout:'full-width',onClick:function onClick(){return _this2.setSelectedPackage(creditPackage);},styleType:creditPackage.credits===200?'primary':'secondary'},'Buy now'));})),_react2.default.createElement('footer',{className:'pricing-footer'},_react2.default.createElement('p',null,_react2.default.createElement('strong',null,'Need content that drives engagement and sales?'),' Try our ',_react2.default.createElement(_reactRouter.Link,{to:(0,_Routes.getRouteByName)('enterprise').path},'Enterprise solutions'),' trusted by some of the world\'s smartest companies. Big and small.')))),_react2.default.createElement('section',{className:'section-boxes'},_react2.default.createElement('div',{className:'boxes-bg'},_react2.default.createElement('div',{className:'box-bg'}),_react2.default.createElement('div',{className:'box-bg highlighted'})),_react2.default.createElement('div',{className:'boxes'},_react2.default.createElement('div',{className:'container-fluid'},_react2.default.createElement('div',{className:'box box-left'},_react2.default.createElement('div',{className:'icon'},_react2.default.createElement('i',{className:'fa fa-camera'})),_react2.default.createElement('div',{className:'copy'},_react2.default.createElement('p',{className:'subtitle'},'ARE YOU A PHOTOGRAPHER?'),_react2.default.createElement('h2',{className:'title'},'Turn your photos into dollars.')),_react2.default.createElement('div',{className:'cta'},_react2.default.createElement(_Button2.default,{element:'anchor',to:(0,_Routes.getRouteByName)('photographer').path,styleType:'secondary'},'Download our App and Start Uploading'))),_react2.default.createElement('div',{className:'box box-right'},_react2.default.createElement('div',{className:'icon'},_react2.default.createElement('i',{className:'fa fa-picture-o'})),_react2.default.createElement('div',{className:'copy'},_react2.default.createElement('p',{className:'subtitle'},'FOR BRANDS AND AGENCIES'),_react2.default.createElement('h2',{className:'title'},'Brand storytelling content on demand.')),_react2.default.createElement('div',{className:'cta'},_react2.default.createElement(_Button2.default,{element:'anchor',to:(0,_Routes.getRouteByName)('enterprise').path,styleType:'secondary'},'Check our Solutions for Brands')))))));}}]);return Market;}(_react2.default.Component),_class2.propTypes={fetchCreditPackages:_propTypes2.default.func.isRequired,setSelectedPackage:_propTypes2.default.func.isRequired,creditPackages:_propTypes2.default.shape({packages:_propTypes2.default.arrayOf(_propTypes2.default.shape({id:_propTypes2.default.string.isRequired,name:_propTypes2.default.string.isRequired,credits:_propTypes2.default.number.isRequired,price:_propTypes2.default.number.isRequired,discountPercentage:_propTypes2.default.number.isRequired}))}),params:_propTypes2.default.shape({query:_propTypes2.default.string,page:_propTypes2.default.string}),currentPolicies:_propTypes2.default.shape({buyCredits:_propTypes2.default.bool.isRequired}).isRequired},_class2.defaultProps={},_temp))||_class);exports.default=Market;

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(1275), __webpack_require__(148));
	else if(typeof define === 'function' && define.amd)
		define("reactTippy", ["react", "popper.js", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["reactTippy"] = factory(require("react"), require("popper.js"), require("react-dom"));
	else
		root["reactTippy"] = factory(root["React"], root["Popper"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_39__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Browser = exports.Browser = {};

if (typeof window !== 'undefined') {
  Browser.SUPPORTED = 'requestAnimationFrame' in window;
  Browser.SUPPORTS_TOUCH = 'ontouchstart' in window;
  Browser.touch = false;
  Browser.dynamicInputDetection = true;
  // Chrome device/touch emulation can make this dynamic
  Browser.iOS = function () {
    return (/iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream
    );
  };
}

/**
* The global storage array which holds all data reference objects
* from every instance
* This allows us to hide tooltips from all instances, finding the ref when
* clicking on the body, and for followCursor
*/
var Store = exports.Store = [];

/**
* Selector constants used for grabbing elements
*/
var Selectors = exports.Selectors = {
  POPPER: '.tippy-popper',
  TOOLTIP: '.tippy-tooltip',
  CONTENT: '.tippy-tooltip-content',
  CIRCLE: '[x-circle]',
  ARROW: '[x-arrow]',
  TOOLTIPPED_EL: '[data-tooltipped]',
  CONTROLLER: '[data-tippy-controller]'
};

/**
* The default settings applied to each instance
*/
var Defaults = exports.Defaults = {
  html: false,
  position: 'top',
  animation: 'shift',
  animateFill: true,
  arrow: false,
  arrowSize: 'regular',
  delay: 0,
  trigger: 'mouseenter focus',
  duration: 350,
  interactive: false,
  interactiveBorder: 2,
  theme: 'dark',
  size: 'regular',
  distance: 10,
  offset: 0,
  hideOnClick: true,
  multiple: false,
  followCursor: false,
  inertia: false,
  flipDuration: 350,
  sticky: false,
  stickyDuration: 200,
  appendTo: function appendTo() {
    return document.body;
  },
  zIndex: 9999,
  touchHold: false,
  performance: false,
  dynamicTitle: false,
  useContext: false,
  reactInstance: undefined,
  popperOptions: {},
  open: undefined,
  onRequestClose: function onRequestClose() {}
};

/**
* The keys of the defaults object for reducing down into a new object
* Used in `getIndividualSettings()`
*/
var DefaultsKeys = exports.DefaultsKeys = Browser.SUPPORTED && Object.keys(Defaults);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefix;
/**
* Returns the supported prefixed property - only `webkit` is needed, `moz`, `ms` and `o` are obsolete
* @param {String} property
* @return {String} - browser supported prefixed property
*/
function prefix(property) {
  var prefixes = [false, 'webkit'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var _prefix = prefixes[i];
    var prefixedProp = _prefix ? '' + _prefix + upperProp : property;
    if (typeof window.document.body.style[prefixedProp] !== 'undefined') {
      return prefixedProp;
    }
  }

  return null;
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = find;
/**
* Ponyfill for Array.prototype.find
* @param {Array} arr
* @param {Function} checkFn
* @return item in the array
*/
function find(arr, checkFn) {
  if (Array.prototype.find) {
    return arr.find(checkFn);
  }

  // use `filter` as fallback
  return arr.filter(checkFn)[0];
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCorePlacement;
/**
* Returns the non-shifted placement (e.g., 'bottom-start' => 'bottom')
* @param {String} placement
* @return {String}
*/
function getCorePlacement(placement) {
  return placement.replace(/-.+/, '');
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closest;

var _matches = __webpack_require__(8);

/**
* Ponyfill to get the closest parent element
* @param {Element} element - child of parent to be returned
* @param {String} parentSelector - selector to match the parent if found
* @return {Element}
*/
function closest(element, parentSelector) {
  var _closest = Element.prototype.closest || function (selector) {
    var el = this;
    while (el) {
      if (_matches.matches.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
  };

  return _closest.call(element, parentSelector);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defer;
/**
* Waits until next repaint to execute a fn
* @param {Function} fn
*/
function defer(fn) {
  window.requestAnimationFrame(function () {
    setTimeout(fn, 0);
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getInnerElements;

var _globals = __webpack_require__(0);

/**
* Returns inner elements of the popper element
* @param {Element} popper
* @return {Object}
*/
function getInnerElements(popper) {
  return {
    tooltip: popper.querySelector(_globals.Selectors.TOOLTIP),
    circle: popper.querySelector(_globals.Selectors.CIRCLE),
    content: popper.querySelector(_globals.Selectors.CONTENT)
  };
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isVisible;
/**
* Determines if a popper is currently visible
* @param {Element} popper
* @return {Boolean}
*/
function isVisible(popper) {
  return popper.style.visibility === 'visible';
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function defaultMatchSelector(s) {
  var matches = (this.document || this.ownerDocument).querySelectorAll(s),
      i = matches.length;
  while (--i >= 0 && matches.item(i) !== this) {}
  return i > -1;
}

var matches = exports.matches = typeof window === 'undefined' ? defaultMatchSelector : Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || defaultMatchSelector;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _tippy = __webpack_require__(30);

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  html: null,
  position: 'top',
  animation: 'shift',
  animateFill: true,
  arrow: false,
  delay: 0,
  hideDelay: 0,
  trigger: 'mouseenter focus',
  duration: 375,
  hideDuration: 375,
  interactive: false,
  interactiveBorder: 2,
  theme: 'dark',
  offset: 0,
  hideOnClick: true,
  multiple: false,
  followCursor: false,
  inertia: false,
  popperOptions: {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onHide: function onHide() {},
  onHidden: function onHidden() {},
  disabled: false,
  arrowSize: 'regular',
  size: 'regular',
  className: '',
  style: {},
  distance: 10,
  onRequestClose: function onRequestClose() {},
  sticky: false,
  stickyDuration: 200,
  touchHold: false,
  unmountHTMLWhenHide: false
};

var propKeys = Object.keys(defaultProps);

var detectPropsChanged = function detectPropsChanged(props, prevProps) {
  var result = [];
  propKeys.forEach(function (key) {
    if (props[key] !== prevProps[key]) {
      result.push(key);
    }
  });
  return result;
};

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.initTippy = _this._initTippy.bind(_this);
    _this.destroyTippy = _this._destroyTippy.bind(_this);
    _this.updateTippy = _this._updateTippy.bind(_this);
    _this.updateReactDom = _this._updateReactDom.bind(_this);
    _this.showTooltip = _this._showTooltip.bind(_this);
    _this.hideTooltip = _this._hideTooltip.bind(_this);
    _this.updateSettings = _this._updateSettings.bind(_this);
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      this.initTippy();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      this.destroyTippy();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // enable and disabled
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.props.disabled === false && prevProps.disabled === true) {
        this.updateSettings('disabled', false);
        this.destroyTippy();
        this.initTippy();
        return;
      }

      if (this.props.disabled === true && prevProps.disabled === false) {
        this.updateSettings('disabled', true);
        this.destroyTippy();
        return;
      }

      // open
      if (this.props.open === true && !prevProps.open) {
        this.updateSettings('open', true);
        setTimeout(function () {
          _this2.showTooltip();
        }, 0);
      }
      if (this.props.open === false && prevProps.open === true) {
        this.updateSettings('open', false);
        this.hideTooltip();
      }

      if (this.props.html !== prevProps.html) {
        this.updateReactDom();
      }

      // Update content
      if (this.props.title !== prevProps.title) {
        this.updateTippy();
      }

      // update otherProps
      var propChanges = detectPropsChanged(this.props, prevProps);
      propChanges.forEach(function (key) {
        _this2.updateSettings(key, _this2.props[key]);
      });
    }
  }, {
    key: '_showTooltip',
    value: function _showTooltip() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.show(popper, this.props.duration);
      }
    }
  }, {
    key: '_hideTooltip',
    value: function _hideTooltip() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.hide(popper, this.props.hideDuration);
      }
    }
  }, {
    key: '_updateSettings',
    value: function _updateSettings(name, value) {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.updateSettings(popper, name, value);
      }
    }
  }, {
    key: '_updateReactDom',
    value: function _updateReactDom() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        this.updateSettings('reactDOM', this.props.html);
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        var isVisible = popper.style.visibility === 'visible' || this.props.open;
        if (isVisible) {
          this.tippy.updateForReact(popper, this.props.html);
        }
      }
    }
  }, {
    key: '_updateTippy',
    value: function _updateTippy() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.update(popper);
      }
    }
  }, {
    key: '_initTippy',
    value: function _initTippy() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (!this.props.disabled) {
        this.tooltipDOM.setAttribute('title', this.props.title);
        this.tippy = (0, _tippy2.default)(this.tooltipDOM, {
          disabled: this.props.disabled,
          position: this.props.position,
          animation: this.props.animation,
          animateFill: this.props.animateFill,
          arrow: this.props.arrow,
          arrowSize: this.props.arrowSize,
          delay: this.props.delay,
          hideDelay: this.props.hideDelay,
          trigger: this.props.trigger,
          duration: this.props.duration,
          hideDuration: this.props.hideDuration,
          interactive: this.props.interactive,
          interactiveBorder: this.props.interactiveBorder,
          theme: this.props.theme,
          offset: this.props.offset,
          hideOnClick: this.props.hideOnClick,
          multiple: this.props.multiple,
          size: this.props.size,
          followCursor: this.props.followCursor,
          inertia: this.props.inertia,
          popperOptions: this.props.popperOptions,
          onShow: this.props.onShow,
          onShown: this.props.onShown,
          onHide: this.props.onHide,
          onHidden: this.props.onHidden,
          distance: this.props.distance,
          reactDOM: this.props.html,
          unmountHTMLWhenHide: this.props.unmountHTMLWhenHide,
          open: this.props.open,
          sticky: this.props.sticky,
          stickyDuration: this.props.stickyDuration,
          touchHold: this.props.touchHold,
          onRequestClose: this.props.onRequestClose,
          useContext: this.props.useContext,
          reactInstance: this.props.useContext ? this : undefined,
          performance: true,
          html: this.props.rawTemplate ? this.props.rawTemplate : undefined
        });
        if (this.props.open) {
          this.showTooltip();
        }
      } else {
        this.tippy = null;
      }
    }
  }, {
    key: '_destroyTippy',
    value: function _destroyTippy() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.updateSettings('open', false);
        this.tippy.hide(popper, 0);
        this.tippy.destroy(popper);
        this.tippy = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(tooltip) {
            _this3.tooltipDOM = tooltip;
          },
          title: this.props.title,
          className: this.props.className,
          tabIndex: this.props.tabIndex,
          style: _extends({
            display: 'inline'
          }, this.props.style)
        },
        this.props.children
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.defaultProps = defaultProps;

exports.default = Tooltip;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = followCursorHandler;

var _globals = __webpack_require__(0);

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Mousemove event listener callback method for follow cursor setting
* @param {MouseEvent} e
*/
function followCursorHandler(e) {
  var _this = this;

  var refData = (0, _find2.default)(_globals.Store, function (refData) {
    return refData.el === _this;
  });

  var popper = refData.popper,
      offset = refData.settings.offset;


  var position = (0, _getCorePlacement2.default)(popper.getAttribute('x-placement'));
  var halfPopperWidth = Math.round(popper.offsetWidth / 2);
  var halfPopperHeight = Math.round(popper.offsetHeight / 2);
  var viewportPadding = 5;
  var pageWidth = document.documentElement.offsetWidth || document.body.offsetWidth;

  var pageX = e.pageX,
      pageY = e.pageY;


  var x = void 0,
      y = void 0;

  switch (position) {
    case 'top':
      x = pageX - halfPopperWidth + offset;
      y = pageY - 2.25 * halfPopperHeight;
      break;
    case 'left':
      x = pageX - 2 * halfPopperWidth - 10;
      y = pageY - halfPopperHeight + offset;
      break;
    case 'right':
      x = pageX + halfPopperHeight;
      y = pageY - halfPopperHeight + offset;
      break;
    case 'bottom':
      x = pageX - halfPopperWidth + offset;
      y = pageY + halfPopperHeight / 1.5;
      break;
  }

  var isRightOverflowing = pageX + viewportPadding + halfPopperWidth + offset > pageWidth;
  var isLeftOverflowing = pageX - viewportPadding - halfPopperWidth + offset < 0;

  // Prevent left/right overflow
  if (position === 'top' || position === 'bottom') {
    if (isRightOverflowing) {
      x = pageWidth - viewportPadding - 2 * halfPopperWidth;
    }

    if (isLeftOverflowing) {
      x = viewportPadding;
    }
  }

  popper.style[(0, _prefix2.default)('transform')] = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOffsetDistanceInPx;

var _globals = __webpack_require__(0);

/**
* Returns the distance taking into account the default distance due to
* the transform: translate setting in CSS
* @param {Number} distance
* @return {String}
*/
function getOffsetDistanceInPx(distance) {
  return -(distance - _globals.Defaults.distance) + 'px';
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeTitle;
/**
* Removes the title from the tooltipped element, setting `data-original-title`
* appropriately
* @param {Element} el
*/
function removeTitle(el) {
  var title = el.getAttribute('title');

  // Only set `data-original-title` attr if there is a title
  if (title) {
    el.setAttribute('data-original-title', title);
  }

  el.removeAttribute('title');
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _component = __webpack_require__(9);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withTooltip = function withTooltip(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref) {
    var props = _objectWithoutProperties(_ref, []);

    return _react2.default.createElement(
      _component2.default,
      options,
      _react2.default.createElement(Component, props)
    );
  };
};

exports.default = withTooltip;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTooltip = exports.Tooltip = undefined;

var _component = __webpack_require__(9);

var _component2 = _interopRequireDefault(_component);

var _hoc = __webpack_require__(14);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tooltip = _component2.default;
exports.withTooltip = _hoc2.default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bindEventListeners;

var _globals = __webpack_require__(0);

var _hideAllPoppers = __webpack_require__(25);

var _hideAllPoppers2 = _interopRequireDefault(_hideAllPoppers);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _matches = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Adds the needed event listeners
*/
function bindEventListeners() {
  var touchHandler = function touchHandler() {
    _globals.Browser.touch = true;

    if (_globals.Browser.iOS()) {
      document.body.classList.add('tippy-touch');
    }

    if (_globals.Browser.dynamicInputDetection && window.performance) {
      document.addEventListener('mousemove', mousemoveHandler);
    }
  };

  var mousemoveHandler = function () {
    var time = void 0;

    return function () {
      var now = performance.now();

      // Chrome 60+ is 1 mousemove per rAF, use 20ms time difference
      if (now - time < 20) {
        _globals.Browser.touch = false;
        document.removeEventListener('mousemove', mousemoveHandler);
        if (!_globals.Browser.iOS()) {
          document.body.classList.remove('tippy-touch');
        }
      }

      time = now;
    };
  }();

  var clickHandler = function clickHandler(event) {
    // Simulated events dispatched on the document
    if (!(event.target instanceof Element)) {
      return (0, _hideAllPoppers2.default)();
    }

    var el = (0, _closest2.default)(event.target, _globals.Selectors.TOOLTIPPED_EL);
    var popper = (0, _closest2.default)(event.target, _globals.Selectors.POPPER);

    if (popper) {
      var ref = (0, _find2.default)(_globals.Store, function (ref) {
        return ref.popper === popper;
      });
      var interactive = ref.settings.interactive;

      if (interactive) return;
    }

    if (el) {
      var _ref = (0, _find2.default)(_globals.Store, function (ref) {
        return ref.el === el;
      });
      var _ref$settings = _ref.settings,
          hideOnClick = _ref$settings.hideOnClick,
          multiple = _ref$settings.multiple,
          trigger = _ref$settings.trigger;

      // Hide all poppers except the one belonging to the element that was clicked IF
      // `multiple` is false AND they are a touch user, OR
      // `multiple` is false AND it's triggered by a click

      if (!multiple && _globals.Browser.touch || !multiple && trigger.indexOf('click') !== -1) {
        return (0, _hideAllPoppers2.default)(_ref);
      }

      // If hideOnClick is not strictly true or triggered by a click don't hide poppers
      if (hideOnClick !== true || trigger.indexOf('click') !== -1) return;
    }

    // Don't trigger a hide for tippy controllers, and don't needlessly run loop
    if ((0, _closest2.default)(event.target, _globals.Selectors.CONTROLLER) || !document.querySelector(_globals.Selectors.POPPER)) return;

    (0, _hideAllPoppers2.default)();
  };

  var blurHandler = function blurHandler(event) {
    var _document = document,
        el = _document.activeElement;

    if (el && el.blur && _matches.matches.call(el, _globals.Selectors.TOOLTIPPED_EL)) {
      el.blur();
    }
  };

  // Hook events
  document.addEventListener('click', clickHandler);
  document.addEventListener('touchstart', touchHandler);
  window.addEventListener('blur', blurHandler);

  if (!_globals.Browser.SUPPORTS_TOUCH && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {
    document.addEventListener('pointerdown', touchHandler);
  }
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPopperElement;

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _getOffsetDistanceInPx = __webpack_require__(11);

var _getOffsetDistanceInPx2 = _interopRequireDefault(_getOffsetDistanceInPx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Creates a popper element then returns it
* @param {Number} id - the popper id
* @param {String} title - the tooltip's `title` attribute
* @param {Object} settings - individual settings
* @return {Element} - the popper element
*/
function createPopperElement(id, title, settings) {
  var position = settings.position,
      distance = settings.distance,
      arrow = settings.arrow,
      animateFill = settings.animateFill,
      inertia = settings.inertia,
      animation = settings.animation,
      arrowSize = settings.arrowSize,
      size = settings.size,
      theme = settings.theme,
      html = settings.html,
      zIndex = settings.zIndex,
      interactive = settings.interactive;


  var popper = document.createElement('div');
  popper.setAttribute('class', 'tippy-popper');
  popper.setAttribute('role', 'tooltip');
  popper.setAttribute('aria-hidden', 'true');
  popper.setAttribute('id', 'tippy-tooltip-' + id);
  popper.style.zIndex = zIndex;

  var tooltip = document.createElement('div');
  tooltip.setAttribute('class', 'tippy-tooltip tippy-tooltip--' + size + ' leave');
  tooltip.setAttribute('data-animation', animation);

  theme.split(' ').forEach(function (t) {
    tooltip.classList.add(t + '-theme');
  });

  if (arrow) {
    // Add an arrow
    var _arrow = document.createElement('div');
    _arrow.setAttribute('class', 'arrow-' + arrowSize);
    _arrow.setAttribute('x-arrow', '');
    tooltip.appendChild(_arrow);
  }

  if (animateFill) {
    // Create animateFill circle element for animation
    tooltip.setAttribute('data-animatefill', '');
    var circle = document.createElement('div');
    circle.setAttribute('class', 'leave');
    circle.setAttribute('x-circle', '');
    tooltip.appendChild(circle);
  }

  if (inertia) {
    // Change transition timing function cubic bezier
    tooltip.setAttribute('data-inertia', '');
  }

  if (interactive) {
    tooltip.setAttribute('data-interactive', '');
  }

  // Tooltip content (text or HTML)
  var content = document.createElement('div');
  content.setAttribute('class', 'tippy-tooltip-content');

  if (html) {
    var templateId = void 0;

    if (html instanceof Element) {
      content.appendChild(html);
      templateId = '#' + html.id || 'tippy-html-template';
    } else {
      content.innerHTML = document.getElementById(html.replace('#', '')).innerHTML;
      templateId = html;
    }

    popper.classList.add('html-template');
    interactive && popper.setAttribute('tabindex', '-1');
    tooltip.setAttribute('data-template-id', templateId);
  } else {
    content.innerHTML = title;
  }

  // Init distance. Further updates are made in the popper instance's `onUpdate()` method
  tooltip.style[(0, _getCorePlacement2.default)(position)] = (0, _getOffsetDistanceInPx2.default)(distance);

  tooltip.appendChild(content);
  popper.appendChild(tooltip);

  return popper;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createPopperInstance;

var _popper = __webpack_require__(38);

var _popper2 = _interopRequireDefault(_popper);

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _getInnerElements2 = __webpack_require__(6);

var _getInnerElements3 = _interopRequireDefault(_getInnerElements2);

var _getOffsetDistanceInPx = __webpack_require__(11);

var _getOffsetDistanceInPx2 = _interopRequireDefault(_getOffsetDistanceInPx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Creates a new popper instance
* @param {Object} data
* @return {Object} - the popper instance
*/
function createPopperInstance(data) {
  var el = data.el,
      popper = data.popper,
      _data$settings = data.settings,
      position = _data$settings.position,
      popperOptions = _data$settings.popperOptions,
      offset = _data$settings.offset,
      distance = _data$settings.distance,
      flipDuration = _data$settings.flipDuration;

  var _getInnerElements = (0, _getInnerElements3.default)(popper),
      tooltip = _getInnerElements.tooltip;

  var config = _extends({
    placement: position
  }, popperOptions || {}, {
    modifiers: _extends({}, popperOptions ? popperOptions.modifiers : {}, {
      flip: _extends({
        padding: distance + 5 /* 5px from viewport boundary */
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.flip : {}),
      offset: _extends({
        offset: offset
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.offset : {})
    }),
    onUpdate: function onUpdate() {
      var styles = tooltip.style;
      styles.top = '';
      styles.bottom = '';
      styles.left = '';
      styles.right = '';
      styles[(0, _getCorePlacement2.default)(popper.getAttribute('x-placement'))] = (0, _getOffsetDistanceInPx2.default)(distance);
    }
  });

  // Update the popper's position whenever its content changes
  // Not supported in IE10 unless polyfilled
  if (window.MutationObserver) {
    var styles = popper.style;

    var observer = new MutationObserver(function () {
      styles[(0, _prefix2.default)('transitionDuration')] = '0ms';
      data.popperInstance.update();
      (0, _defer2.default)(function () {
        styles[(0, _prefix2.default)('transitionDuration')] = flipDuration + 'ms';
      });
    });

    observer.observe(popper, {
      childList: true,
      subtree: true,
      characterData: true
    });

    data._mutationObserver = observer;
  }

  return new _popper2.default(el, popper, config);
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTooltips;

var _getIndividualSettings = __webpack_require__(24);

var _getIndividualSettings2 = _interopRequireDefault(_getIndividualSettings);

var _createPopperElement = __webpack_require__(17);

var _createPopperElement2 = _interopRequireDefault(_createPopperElement);

var _createTrigger = __webpack_require__(20);

var _createTrigger2 = _interopRequireDefault(_createTrigger);

var _getEventListenerHandlers = __webpack_require__(23);

var _getEventListenerHandlers2 = _interopRequireDefault(_getEventListenerHandlers);

var _evaluateSettings = __webpack_require__(21);

var _evaluateSettings2 = _interopRequireDefault(_evaluateSettings);

var _removeTitle = __webpack_require__(12);

var _removeTitle2 = _interopRequireDefault(_removeTitle);

var _globals = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idCounter = 1;

/**
* Creates tooltips for all el elements that match the instance's selector
* @param {Element[]} els
* @return {Object[]} Array of ref data objects
*/
function createTooltips(els) {
  var _this = this;

  return els.reduce(function (a, el) {
    var id = idCounter;

    var settings = (0, _evaluateSettings2.default)(_this.settings.performance ? _this.settings : (0, _getIndividualSettings2.default)(el, _this.settings));

    var html = settings.html,
        trigger = settings.trigger,
        touchHold = settings.touchHold;


    var title = el.getAttribute('title');
    if (!title && !html) return a;

    el.setAttribute('data-tooltipped', '');
    el.setAttribute('aria-describedby', 'tippy-tooltip-' + id);
    (0, _removeTitle2.default)(el);

    var popper = (0, _createPopperElement2.default)(id, title, settings);
    var handlers = _getEventListenerHandlers2.default.call(_this, el, popper, settings);

    var listeners = [];

    trigger.trim().split(' ').forEach(function (event) {
      return listeners = listeners.concat((0, _createTrigger2.default)(event, el, handlers, touchHold));
    });

    a.push({
      id: id,
      el: el,
      popper: popper,
      settings: settings,
      listeners: listeners,
      tippyInstance: _this
    });

    idCounter++;

    return a;
  }, []);
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTrigger;

var _globals = __webpack_require__(0);

/**
* Creates a trigger
* @param {Object} event - the custom event specified in the `trigger` setting
* @param {Element} el - tooltipped element
* @param {Object} handlers - the handlers for each listener
* @param {Boolean} touchHold
* @return {Array} - array of listener objects
*/
function createTrigger(event, el, handlers, touchHold) {
  var listeners = [];

  if (event === 'manual') return listeners;

  // Enter
  el.addEventListener(event, handlers.handleTrigger);
  listeners.push({
    event: event,
    handler: handlers.handleTrigger
  });

  // Leave
  if (event === 'mouseenter') {
    if (_globals.Browser.SUPPORTS_TOUCH && touchHold) {
      el.addEventListener('touchstart', handlers.handleTrigger);
      listeners.push({
        event: 'touchstart',
        handler: handlers.handleTrigger
      });
      el.addEventListener('touchend', handlers.handleMouseleave);
      listeners.push({
        event: 'touchend',
        handler: handlers.handleMouseleave
      });
    }

    el.addEventListener('mouseleave', handlers.handleMouseleave);
    listeners.push({
      event: 'mouseleave',
      handler: handlers.handleMouseleave
    });
  }

  if (event === 'focus') {
    el.addEventListener('blur', handlers.handleBlur);
    listeners.push({
      event: 'blur',
      handler: handlers.handleBlur
    });
  }

  return listeners;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = evaluateSettings;
/**
* Evaluates/modifies the settings object for appropriate behavior
* @param {Object} settings
* @return {Object} modified/evaluated settings
*/
function evaluateSettings(settings) {
  // animateFill is disabled if an arrow is true
  if (settings.arrow) {
    settings.animateFill = false;
  }

  // reassign appendTo into the result of evaluating appendTo
  // if it's set as a function instead of Element
  if (settings.appendTo && typeof settings.appendTo === 'function') {
    settings.appendTo = settings.appendTo();
  }

  return settings;
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getArrayOfElements;
/**
* Returns an array of elements based on the selector input
* @param {String|Element|Element[]} selector
* @return {Element[]}
*/
function getArrayOfElements(selector) {
  if (selector instanceof Element) {
    return [selector];
  }

  if (Array.isArray(selector)) {
    return selector;
  }

  return [].slice.call(document.querySelectorAll(selector));
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getEventListenerHandlers;

var _globals = __webpack_require__(0);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

var _cursorIsOutsideInteractiveBorder = __webpack_require__(32);

var _cursorIsOutsideInteractiveBorder2 = _interopRequireDefault(_cursorIsOutsideInteractiveBorder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Returns relevant listener callbacks for each ref
* @param {Element} el
* @param {Element} popper
* @param {Object} settings
* @return {Object} - relevant listener handlers
*/
function getEventListenerHandlers(el, popper, settings) {
  var _this = this;

  var position = settings.position,
      delay = settings.delay,
      duration = settings.duration,
      interactive = settings.interactive,
      interactiveBorder = settings.interactiveBorder,
      distance = settings.distance,
      hideOnClick = settings.hideOnClick,
      trigger = settings.trigger,
      touchHold = settings.touchHold,
      touchWait = settings.touchWait;


  var showDelay = void 0,
      hideDelay = void 0;

  var clearTimeouts = function clearTimeouts() {
    clearTimeout(showDelay);
    clearTimeout(hideDelay);
  };

  var _show = function _show() {
    clearTimeouts();

    // Not hidden. For clicking when it also has a `focus` event listener
    if ((0, _isVisible2.default)(popper)) return;

    var _delay = Array.isArray(delay) ? delay[0] : delay;

    if (delay) {
      showDelay = setTimeout(function () {
        return _this.show(popper);
      }, _delay);
    } else {
      _this.show(popper);
    }
  };

  var show = function show(event) {
    return _this.callbacks.wait ? _this.callbacks.wait.call(popper, _show, event) : _show();
  };

  var hide = function hide() {
    clearTimeouts();

    var _delay = Array.isArray(delay) ? delay[1] : delay;

    if (delay) {
      hideDelay = setTimeout(function () {
        return _this.hide(popper);
      }, _delay);
    } else {
      _this.hide(popper);
    }
  };

  var handleTrigger = function handleTrigger(event) {
    var mouseenterTouch = event.type === 'mouseenter' && _globals.Browser.SUPPORTS_TOUCH && _globals.Browser.touch;

    if (mouseenterTouch && touchHold) return;

    // Toggle show/hide when clicking click-triggered tooltips
    var isClick = event.type === 'click';
    var isNotPersistent = hideOnClick !== 'persistent';

    isClick && (0, _isVisible2.default)(popper) && isNotPersistent ? hide() : show(event);

    if (mouseenterTouch && _globals.Browser.iOS() && el.click) {
      el.click();
    }
  };

  var handleMouseleave = function handleMouseleave(event) {

    // Don't fire 'mouseleave', use the 'touchend'
    if (event.type === 'mouseleave' && _globals.Browser.SUPPORTS_TOUCH && _globals.Browser.touch && touchHold) {
      return;
    }

    if (interactive) {
      // Temporarily handle mousemove to check if the mouse left somewhere
      // other than its popper
      var handleMousemove = function handleMousemove(event) {

        var triggerHide = function triggerHide() {
          document.body.removeEventListener('mouseleave', hide);
          document.removeEventListener('mousemove', handleMousemove);
          hide();
        };

        var closestTooltippedEl = (0, _closest2.default)(event.target, _globals.Selectors.TOOLTIPPED_EL);

        var isOverPopper = (0, _closest2.default)(event.target, _globals.Selectors.POPPER) === popper;
        var isOverEl = closestTooltippedEl === el;
        var isClickTriggered = trigger.indexOf('click') !== -1;
        var isOverOtherTooltippedEl = closestTooltippedEl && closestTooltippedEl !== el;

        if (isOverOtherTooltippedEl) {
          return triggerHide();
        }

        if (isOverPopper || isOverEl || isClickTriggered) return;

        if ((0, _cursorIsOutsideInteractiveBorder2.default)(event, popper, settings)) {
          triggerHide();
        }
      };

      document.body.addEventListener('mouseleave', hide);
      document.addEventListener('mousemove', handleMousemove);

      return;
    }

    // If it's not interactive, just hide it
    hide();
  };

  var handleBlur = function handleBlur(event) {
    // Ignore blur on touch devices, if there is no `relatedTarget`, hide
    // If the related target is a popper, ignore
    if (!event.relatedTarget || _globals.Browser.touch) return;
    if ((0, _closest2.default)(event.relatedTarget, _globals.Selectors.POPPER)) return;

    hide();
  };

  return {
    handleTrigger: handleTrigger,
    handleMouseleave: handleMouseleave,
    handleBlur: handleBlur
  };
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIndividualSettings;

var _globals = __webpack_require__(0);

/**
* Returns an object of settings to override global settings
* @param {Element} el - the tooltipped element
* @param {Object} instanceSettings
* @return {Object} - individual settings
*/
function getIndividualSettings(el, instanceSettings) {
  var settings = _globals.DefaultsKeys.reduce(function (acc, key) {
    var val = el.getAttribute('data-' + key.toLowerCase()) || instanceSettings[key];

    // Convert strings to booleans
    if (val === 'false') val = false;
    if (val === 'true') val = true;

    // Convert number strings to true numbers
    if (isFinite(val) && !isNaN(parseFloat(val))) {
      val = parseFloat(val);
    }

    // Convert array strings to actual arrays
    if (typeof val === 'string' && val.trim().charAt(0) === '[') {
      val = JSON.parse(val);
    }

    acc[key] = val;

    return acc;
  }, {});

  return Object.assign({}, instanceSettings, settings);
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hideAllPoppers;

var _globals = __webpack_require__(0);

/**
* Hides all poppers
* @param {Object} exclude - refData to exclude if needed
*/
function hideAllPoppers(exclude) {
  _globals.Store.forEach(function (refData) {
    var popper = refData.popper,
        tippyInstance = refData.tippyInstance,
        _refData$settings = refData.settings,
        appendTo = _refData$settings.appendTo,
        hideOnClick = _refData$settings.hideOnClick,
        trigger = _refData$settings.trigger;

    // Don't hide already hidden ones

    if (!appendTo.contains(popper)) return;

    // hideOnClick can have the truthy value of 'persistent', so strict check is needed
    var isHideOnClick = hideOnClick === true || trigger.indexOf('focus') !== -1;
    var isNotCurrentRef = !exclude || popper !== exclude.popper;

    if (isHideOnClick && isNotCurrentRef) {
      refData.settings.onRequestClose();
      tippyInstance.hide(popper);
    }
  });
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _bindEventListeners = __webpack_require__(16);

var _bindEventListeners2 = _interopRequireDefault(_bindEventListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* To run a single time, once DOM is presumed to be ready
* @return {Boolean} whether the function has run or not
*/
function init() {
  if (init.done) return false;
  init.done = true;

  (0, _bindEventListeners2.default)();

  return true;
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeSticky;

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Updates a popper's position on each animation frame to make it stick to a moving element
* @param {Object} refData
*/
function makeSticky(refData) {
  var popper = refData.popper,
      popperInstance = refData.popperInstance,
      stickyDuration = refData.settings.stickyDuration;


  var applyTransitionDuration = function applyTransitionDuration() {
    return popper.style[(0, _prefix2.default)('transitionDuration')] = stickyDuration + 'ms';
  };

  var removeTransitionDuration = function removeTransitionDuration() {
    return popper.style[(0, _prefix2.default)('transitionDuration')] = '';
  };

  var updatePosition = function updatePosition() {
    popperInstance && popperInstance.scheduleUpdate();

    applyTransitionDuration();

    (0, _isVisible2.default)(popper) ? window.requestAnimationFrame(updatePosition) : removeTransitionDuration();
  };

  // Wait until Popper's position has been updated initially
  (0, _defer2.default)(updatePosition);
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mountPopper;

var _globals = __webpack_require__(0);

var _followCursorHandler = __webpack_require__(10);

var _followCursorHandler2 = _interopRequireDefault(_followCursorHandler);

var _createPopperInstance = __webpack_require__(18);

var _createPopperInstance2 = _interopRequireDefault(_createPopperInstance);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Appends the popper and creates a popper instance if one does not exist
* Also updates its position if need be and enables event listeners
* @param {Object} data -  the element/popper reference data
*/
function mountPopper(data) {
  var el = data.el,
      popper = data.popper,
      _data$settings = data.settings,
      appendTo = _data$settings.appendTo,
      followCursor = _data$settings.followCursor;

  // Already on the DOM

  if (appendTo.contains(popper)) return;

  appendTo.appendChild(popper);

  if (!data.popperInstance) {
    data.popperInstance = (0, _createPopperInstance2.default)(data);
  } else {
    data.popperInstance.update();
    if (!followCursor || _globals.Browser.touch) {
      data.popperInstance.enableEventListeners();
    }
  }

  // Since touch is determined dynamically, followCursor is set on mount
  if (followCursor && !_globals.Browser.touch) {
    el.addEventListener('mousemove', _followCursorHandler2.default);
    data.popperInstance.disableEventListeners();
  }
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onTransitionEnd;

var _globals = __webpack_require__(0);

var _getInnerElements2 = __webpack_require__(6);

var _getInnerElements3 = _interopRequireDefault(_getInnerElements2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Prepares the callback functions for `show` and `hide` methods
* @param {Object} data
* @param {Number} duration
* @param {Function} callback - callback function to fire once transitions complete
*/
function onTransitionEnd(data, duration, callback) {
  // Make callback synchronous if duration is 0
  if (!duration) {
    return callback();
  }

  var _getInnerElements = (0, _getInnerElements3.default)(data.popper),
      tooltip = _getInnerElements.tooltip;

  var transitionendFired = false;

  var listenerCallback = function listenerCallback(e) {
    if (e.target === tooltip && !transitionendFired) {
      transitionendFired = true;
      callback();
    }
  };

  // Fire callback upon transition completion
  tooltip.addEventListener('webkitTransitionEnd', listenerCallback);
  tooltip.addEventListener('transitionend', listenerCallback);

  // Fallback: transitionend listener sometimes may not fire
  clearTimeout(data._transitionendTimeout);
  data._transitionendTimeout = setTimeout(function () {
    if (!transitionendFired) {
      callback();
    }
  }, duration);
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

/* Utility functions */


/* Core library functions */


var _globals = __webpack_require__(0);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _init = __webpack_require__(26);

var _init2 = _interopRequireDefault(_init);

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _findIndex = __webpack_require__(34);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _removeTitle = __webpack_require__(12);

var _removeTitle2 = _interopRequireDefault(_removeTitle);

var _elementIsInViewport = __webpack_require__(33);

var _elementIsInViewport2 = _interopRequireDefault(_elementIsInViewport);

var _triggerReflow = __webpack_require__(37);

var _triggerReflow2 = _interopRequireDefault(_triggerReflow);

var _modifyClassList = __webpack_require__(35);

var _modifyClassList2 = _interopRequireDefault(_modifyClassList);

var _getInnerElements4 = __webpack_require__(6);

var _getInnerElements5 = _interopRequireDefault(_getInnerElements4);

var _applyTransitionDuration = __webpack_require__(31);

var _applyTransitionDuration2 = _interopRequireDefault(_applyTransitionDuration);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

var _noop = __webpack_require__(36);

var _noop2 = _interopRequireDefault(_noop);

var _followCursorHandler = __webpack_require__(10);

var _followCursorHandler2 = _interopRequireDefault(_followCursorHandler);

var _getArrayOfElements = __webpack_require__(22);

var _getArrayOfElements2 = _interopRequireDefault(_getArrayOfElements);

var _onTransitionEnd = __webpack_require__(29);

var _onTransitionEnd2 = _interopRequireDefault(_onTransitionEnd);

var _mountPopper = __webpack_require__(28);

var _mountPopper2 = _interopRequireDefault(_mountPopper);

var _makeSticky = __webpack_require__(27);

var _makeSticky2 = _interopRequireDefault(_makeSticky);

var _createTooltips = __webpack_require__(19);

var _createTooltips2 = _interopRequireDefault(_createTooltips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* @param {String|Element|Element[]} selector
* @param {Object} settings (optional) - the object of settings to be applied to the instance
*/
var Tippy = function () {
  function Tippy(selector) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Tippy);

    // Use default browser tooltip on unsupported browsers
    if (!_globals.Browser.SUPPORTED) return;

    (0, _init2.default)();

    this.state = {
      destroyed: false
    };

    this.selector = selector;

    this.settings = _extends({}, _globals.Defaults, settings);

    if (settings.show || settings.shown || settings.hide || settings.hidden) {
      console.warn('Callbacks without the `on` prefix are deprecated (with the exception of `wait`).' + ' Use onShow, onShown, onHide, and onHidden instead.');
    }

    this.callbacks = {
      wait: settings.wait,
      show: settings.onShow || settings.show || _noop2.default,
      shown: settings.onShown || settings.shown || _noop2.default,
      hide: settings.onHide || settings.hide || _noop2.default,
      hidden: settings.onHidden || settings.hidden || _noop2.default
    };

    this.store = _createTooltips2.default.call(this, (0, _getArrayOfElements2.default)(selector));
    _globals.Store.push.apply(_globals.Store, this.store);
  }

  /**
  * Returns the reference element's popper element
  * @param {Element} el
  * @return {Element}
  */


  _createClass(Tippy, [{
    key: 'getPopperElement',
    value: function getPopperElement(el) {
      try {
        return (0, _find2.default)(this.store, function (data) {
          return data.el === el;
        }).popper;
      } catch (e) {
        console.error('[getPopperElement]: Element passed as the argument does not exist in the instance');
      }
    }

    /**
    * Returns a popper's reference element
    * @param {Element} popper
    * @return {Element}
    */

  }, {
    key: 'getReferenceElement',
    value: function getReferenceElement(popper) {
      try {
        return (0, _find2.default)(this.store, function (data) {
          return data.popper === popper;
        }).el;
      } catch (e) {
        console.error('[getReferenceElement]: Popper passed as the argument does not exist in the instance');
      }
    }

    /**
    * Returns the reference data object from either the reference element or popper element
    * @param {Element} x (reference element or popper)
    * @return {Object}
    */

  }, {
    key: 'getReferenceData',
    value: function getReferenceData(x) {
      return (0, _find2.default)(this.store, function (data) {
        return data.el === x || data.popper === x;
      });
    }

    /**
    * Update settings
    * @param {DOMElement} - popper
    * @param {string} - name
    * @param {string} - value
    */

  }, {
    key: 'updateSettings',
    value: function updateSettings(popper, name, value) {
      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });
      var newSettings = _extends({}, data.settings, _defineProperty({}, name, value));
      data.settings = newSettings;
    }
  }, {
    key: 'updateForReact',


    /**
    * Update for React
    * @param {DOMElement} - popper
    * @param {ReactElement} - content
    */
    value: function updateForReact(popper, updatedContent) {
      var tooltipContent = popper.querySelector(_globals.Selectors.CONTENT);
      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var _data$settings = data.settings,
          useContext = _data$settings.useContext,
          reactInstance = _data$settings.reactInstance;

      if (useContext) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(data.settings.reactInstance, updatedContent, tooltipContent);
      } else {
        _reactDom2.default.render(updatedContent, tooltipContent);
      }
    }
    /**
    * Shows a popper
    * @param {Element} popper
    * @param {Number} customDuration (optional)
    */

  }, {
    key: 'show',
    value: function show(popper, customDuration) {
      var _this = this;

      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var _getInnerElements = (0, _getInnerElements5.default)(popper),
          tooltip = _getInnerElements.tooltip,
          circle = _getInnerElements.circle,
          content = _getInnerElements.content;

      if (!document.body.contains(data.el)) {
        this.destroy(popper);
        return;
      }

      this.callbacks.show.call(popper);

      // Custom react
      if (data && data.settings && data.settings.open === false) {
        return;
      }

      if (data.settings.reactDOM) {
        this.updateForReact(popper, data.settings.reactDOM);
      }
      // end: Custom react

      var el = data.el,
          _data$settings2 = data.settings,
          appendTo = _data$settings2.appendTo,
          sticky = _data$settings2.sticky,
          interactive = _data$settings2.interactive,
          followCursor = _data$settings2.followCursor,
          flipDuration = _data$settings2.flipDuration,
          duration = _data$settings2.duration,
          dynamicTitle = _data$settings2.dynamicTitle;


      if (dynamicTitle) {
        var title = el.getAttribute('title');
        if (title) {
          content.innerHTML = title;
          (0, _removeTitle2.default)(el);
        }
      }

      var _duration = customDuration !== undefined ? customDuration : Array.isArray(duration) ? duration[0] : duration;

      // Prevent a transition when popper changes position
      (0, _applyTransitionDuration2.default)([popper, tooltip, circle], 0);

      (0, _mountPopper2.default)(data);

      popper.style.visibility = 'visible';
      popper.setAttribute('aria-hidden', 'false');

      // Wait for popper's position to update
      (0, _defer2.default)(function () {
        // Sometimes the arrow will not be in the correct position, force another update
        if (!followCursor || _globals.Browser.touch) {
          data.popperInstance.update();
          (0, _applyTransitionDuration2.default)([popper], flipDuration);
        }

        // Re-apply transition durations
        (0, _applyTransitionDuration2.default)([tooltip, circle], _duration);

        // Make content fade out a bit faster than the tooltip if `animateFill`
        if (circle) content.style.opacity = 1;

        // Interactive tooltips receive a class of 'active'
        interactive && el.classList.add('active');

        // Update popper's position on every animation frame
        sticky && (0, _makeSticky2.default)(data);

        // Repaint/reflow is required for CSS transition when appending
        (0, _triggerReflow2.default)(tooltip, circle);

        (0, _modifyClassList2.default)([tooltip, circle], function (list) {
          list.contains('tippy-notransition') && list.remove('tippy-notransition');
          list.remove('leave');
          list.add('enter');
        });

        // Wait for transitions to complete
        (0, _onTransitionEnd2.default)(data, _duration, function () {
          if (!(0, _isVisible2.default)(popper) || data._onShownFired) return;

          // Focus interactive tooltips only
          interactive && popper.focus();
          // Remove transitions from tooltip
          tooltip.classList.add('tippy-notransition');
          // Prevents shown() from firing more than once from early transition cancellations
          data._onShownFired = true;

          _this.callbacks.shown.call(popper);
        });
      });
    }

    /**
    * Hides a popper
    * @param {Element} popper
    * @param {Number} customDuration (optional)
    */

  }, {
    key: 'hide',
    value: function hide(popper, customDuration) {
      var _this2 = this;

      if (this.state.destroyed) return;

      this.callbacks.hide.call(popper);

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var _getInnerElements2 = (0, _getInnerElements5.default)(popper),
          tooltip = _getInnerElements2.tooltip,
          circle = _getInnerElements2.circle,
          content = _getInnerElements2.content;

      // custom react
      // Prevent hide if open


      if (data.settings.disabled === false && data.settings.open) {
        return;
      }

      var isUnmount = data && data.settings && data.settings.unmountHTMLWhenHide && data.settings.reactDOM;
      // end: custom react

      var el = data.el,
          _data$settings3 = data.settings,
          appendTo = _data$settings3.appendTo,
          sticky = _data$settings3.sticky,
          interactive = _data$settings3.interactive,
          followCursor = _data$settings3.followCursor,
          html = _data$settings3.html,
          trigger = _data$settings3.trigger,
          duration = _data$settings3.duration;


      var _duration = customDuration !== undefined ? customDuration : Array.isArray(duration) ? duration[1] : duration;

      data._onShownFired = false;
      interactive && el.classList.remove('active');

      popper.style.visibility = 'hidden';
      popper.setAttribute('aria-hidden', 'true');

      (0, _applyTransitionDuration2.default)([tooltip, circle, circle ? content : null], _duration);

      if (circle) content.style.opacity = 0;

      (0, _modifyClassList2.default)([tooltip, circle], function (list) {
        list.contains('tippy-tooltip') && list.remove('tippy-notransition');
        list.remove('enter');
        list.add('leave');
      });

      // Re-focus click-triggered html elements
      // and the tooltipped element IS in the viewport (otherwise it causes unsightly scrolling
      // if the tooltip is closed and the element isn't in the viewport anymore)
      if (html && trigger.indexOf('click') !== -1 && (0, _elementIsInViewport2.default)(el)) {
        el.focus();
      }

      // Wait for transitions to complete
      (0, _onTransitionEnd2.default)(data, _duration, function () {
        // `isVisible` is not completely reliable to determine if we shouldn't
        // run the hidden callback, we need to check the computed opacity style.
        // This prevents glitchy behavior of the transition when quickly showing
        // and hiding a tooltip.
        if ((0, _isVisible2.default)(popper) || !appendTo.contains(popper) || getComputedStyle(tooltip).opacity === '1') return;

        el.removeEventListener('mousemove', _followCursorHandler2.default);
        data.popperInstance.disableEventListeners();
        appendTo.removeChild(popper);

        _this2.callbacks.hidden.call(popper);

        // custom react
        if (isUnmount) {
          _reactDom2.default.unmountComponentAtNode(content);
        }
      });
    }

    /**
    * Updates a popper with new content
    * @param {Element} popper
    */

  }, {
    key: 'update',
    value: function update(popper) {
      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var _getInnerElements3 = (0, _getInnerElements5.default)(popper),
          content = _getInnerElements3.content;

      var el = data.el,
          html = data.settings.html;


      if (html instanceof Element) {
        console.warn('Aborted: update() should not be used if `html` is a DOM element');
        return;
      }

      content.innerHTML = html ? document.getElementById(html.replace('#', '')).innerHTML : el.getAttribute('title') || el.getAttribute('data-original-title');

      if (!html) (0, _removeTitle2.default)(el);
    }

    /**
    * Destroys a popper
    * @param {Element} popper
    * @param {Boolean} _isLast - private param used by destroyAll to optimize
    */

  }, {
    key: 'destroy',
    value: function destroy(popper, _isLast) {
      var _this3 = this;

      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var el = data.el,
          popperInstance = data.popperInstance,
          listeners = data.listeners,
          _mutationObserver = data._mutationObserver;

      // Ensure the popper is hidden

      if ((0, _isVisible2.default)(popper)) {
        this.hide(popper, 0);
      }

      // Remove Tippy-only event listeners from tooltipped element
      listeners.forEach(function (listener) {
        return el.removeEventListener(listener.event, listener.handler);
      });

      // Restore original title
      el.setAttribute('title', el.getAttribute('data-original-title'));

      el.removeAttribute('data-original-title');
      el.removeAttribute('data-tooltipped');
      el.removeAttribute('aria-describedby');

      popperInstance && popperInstance.destroy();
      _mutationObserver && _mutationObserver.disconnect();

      // Remove from store
      _globals.Store.splice((0, _findIndex2.default)(_globals.Store, function (data) {
        return data.popper === popper;
      }), 1);

      // Ensure filter is called only once
      if (_isLast === undefined || _isLast) {
        this.store = _globals.Store.filter(function (data) {
          return data.tippyInstance === _this3;
        });
      }
    }

    /**
    * Destroys all tooltips created by the instance
    */

  }, {
    key: 'destroyAll',
    value: function destroyAll() {
      var _this4 = this;

      if (this.state.destroyed) return;

      var storeLength = this.store.length;

      this.store.forEach(function (_ref, index) {
        var popper = _ref.popper;

        _this4.destroy(popper, index === storeLength - 1);
      });

      this.store = null;
      this.state.destroyed = true;
    }
  }]);

  return Tippy;
}();

function tippy(selector, settings) {
  return new Tippy(selector, settings);
}

tippy.Browser = _globals.Browser;
tippy.Defaults = _globals.Defaults;
tippy.disableDynamicInputDetection = function () {
  return _globals.Browser.dynamicInputDetection = false;
};
tippy.enableDynamicInputDetection = function () {
  return _globals.Browser.dynamicInputDetection = true;
};

exports.default = tippy;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyTransitionDuration;

var _globals = __webpack_require__(0);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _matches = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Applies the transition duration to each element
* @param {Element[]} els - Array of elements
* @param {Number} duration
*/
function applyTransitionDuration(els, duration) {
  els.forEach(function (el) {
    if (!el) return;

    var isContent = _matches.matches.call(el, _globals.Selectors.CONTENT);

    var _duration = isContent ? Math.round(duration / 1.3) : duration;

    el.style[(0, _prefix2.default)('transitionDuration')] = _duration + 'ms';
  });
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursorIsOutsideInteractiveBorder;

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Determines if the mouse's cursor is outside the interactive border
* @param {MouseEvent} event
* @param {Element} popper
* @param {Object} settings
* @return {Boolean}
*/
function cursorIsOutsideInteractiveBorder(event, popper, settings) {
  if (!popper.getAttribute('x-placement')) return true;

  var x = event.clientX,
      y = event.clientY;
  var interactiveBorder = settings.interactiveBorder,
      distance = settings.distance;


  var rect = popper.getBoundingClientRect();
  var corePosition = (0, _getCorePlacement2.default)(popper.getAttribute('x-placement'));
  var borderWithDistance = interactiveBorder + distance;

  var exceeds = {
    top: rect.top - y > interactiveBorder,
    bottom: y - rect.bottom > interactiveBorder,
    left: rect.left - x > interactiveBorder,
    right: x - rect.right > interactiveBorder
  };

  switch (corePosition) {
    case 'top':
      exceeds.top = rect.top - y > borderWithDistance;
      break;
    case 'bottom':
      exceeds.bottom = y - rect.bottom > borderWithDistance;
      break;
    case 'left':
      exceeds.left = rect.left - x > borderWithDistance;
      break;
    case 'right':
      exceeds.right = x - rect.right > borderWithDistance;
      break;
  }

  return exceeds.top || exceeds.bottom || exceeds.left || exceeds.right;
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = elementIsInViewport;
/**
* Determines if an element is visible in the viewport
* @param {Element} el
* @return {Boolean}
*/
function elementIsInViewport(el) {
  var rect = el.getBoundingClientRect();

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findIndex;

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Ponyfill for Array.prototype.findIndex
* @param {Array} arr
* @param {Function} checkFn
* @return index of the item in the array
*/
function findIndex(arr, checkFn) {
  if (Array.prototype.findIndex) {
    return arr.findIndex(checkFn);
  }

  // fallback
  return arr.indexOf((0, _find2.default)(arr, checkFn));
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modifyClassList;
/**
* Modifies elements' class lists
* @param {Element[]} els - Array of elements
* @param {Function} callback
*/
function modifyClassList(els, callback) {
  els.forEach(function (el) {
    if (!el) return;
    callback(el.classList);
  });
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = noop;
function noop() {}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = triggerReflow;

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Triggers a document repaint or reflow for CSS transition
* @param {Element} tooltip
* @param {Element} circle
*/
function triggerReflow(tooltip, circle) {
  // Safari needs the specific 'transform' property to be accessed
  circle ? window.getComputedStyle(circle)[(0, _prefix2.default)('transform')] : window.getComputedStyle(tooltip).opacity;
}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_38__;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ })
/******/ ]);
});
//# sourceMappingURL=react-tippy.js.map

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(148);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(1296);

var _scrollParent = __webpack_require__(1297);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(1295);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(1298);

var _throttle2 = _interopRequireDefault(_throttle);

var _decorator = __webpack_require__(1294);

var _decorator2 = _interopRequireDefault(_decorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);

  var parentTop = void 0;
  var parentHeight = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentHeight = _parent$getBoundingCl.height;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height

  // check whether the element is visible in the intersection
  var top = void 0;
  var height = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    height = _node$getBoundingClie.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    height = defaultBoundingClientRect.height;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  if (!node) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof process !== 'undefined' && "production" !== 'production') {
        if (_react2.default.Children.count(this.props.children) > 1) {
          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
        }

        if (this.props.wheel) {
          // eslint-disable-line
          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
        }

        // Warn the user if placeholder and height is not specified and the rendered height is 0
        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
        }
      }

      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var needResetFinalLazyLoadHandler = false;
      if (this.props.debounce !== undefined && delayType === 'throttle') {
        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      }

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0) {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var lazyload = exports.lazyload = _decorator2.default;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;__webpack_require__(1307);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _moment=__webpack_require__(42);var _moment2=_interopRequireDefault(_moment);var _reactLazyload=__webpack_require__(1250);var _reactLazyload2=_interopRequireDefault(_reactLazyload);var _reactVisibilitySensor=__webpack_require__(1279);var _reactVisibilitySensor2=_interopRequireDefault(_reactVisibilitySensor);var _Browser=__webpack_require__(19);var _Select=__webpack_require__(1273);var _GalleryLink=__webpack_require__(1302);var _GalleryLink2=_interopRequireDefault(_GalleryLink);var _GalleryOverlay=__webpack_require__(1303);var _GalleryOverlay2=_interopRequireDefault(_GalleryOverlay);var _GalleryOverlayV=__webpack_require__(1304);var _GalleryOverlayV2=_interopRequireDefault(_GalleryOverlayV);var _GalleryControlsV=__webpack_require__(1285);var _GalleryControlsV2=_interopRequireDefault(_GalleryControlsV);var _GalleryPromote=__webpack_require__(1305);var _GalleryPromote2=_interopRequireDefault(_GalleryPromote);var _GallerySelect=__webpack_require__(1280);var _GallerySelect2=_interopRequireDefault(_GallerySelect);var _Picture=__webpack_require__(1281);var _Picture2=_interopRequireDefault(_Picture);var _Spinner=__webpack_require__(52);var _Spinner2=_interopRequireDefault(_Spinner);var _LazyLoadContainer=__webpack_require__(1306);var _LazyLoadContainer2=_interopRequireDefault(_LazyLoadContainer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=(_temp2=_class=function(_React$Component){_inherits(Gallery,_React$Component);function Gallery(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Gallery);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Gallery.__proto__||Object.getPrototypeOf(Gallery)).call.apply(_ref,[this].concat(args))),_this),_this.keys={},_this.state={photoMinHeight:225,lazyLoadOffset:300,selectDirection:null},_this.componentWillUnmount=function(){if((0,_Browser.isBrowser)()){document.removeEventListener("keydown",function(event){return _this.keys[event.keyCode]=false;});document.removeEventListener("keyup",function(event){return _this.keys[event.keyCode]=false;});}},_this.componentWillReceiveProps=function(nextProps){if((0,_Browser.isBrowser)()){//Hack to lazy load photos on tab change
(0,_reactLazyload.forceCheck)();}},_this.onHover=function(photo){if(_this.props.onHover&&window&&window.innerWidth>=1024){_this.props.onHover(photo);}},_this.getGalleryGroups=function(photos,groupBy){var groups={};photos.forEach(function(photo){var date=(0,_moment2.default)(photo[groupBy]).format('MMM D, YYYY');if(!groups.hasOwnProperty(date)){groups[date]=[];}groups[date].push(photo);});return Object.keys(groups).map(function(groupName){return _react2.default.createElement('div',{className:'gallery-group',key:groupName,id:groupName},_react2.default.createElement('span',{className:'gallery-group-name'},groupName),_react2.default.createElement('div',{className:'gallery-group-photos'},_this.getGalleryPhotos(groups[groupName])));});},_this.onSelect=function(selectTarget){var items=_this.props.selectable.items;var photos=_this.props.photos;var selectDirection=_this.state.selectDirection;if(_this.keys[16]&&_this.keys[16]===true){var rangeData=(0,_Select.getRange)(photos,items,selectTarget,selectDirection);selectDirection=rangeData.selectDirection;items=rangeData.selectedItems;}else{var selectedIndex=items.findIndex(function(selectedItem){return selectedItem.id===selectTarget.id;});if(selectedIndex!==-1){items.splice(selectedIndex,1);}else{items.push(selectTarget);}}_this.setState(_extends({},_this.state,{selectDirection:selectDirection}));_this.props.selectable.onStateChange(items);},_this.getGalleryPhotos=function(photos){var _this$state=_this.state,photoMinHeight=_this$state.photoMinHeight,lazyLoadOffset=_this$state.lazyLoadOffset;var _this$props=_this.props,selectable=_this$props.selectable,promotable=_this$props.promotable;var isPortaitsOnlyGallery=photos.filter(function(photo){return photo.width>=photo.height;}).length===0;var multiplier=isPortaitsOnlyGallery?1.4:1;return photos.map(function(photo){var width=photo.width;var height=photo.height>=photoMinHeight?photo.height:photoMinHeight;var realWidth=width*photoMinHeight/photo.height;var photoWidth=realWidth>640?640:realWidth;if((0,_Browser.isBrowser)()&&window.innerWidth<640){photoMinHeight=120;}else if((0,_Browser.isBrowser)()&&window.innerWidth<960){photoMinHeight=250;}return _react2.default.createElement('div',{key:photo.id,className:'picture-wrapper '+(photo.removed?'removed':'')+' '+(photo.isPromoted?'promoted':'')+' '+(photo.isRejected?'rejected':'')+' '+(photo.isDemoted?'demoted':''),id:'photo-'+photo.id,onMouseEnter:function onMouseEnter(){_this.onHover(photo);},style:{width:photoWidth*multiplier+'px',flexGrow:photoWidth*multiplier,flexBasis:realWidth*multiplier+'px'}},_react2.default.createElement('i',{className:'placeholder',style:{paddingBottom:photo.height/photo.width*100+'%'}}),promotable&&promotable.enabled?_react2.default.createElement(_GalleryPromote2.default,{photo:photo,inSelectMode:Boolean(selectable&&selectable.enabled&&selectable.items.length)}):null,photo.controls?_react2.default.createElement(_GalleryControlsV2.default,{photo:photo}):null,selectable&&selectable.enabled?_react2.default.createElement(_GallerySelect2.default,{photo:photo,visibleOnHover:selectable.visibleOnHover||false,onSelect:_this.onSelect,isSelected:_this.props.selectable.items.findIndex(function(selectedItem){return selectedItem.id===photo.id;})!==-1}):null,_react2.default.createElement(_GalleryLink2.default,{href:selectable&&selectable.enabled&&_this.props.selectable.items.length?null:photo.href,onEnter:selectable&&selectable.enabled&&_this.props.selectable.items.length?function(){return _this.onSelect(photo);}:_this.props.onEnter?function(){return _this.props.onEnter(photo);}:null,onEnterAsync:_this.props.onEnterAsync?function(){return _this.props.onEnterAsync(photo);}:null},!photo.overlay?_react2.default.createElement(_GalleryOverlay2.default,{photo:photo,type:_this.props.overlayType}):null,photo.overlay?_react2.default.createElement(_GalleryOverlayV2.default,photo.overlay):null,_react2.default.createElement(_reactLazyload2.default,{height:photo.height/photo.width*100,offset:lazyLoadOffset,resize:true},_react2.default.createElement(_Picture2.default,{url:photo.imageUrl,resolutions:photo.resolutions,alt:photo.selectedCaption}))));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Gallery,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if((0,_Browser.isBrowser)()){document.addEventListener("keydown",function(event){return _this2.keys[event.keyCode]=true;});document.addEventListener("keyup",function(event){return _this2.keys[event.keyCode]=false;});}}},{key:'render',value:function render(){var _this3=this;var photoMinHeight=this.state.photoMinHeight;var _props=this.props,photos=_props.photos,selectable=_props.selectable,isLoading=_props.isLoading,noResultInfo=_props.noResultInfo,promotable=_props.promotable,groupable=_props.groupable;var content=null;if(isLoading){content=_react2.default.createElement(_Spinner2.default,{className:'search-spinner'});}else if(!photos.length&&noResultInfo){content=noResultInfo;}else{if(groupable&&groupable.enabled&&groupable.groupBy){content=this.getGalleryGroups(photos,groupable.groupBy);}else{content=this.getGalleryPhotos(photos);}}return _react2.default.createElement('div',{className:'component-gallery '+(selectable&&selectable.enabled&&selectable.items.length?'select-mode':'')},_react2.default.createElement(_reactVisibilitySensor2.default,{onChange:function onChange(offset){return _this3.setState(_extends({},_this3.state,{lazyLoadOffset:300}),function(){return(0,_reactLazyload.forceCheck)();});}},_react2.default.createElement(_LazyLoadContainer2.default,{baseOffset:300,onOffsetChange:function onOffsetChange(offset){return _this3.setState(_extends({},_this3.state,{lazyLoadOffset:offset}),function(){return(0,_reactLazyload.forceCheck)();});}},_react2.default.createElement('div',{className:'gallery-container'},content))));}}]);return Gallery;}(_react2.default.Component),_class.propTypes={isLoading:_propTypes2.default.bool,noResultInfo:_propTypes2.default.element,overlayType:_propTypes2.default.string,onHover:_propTypes2.default.func,onEnter:_propTypes2.default.func,onEnterAsync:_propTypes2.default.func,photos:_propTypes2.default.arrayOf(_propTypes2.default.shape({imageUrl:_propTypes2.default.string,resolutions:_propTypes2.default.object,width:_propTypes2.default.number.isRequired,height:_propTypes2.default.number.isRequired,alt:_propTypes2.default.string,href:_propTypes2.default.string,controls:_propTypes2.default.object,overlay:_propTypes2.default.shape({type:_propTypes2.default.string,contentArray:_propTypes2.default.array})})),selectable:_propTypes2.default.shape({enabled:_propTypes2.default.bool,visibleOnHover:_propTypes2.default.bool,onStateChange:_propTypes2.default.func,items:_propTypes2.default.array}),promotable:_propTypes2.default.shape({enabled:_propTypes2.default.bool,controls:_propTypes2.default.object}),groupable:_propTypes2.default.shape({enabled:_propTypes2.default.bool,groupBy:_propTypes2.default.string})},_class.defaultProps={isLoading:false,photos:[]},_temp2);exports.default=Gallery;

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;__webpack_require__(1314);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactTippy=__webpack_require__(1245);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModelReleasesStatusIcon=(_temp=_class=function(_React$Component){_inherits(ModelReleasesStatusIcon,_React$Component);function ModelReleasesStatusIcon(){_classCallCheck(this,ModelReleasesStatusIcon);return _possibleConstructorReturn(this,(ModelReleasesStatusIcon.__proto__||Object.getPrototypeOf(ModelReleasesStatusIcon)).apply(this,arguments));}_createClass(ModelReleasesStatusIcon,[{key:'render',value:function render(){var _props=this.props,state=_props.state,photo=_props.photo,tooltips=_props.tooltips;var iconClass=void 0;var displayName=void 0;switch(state){case'error':iconClass='times';displayName='Rejected';break;case'warning':iconClass='exclamation';displayName=photo&&photo.modelReleases&&photo.modelReleases.status==='UPLOADED'?'Uploaded':'Missing';break;case'success':iconClass='user';displayName='Sent to verification';break;}var icon=_react2.default.createElement('div',{className:'state-icon '+state},_react2.default.createElement('i',{className:'fa fa-'+iconClass}));if(tooltips){icon=_react2.default.createElement(_reactTippy.Tooltip,{title:displayName},icon);}return _react2.default.createElement('div',{className:'component-model-releases-status-icon'},icon);}}]);return ModelReleasesStatusIcon;}(_react2.default.Component),_class.propTypes={tooltips:_propTypes2.default.bool,photo:_propTypes2.default.shape({modelReleases:_propTypes2.default.shape({status:_propTypes2.default.string.isRequired}).isRequired}),state:_propTypes2.default.oneOf(['error','warning','success']).isRequired},_class.defaultProps={tooltips:true,photo:null},_temp);exports.default=ModelReleasesStatusIcon;

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getRange=getRange;var _Array=__webpack_require__(385);function getRange(items,selectedItems,selectTarget,selectDirection){var lastSelectedItem=null;var itemsToSelect=[];var lastItemToSelect=null;//Set selection direction
items.forEach(function(item,index){var selectedIndex=selectedItems.findIndex(function(selectedItem){return selectedItem.id===item.id;});//Find last selected item
if(selectedIndex!==-1){lastSelectedItem=item.id;}//Find selection target
if(item.id===selectTarget.id){lastItemToSelect=item.id;//Add selection target to selection
selectedItems.push(item);}// Set selection target
if(lastSelectedItem&&!lastItemToSelect){selectDirection='ltr';}else if(!lastSelectedItem&&lastItemToSelect){selectDirection='rtl';}if(selectDirection==='ltr'){//Select item if loop above last selected and below selection target
if(lastSelectedItem&&!lastItemToSelect){selectedItems.push(item);}//Remove selected items above selection target
if(lastItemToSelect&&item.id!==lastItemToSelect&&selectedIndex!==-1){selectedItems.splice(selectedIndex,1);}}else if(selectDirection==='rtl'){//Select item if loop below last selected and above selection target
if(!lastSelectedItem&&lastItemToSelect){selectedItems.push(item);}//Remove selected items below selection target
if(!lastItemToSelect&&selectedIndex!==-1){selectedItems.splice(selectedIndex,1);}}});//Dedupe selected items
selectedItems=(0,_Array.dedupe)(selectedItems,'id');return{selectDirection:selectDirection,selectedItems:selectedItems};}

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.9
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE10$1() && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(148);
var PropTypes = __webpack_require__(2);
var createReactClass = __webpack_require__(44);
var isVisibleWithOffset = __webpack_require__(1283)

var containmentPropType = PropTypes.any;

if (typeof window !== 'undefined') {
  containmentPropType = PropTypes.instanceOf(window.Element);
}

function throttle (callback, limit) {
    var wait = false;
    return function () {
        if (!wait) {
            wait = true;
            setTimeout(function () {
                callback();
                wait = false;
            }, limit);
        }
    }
}

function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

module.exports = createReactClass({
  displayName: 'VisibilitySensor',

  propTypes: {
    onChange: PropTypes.func,
    active: PropTypes.bool,
    partialVisibility: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    ]),
    delayedCall: PropTypes.bool,
    offset: PropTypes.oneOfType([
      PropTypes.shape({
        top: PropTypes.number,
        left: PropTypes.number,
        bottom: PropTypes.number,
        right: PropTypes.number
      }),
      // deprecated offset property
      PropTypes.shape({
        direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        value: PropTypes.number
      })
    ]),
    scrollCheck: PropTypes.bool,
    scrollDelay: PropTypes.number,
    scrollThrottle: PropTypes.number,
    resizeCheck: PropTypes.bool,
    resizeDelay: PropTypes.number,
    resizeThrottle: PropTypes.number,
    intervalCheck: PropTypes.bool,
    intervalDelay: PropTypes.number,
    containment: containmentPropType,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func,
    ]),
    minTopValue: PropTypes.number,
  },

  getDefaultProps: function () {
    return {
      active: true,
      partialVisibility: false,
      minTopValue: 0,
      scrollCheck: false,
      scrollDelay: 250,
      scrollThrottle: -1,
      resizeCheck: false,
      resizeDelay: 250,
      resizeThrottle: -1,
      intervalCheck: true,
      intervalDelay: 100,
      delayedCall: false,
      offset: {},
      containment: null,
      children: React.createElement('span')
    };
  },

  getInitialState: function () {
    return {
      isVisible: null,
      visibilityRect: {}
    };
  },

  componentDidMount: function () {
    this.node = ReactDOM.findDOMNode(this);
    if (this.props.active) {
      this.startWatching();
    }
  },

  componentWillUnmount: function () {
    this.stopWatching();
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.active && !this.props.active) {
      this.setState(this.getInitialState());
      this.startWatching();
    } else if (!nextProps.active) {
      this.stopWatching();
    }
  },

  getContainer: function () {
    return this.props.containment || window;
  },

  addEventListener: function (target, event, delay, throttle) {
    if (!this.debounceCheck) {
      this.debounceCheck = {};
    }

    var timeout;
    var func;

    var later = function () {
      timeout = null;
      this.check();
    }.bind(this);

    if (throttle > -1) {
      func = function () {
        if (!timeout) {
          timeout = setTimeout(later, throttle || 0);
        }
      };
    } else {
      func = function () {
        clearTimeout(timeout);
        timeout = setTimeout(later, delay || 0);
      };
    }

    var info = {
      target: target,
      fn: func,
      getLastTimeout: function () {
        return timeout;
      },
    };

    target.addEventListener(event, info.fn);
    this.debounceCheck[event] = info;
  },

  startWatching: function () {
    if (this.debounceCheck || this.interval) { return; }

    if (this.props.intervalCheck) {
      this.interval = setInterval(this.check, this.props.intervalDelay);
    }

    if (this.props.scrollCheck) {
      this.addEventListener(
        this.getContainer(),
        'scroll',
        this.props.scrollDelay,
        this.props.scrollThrottle
      );
    }

    if (this.props.resizeCheck) {
      this.addEventListener(
        window,
        'resize',
        this.props.resizeDelay,
        this.props.resizeThrottle
      );
    }

    // if dont need delayed call, check on load ( before the first interval fires )
    !this.props.delayedCall && this.check();
  },

  stopWatching: function () {
    if (this.debounceCheck) {
      // clean up event listeners and their debounce callers
      for (var debounceEvent in this.debounceCheck) {
        if (this.debounceCheck.hasOwnProperty(debounceEvent)) {
          var debounceInfo = this.debounceCheck[debounceEvent];

          clearTimeout(debounceInfo.getLastTimeout());
          debounceInfo.target.removeEventListener(
            debounceEvent, debounceInfo.fn
          );

          this.debounceCheck[debounceEvent] = null;
        }
      }
    }
    this.debounceCheck = null;

    if (this.interval) { this.interval = clearInterval(this.interval); }
  },

  /**
   * Check if the element is within the visible viewport
   */
  check: function () {
    var el = this.node;
    var rect;
    var containmentRect;
    // if the component has rendered to null, dont update visibility
    if (!el) {
      return this.state;
    }

    rect = el.getBoundingClientRect();

    if (this.props.containment) {
      var containmentDOMRect = this.props.containment.getBoundingClientRect();
      containmentRect = {
        top: containmentDOMRect.top,
        left: containmentDOMRect.left,
        bottom: containmentDOMRect.bottom,
        right: containmentDOMRect.right,
      }
    } else {
      containmentRect = {
        top: 0,
        left: 0,
        bottom: window.innerHeight || document.documentElement.clientHeight,
        right: window.innerWidth || document.documentElement.clientWidth
      };
    }

    // Check if visibility is wanted via offset?
    var offset = this.props.offset || {};
    var hasValidOffset = typeof offset === 'object';
    if (hasValidOffset) {
      containmentRect.top += offset.top || 0;
      containmentRect.left += offset.left || 0;
      containmentRect.bottom -= offset.bottom || 0;
      containmentRect.right -= offset.right || 0;
    }

    var visibilityRect = {
      top: rect.top >= containmentRect.top,
      left: rect.left >= containmentRect.left,
      bottom: rect.bottom <= containmentRect.bottom,
      right: rect.right <= containmentRect.right
    };

    var isVisible = (
      visibilityRect.top &&
      visibilityRect.left &&
      visibilityRect.bottom &&
      visibilityRect.right
    );

    // check for partial visibility
    if (this.props.partialVisibility) {
      var partialVisible =
          rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top &&
          rect.left <= containmentRect.right && rect.right >= containmentRect.left;

      // account for partial visibility on a single edge
      if (typeof this.props.partialVisibility === 'string') {
        partialVisible = visibilityRect[this.props.partialVisibility]
      }

      // if we have minimum top visibility set by props, lets check, if it meets the passed value
      // so if for instance element is at least 200px in viewport, then show it.
      isVisible = this.props.minTopValue
        ? partialVisible && rect.top <= (containmentRect.bottom - this.props.minTopValue)
        : partialVisible
    }

    // Deprecated options for calculating offset.
    if (typeof offset.direction === 'string' &&
        typeof offset.value === 'number') {
      console.warn('[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }', offset.direction, offset.value)

      isVisible = isVisibleWithOffset(offset, rect, containmentRect);
    }

    var state = this.state;
    // notify the parent when the value changes
    if (this.state.isVisible !== isVisible) {
      state = {
        isVisible: isVisible,
        visibilityRect: visibilityRect
      };
      this.setState(state);
      if (this.props.onChange) this.props.onChange(isVisible, visibilityRect);
    }

    return state;
  },

  render: function () {
    if (this.props.children instanceof Function) {
      return this.props.children({
        isVisible: this.state.isVisible,
        visibilityRect: this.state.visibilityRect,
      });
    }
    return React.Children.only(this.props.children);
  }
});


/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;__webpack_require__(1282);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GallerySelect=(_temp=_class=function(_React$PureComponent){_inherits(GallerySelect,_React$PureComponent);function GallerySelect(){_classCallCheck(this,GallerySelect);return _possibleConstructorReturn(this,(GallerySelect.__proto__||Object.getPrototypeOf(GallerySelect)).apply(this,arguments));}_createClass(GallerySelect,[{key:'render',value:function render(){var _this2=this;var _props=this.props,photo=_props.photo,isSelected=_props.isSelected,promotable=_props.promotable;return _react2.default.createElement('div',{className:'component-gallery-select '+(isSelected?'selected':'')},promotable?_react2.default.createElement('div',{className:'promotable'},photo.controls.promote&&photo.controls.promote.visible?_react2.default.createElement('div',{className:'promotable-button promote-button',onClick:function onClick(){return photo.controls.promote.trigger(photo);}},_react2.default.createElement('i',{className:'fa fa-arrow-circle-o-up'})):null,photo.controls.demote&&photo.controls.demote.visible?_react2.default.createElement('div',{className:'promotable-button demote-button',onClick:function onClick(){return photo.controls.demote.trigger(photo);}},_react2.default.createElement('i',{className:'fa fa-arrow-circle-o-down'})):null):null,_react2.default.createElement('div',{className:'select-checkbox',onClick:function onClick(){return _this2.props.onSelect(photo);}},_react2.default.createElement('i',{className:'fa fa-check'})));}}]);return GallerySelect;}(_react2.default.PureComponent),_class.propTypes={photo:_propTypes2.default.object.isRequired,promotable:_propTypes2.default.bool,isSelected:_propTypes2.default.bool.isRequired,onSelect:_propTypes2.default.func.isRequired},_class.defaultProps={promotable:false},_temp);exports.default=GallerySelect;

/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;__webpack_require__(1313);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _Uri=__webpack_require__(17);var _Browser=__webpack_require__(19);var _Spinner=__webpack_require__(52);var _Spinner2=_interopRequireDefault(_Spinner);var _reactRedux=__webpack_require__(13);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Picture=(_dec=(0,_reactRedux.connect)(function(state){return{webp:state.supports.webp};},{}),_dec(_class=(_temp2=_class2=function(_React$Component){_inherits(Picture,_React$Component);function Picture(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Picture);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Picture.__proto__||Object.getPrototypeOf(Picture)).call.apply(_ref,[this].concat(args))),_this),_this.defaultResolution=480,_this.supportedResolutions=[{mediaQueryType:'max',screenWidth:1200,photoWidth:320},{mediaQueryType:'max',screenWidth:1600,photoWidth:480},{mediaQueryType:'min',screenWidth:1920,photoWidth:640}],_this.state={isLoading:true},_this.onLoad=function(){if(_this.props.onPhotoLoad){_this.props.onPhotoLoad();}_this.setState(_extends({},_this.state,{isLoading:false}));},_this.renderByImageUrl=function(){var _this$props=_this.props,url=_this$props.url,alt=_this$props.alt,forceWidth=_this$props.forceWidth,forceHeight=_this$props.forceHeight,maxHeight=_this$props.maxHeight,webp=_this$props.webp;var defaultResolution=_this.props.defaultResolution||_this.defaultResolution;var supportedResolutions=_this.props.supportedResolutions||_this.supportedResolutions;url=maxHeight?(0,_Uri.addParamToQueryString)(url,'dh',maxHeight):url;url=webp?(0,_Uri.addParamToQueryString)(url,'of','webp'):url;var defaultSrc=(0,_Uri.addParamToQueryString)(url,'dw',defaultResolution);var elements=supportedResolutions.map(function(resolution){return _react2.default.createElement('source',{key:resolution.photoWidth,srcSet:(0,_Uri.addParamToQueryString)(url,'dw',resolution.photoWidth),media:'('+resolution.mediaQueryType+'-width: '+resolution.screenWidth+'px)'});});return _react2.default.createElement('picture',null,elements,_react2.default.createElement('img',{itemProp:'image',className:'photo',onLoad:_this.onLoad,srcSet:defaultSrc,src:defaultSrc,alt:alt,width:forceWidth?forceWidth.replace('px',''):null,height:forceHeight?forceHeight.replace('px',''):null}));},_this.renderByResolutions=function(){var _this$props2=_this.props,resolutions=_this$props2.resolutions,alt=_this$props2.alt,forceWidth=_this$props2.forceWidth,forceHeight=_this$props2.forceHeight,fullScreen=_this$props2.fullScreen;var highestResolution=0;var highestResolutionSrc=null;var elements=Object.keys(resolutions).map(function(resolution){var width=parseInt(resolution.split('w')[1]);if(!isNaN(width)&&resolutions[resolution]){if(width>highestResolution){highestResolution=width;highestResolutionSrc=resolutions[resolution];}if(typeof resolutions[resolution]==='string'){return _react2.default.createElement('source',{key:resolution,srcSet:(0,_Uri.forceHttpsUri)(resolutions[resolution]),media:'(max-width: '+width*(fullScreen?1.5:3)+'px)'});}else{return null;}}});var altText=typeof alt==='undefined'?alt:'';var defaultSrc=(0,_Uri.forceHttpsUri)(highestResolutionSrc);return _react2.default.createElement('picture',null,elements,_react2.default.createElement('img',{itemProp:'image',className:'photo',onLoad:_this.onLoad,srcSet:defaultSrc,src:defaultSrc,alt:alt,width:forceWidth?forceWidth.replace('px',''):null,height:forceHeight?forceHeight.replace('px',''):null}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Picture,[{key:'render',value:function render(){var isLoading=this.state.isLoading;if(!this.props.resolutions&&!this.props.url){return null;}var picture=null;if(this.props.url){picture=this.renderByImageUrl();}else if(this.props.resolutions){picture=this.renderByResolutions();}else{picture=null;}return _react2.default.createElement('div',{className:'component-picture'},isLoading&&_react2.default.createElement(_Spinner2.default,null),picture);}}]);return Picture;}(_react2.default.Component),_class2.propTypes={webp:_propTypes2.default.bool.isRequired,fullScreen:_propTypes2.default.bool,url:_propTypes2.default.string,resolutions:_propTypes2.default.object,alt:_propTypes2.default.string,forceWidth:_propTypes2.default.string,forceHeight:_propTypes2.default.string,onPhotoLoad:_propTypes2.default.func,defaultResolution:_propTypes2.default.number,maxHeight:_propTypes2.default.number,supportedResolutions:_propTypes2.default.arrayOf(_propTypes2.default.shape({mediaQueryType:_propTypes2.default.oneOf(['max','min']).isRequired,screenWidth:_propTypes2.default.number.isRequired,photoWidth:_propTypes2.default.number.isRequired}))},_class2.defaultProps={fullScreen:false,alt:''},_temp2))||_class);exports.default=Picture;

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

// Tell whether the rect is visible, given an offset
//
// return: boolean
module.exports = function (offset, rect, containmentRect) {
  var offsetDir = offset.direction;
  var offsetVal = offset.value;

  // Rules for checking different kind of offsets. In example if the element is
  // 90px below viewport and offsetTop is 100, it is considered visible.
  switch (offsetDir) {
  case 'top':
    return ((containmentRect.top + offsetVal) < rect.top) &&
      (containmentRect.bottom > rect.bottom) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.right > rect.right);

  case 'left':
    return ((containmentRect.left + offsetVal) < rect.left) &&
      (containmentRect.bottom > rect.bottom) &&
      (containmentRect.top < rect.top) &&
      (containmentRect.right > rect.right);

  case 'bottom':
    return ((containmentRect.bottom - offsetVal) > rect.bottom) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.right > rect.right) &&
      (containmentRect.top < rect.top);

  case 'right':
    return ((containmentRect.right - offsetVal) > rect.right) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.top < rect.top) &&
      (containmentRect.bottom > rect.bottom);
  }
}


/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;__webpack_require__(1308);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactTippy=__webpack_require__(1245);var _reactRedux=__webpack_require__(13);var _Button=__webpack_require__(28);var _Button2=_interopRequireDefault(_Button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryControlsV2=(_dec=(0,_reactRedux.connect)(function(state){return{purchasePhotosPolicy:state.user.currentPolicies.purchasePhotos};},{}),_dec(_class=(_temp2=_class2=function(_React$Component){_inherits(GalleryControlsV2,_React$Component);function GalleryControlsV2(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryControlsV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryControlsV2.__proto__||Object.getPrototypeOf(GalleryControlsV2)).call.apply(_ref,[this].concat(args))),_this),_this.presets={curate:{className:'curate-btn',icon:'fa-info-circle',tip:'Curate',href:"http://api.foap.com/admin"+'/curated_photos/new?photo_id='+_this.props.photo.id,target:'_blank'},openInNewTab:{className:'openInNewCart-btn',icon:'fa-external-link',tip:'Open in new tab'},buy:{className:'openInNewCart-btn',icon:'fa-shopping-cart',tip:'Buy'},zoom:{className:'zoom-btn',icon:'fa-search-plus',tip:'Zoom'},addToCart:{className:'add-to-cart-btn',icon:'fa-shopping-cart',tip:'Add to cart'},addToLightbox:{className:'add-to-lightbox-btn',icon:'fa-lightbulb-o',tip:'Add to lightbox'},removeFromLightbox:{className:'remove-from-lightbox-btn',icon:'fa-times',tip:'Remove from lightbox'},star:{className:'star-btn',icon:'fa-star-o',tip:'Star'},unstar:{className:'unstar-btn',icon:'fa-star',tip:'Unstar'},addToCollection:{className:'add-to-collection-btn',icon:'fa-plus-square',tip:'Add to Collection'},removeFromCollection:{className:'remove-from-collection-btn',icon:'fa-minus-square',tip:'Remove from Collection'},download:{className:'download-btn',icon:'fa-download',tip:'Download'},downloadPreview:{className:'download-preview-btn',icon:'fa-level-down',tip:'Download preview'},reject:{className:'reject-btn',icon:'fa-minus-circle',tip:'Reject'},unreject:{className:'unreject-btn',icon:'fa-plus-circle',tip:'Unreject'},promote:{className:'promote-btn',icon:'fa-arrow-circle-up',tip:'Promote'},demote:{className:'demote-btn',icon:'fa-arrow-circle-down',tip:'Demote'},upload:{className:'upload-btn',icon:'fa-upload',tip:'Upload file'},delete:{className:'delete-btn',icon:'fa-times',tip:'Delete photo'},reward:{className:'reward-btn',icon:'fa-gift',tip:'Reward photo'}},_this.shouldComponentUpdate=function(nextProps,nextState){return!(JSON.stringify(_this.props.photo)===JSON.stringify(nextProps.photo));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryControlsV2,[{key:'render',value:function render(){var _this2=this;var _props=this.props,photo=_props.photo,purchasePhotosPolicy=_props.purchasePhotosPolicy;var controls=photo.controls;var buttons=Object.keys(controls).map(function(control){//Skip excluded buttons
if(_this2.props.exclude.includes(control)){return null;}//Dont render add to cart button if policy is blocked
if(control==='addToCart'&&!purchasePhotosPolicy){return null;}var controlConfig=controls[control];if(_this2.presets.hasOwnProperty(control)&&(controlConfig.visible||_this2.props.mode==='preview'&&controlConfig.visibleOnPreview)){var trigger=void 0,href=void 0;var preset=_this2.presets[control];//Set default props
var props={element:"button",styleType:"dark",className:'control-btn '+preset.className,'data-tip':preset.tip,size:"s"};//Set onClick trigger
if(controlConfig.hasOwnProperty('trigger')){props.onClick=function(){return controlConfig.trigger(photo);};}else if(preset.hasOwnProperty('trigger')){props.onClick=function(){return preset.trigger(photo);};}//Set href
if(controlConfig.hasOwnProperty('href')&&controlConfig.href){props.element='anchor';props.href=controlConfig.href;props.target=controlConfig.target||'_blank';}else if(preset.hasOwnProperty('href')){props.element='anchor';props.href=preset.href;props.target=preset.target||'_blank';}//Set disabled state
if(controlConfig.hasOwnProperty('disabled')&&controlConfig.disabled){props.className+=' btn-disabled';props.onClick=null;props.href=null;}return _react2.default.createElement(_reactTippy.Tooltip,{key:control,title:preset.tip},_react2.default.createElement(_Button2.default,props,_react2.default.createElement('i',{className:'fa '+preset.icon})));}else{return null;}});return _react2.default.createElement('div',{className:'component-gallery-controls'},buttons);}}]);return GalleryControlsV2;}(_react2.default.Component),_class2.propTypes={purchasePhotosPolicy:_propTypes2.default.bool.isRequired,mode:_propTypes2.default.oneOf(['default','preview']),exclude:_propTypes2.default.arrayOf(_propTypes2.default.string),photo:_propTypes2.default.shape({id:_propTypes2.default.string.isRequired,downloadUrl:_propTypes2.default.string,imageCompUrl:_propTypes2.default.string,controls:_propTypes2.default.shape({curate:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),openInNewTab:_propTypes2.default.shape({visible:_propTypes2.default.bool,href:_propTypes2.default.string}),open:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),buy:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),addToCart:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),addToLightbox:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),removeFromLightbox:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),star:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),unstar:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),addToCollection:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),removeFromCollection:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),reject:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),unreject:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),promote:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func}),demote:_propTypes2.default.shape({visible:_propTypes2.default.bool,trigger:_propTypes2.default.func})})}).isRequired},_class2.defaultProps={exclude:[],mode:'default'},_temp2))||_class);exports.default=GalleryControlsV2;

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1250);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component) {
      _inherits(LazyLoadDecorated, _Component);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            _index2.default,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!node) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;__webpack_require__(1309);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRouter=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryLink=(_temp2=_class=function(_React$Component){_inherits(GalleryLink,_React$Component);function GalleryLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryLink.__proto__||Object.getPrototypeOf(GalleryLink)).call.apply(_ref,[this].concat(args))),_this),_this.shouldComponentUpdate=function(nextProps,nextState){return _this.props.href!==nextProps.href||_this.props.onEnter!==nextProps.onEnterPhoto||_this.props.onEnterAsync!==nextProps.onEnterPhotoAsync;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryLink,[{key:'render',value:function render(){if(this.props.onEnter){return _react2.default.createElement(_reactRouter.Link,{className:'component-gallery-link',onClick:this.props.onEnter},this.props.children);}else if(this.props.onEnterAsync){return _react2.default.createElement(_reactRouter.Link,{className:'component-gallery-link',to:this.props.href,onClick:this.props.onEnterAsync},this.props.children);}else{return _react2.default.createElement(_reactRouter.Link,{className:'component-gallery-link',to:this.props.href},this.props.children);}}}]);return GalleryLink;}(_react2.default.Component),_class.propTypes={href:_propTypes2.default.string,onEnter:_propTypes2.default.func,onEnterAsync:_propTypes2.default.func,children:_propTypes2.default.any},_class.defaultProps={href:''},_temp2);exports.default=GalleryLink;

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;__webpack_require__(1310);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRouter=__webpack_require__(3);var _StatusIcon=__webpack_require__(1256);var _StatusIcon2=_interopRequireDefault(_StatusIcon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryOverlay=(_temp2=_class=function(_React$Component){_inherits(GalleryOverlay,_React$Component);function GalleryOverlay(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryOverlay);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryOverlay.__proto__||Object.getPrototypeOf(GalleryOverlay)).call.apply(_ref,[this].concat(args))),_this),_this.mapStatusToState={REJECTED:'error',REQUIRED:'warning',UPLOADED:'warning',SENT_TO_VERIFICATION:'success'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryOverlay,[{key:'render',value:function render(){var photo=this.props.photo;switch(this.props.type){case'default':return _react2.default.createElement('div',{className:'component-gallery-photo-overlay'},_react2.default.createElement('h3',{className:'photo-overlay-caption'},photo.selectedCaption));case'modelRelease':return _react2.default.createElement('div',{className:'component-gallery-photo-overlay model-release'},_react2.default.createElement('h3',{className:'photo-overlay-top-caption'},_react2.default.createElement(_StatusIcon2.default,{photo:photo,state:photo.modelReleases.status&&this.mapStatusToState.hasOwnProperty(photo.modelReleases.status)?this.mapStatusToState[photo.modelReleases.status]:'error'})),_react2.default.createElement('h3',{className:'photo-overlay-bottom-caption'},_react2.default.createElement('span',{className:'mission-info'},photo.mission?photo.mission.name:''),_react2.default.createElement('span',{className:'file-info'},photo.modelReleases.edges.length?photo.modelReleases.edges.length+' file'+(photo.modelReleases.edges.length!==1?'s':'')+' attached':'No files attached')));case'static':return _react2.default.createElement('div',{className:'component-gallery-photo-overlay static'},_react2.default.createElement('h3',{className:'photo-overlay-caption'},photo.selectedCaption));case'userAlbum':return _react2.default.createElement('div',{className:'component-gallery-photo-overlay user'},_react2.default.createElement('h3',{className:'photo-overlay-caption'},photo.selectedCaption));case'user':return _react2.default.createElement('div',{className:'component-gallery-photo-overlay user'},_react2.default.createElement('div',{className:'photo-overlay-user'},_react2.default.createElement('div',{className:'avatar'},_react2.default.createElement('img',{alt:photo.user.username,src:photo.user.avatar.w120})),_react2.default.createElement('p',{className:'username'},photo.user.username)));case'userBasic':return _react2.default.createElement('div',{className:'component-gallery-photo-overlay user-basic'},_react2.default.createElement('div',{className:'photo-overlay-user-basic'},_react2.default.createElement('p',{className:'username'},photo.user.username)));case'meta':return _react2.default.createElement('div',{className:'component-gallery-photo-overlay metadata'},_react2.default.createElement('div',{className:'photo-overlay-content'},_react2.default.createElement('p',{className:'photo-overlay-metadata'},'curatedCaption: ',_react2.default.createElement('strong',null,photo.curatedCaption)),_react2.default.createElement('p',{className:'photo-overlay-metadata'},'curatedTags: ',_react2.default.createElement('strong',null,photo.curatedTagLinks?photo.curatedTagLinks.map(function(tagLink){return tagLink.name;}).join(', '):'')),_react2.default.createElement('hr',null),_react2.default.createElement('p',{className:'photo-overlay-metadata'},'caption: ',_react2.default.createElement('strong',null,photo.caption)),_react2.default.createElement('p',{className:'photo-overlay-metadata'},'tags: ',_react2.default.createElement('strong',null,photo.tagLinks?photo.tagLinks.map(function(tagLink){return tagLink.name;}).join(', '):'')),_react2.default.createElement('hr',null),_react2.default.createElement('p',{className:'photo-overlay-metadata'},'suggestedCaption: ',_react2.default.createElement('strong',null,photo.suggestedCaption)),_react2.default.createElement('p',{className:'photo-overlay-metadata'},'suggestedTags: ',_react2.default.createElement('strong',null,photo.suggestedTagLinks?photo.suggestedTagLinks.map(function(tagLink){return tagLink.name;}).join(', '):'')),_react2.default.createElement('hr',null),_react2.default.createElement('p',{className:'photo-overlay-metadata'},'ratingsCount: ',_react2.default.createElement('strong',null,photo.ratingsCount)),_react2.default.createElement('p',{className:'photo-overlay-metadata'},'averageRating: ',_react2.default.createElement('strong',null,photo.averageRating))));default:return _react2.default.createElement('div',{className:'component-gallery-photo-overlay'});}}}]);return GalleryOverlay;}(_react2.default.Component),_class.propTypes={type:_propTypes2.default.oneOf(['','default','modelRelease','meta','static','user','userBasic']),photo:_propTypes2.default.shape({caption:_propTypes2.default.string,curatedCaption:_propTypes2.default.string,suggestedCaption:_propTypes2.default.string,selectedCaption:_propTypes2.default.string,tagLinks:_propTypes2.default.arrayOf(_propTypes2.default.shape({name:_propTypes2.default.string})),curatedTagLinks:_propTypes2.default.arrayOf(_propTypes2.default.shape({name:_propTypes2.default.string})),suggestedTagLinks:_propTypes2.default.arrayOf(_propTypes2.default.shape({name:_propTypes2.default.string})),user:_propTypes2.default.shape({username:_propTypes2.default.string})})},_class.defaultProps={type:''},_temp2);exports.default=GalleryOverlay;

/***/ }),

/***/ 1304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;__webpack_require__(1311);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRouter=__webpack_require__(3);var _StatusIcon=__webpack_require__(1256);var _StatusIcon2=_interopRequireDefault(_StatusIcon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryOverlayV2=(_temp=_class=function(_React$Component){_inherits(GalleryOverlayV2,_React$Component);function GalleryOverlayV2(){_classCallCheck(this,GalleryOverlayV2);return _possibleConstructorReturn(this,(GalleryOverlayV2.__proto__||Object.getPrototypeOf(GalleryOverlayV2)).apply(this,arguments));}_createClass(GalleryOverlayV2,[{key:'render',value:function render(){var _props=this.props,type=_props.type,contentArray=_props.contentArray;return _react2.default.createElement('div',{className:'component-gallery-photo-overlay-v2'},_react2.default.createElement('div',{className:'overlay-elements'},contentArray.map(function(contentElem){return _react2.default.createElement('p',{key:contentElem.label+contentElem.value,className:'overlay-element'},contentElem.label?_react2.default.createElement('span',{className:'label'},contentElem.label,': '):null,_react2.default.createElement('span',{className:'value'},contentElem.value));})));}}]);return GalleryOverlayV2;}(_react2.default.Component),_class.propTypes={type:_propTypes2.default.oneOf(['default']),contentArray:_propTypes2.default.arrayOf(_propTypes2.default.shape({label:_propTypes2.default.string,value:_propTypes2.default.string.isRequired}))},_class.defaultProps={type:'default',contentArray:[]},_temp);exports.default=GalleryOverlayV2;

/***/ }),

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;__webpack_require__(1312);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactTippy=__webpack_require__(1245);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryPromote=(_temp2=_class=function(_React$Component){_inherits(GalleryPromote,_React$Component);function GalleryPromote(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryPromote);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryPromote.__proto__||Object.getPrototypeOf(GalleryPromote)).call.apply(_ref,[this].concat(args))),_this),_this.getButton=function(config){return _react2.default.createElement(_reactTippy.Tooltip,{key:_this.props.photo.id+'-'+config.className,title:config.tip,position:'right'},_react2.default.createElement('div',{className:'promotable-button '+config.className,onClick:function onClick(){return config.trigger?config.trigger(_this.props.photo):function(){return true;};}},_react2.default.createElement('i',{className:'fa '+config.icon})));},_this.mapStateToButtons=function(){var promotable=_this.props.photo.promotable;var output=[];switch(promotable.state){case'promoted':output.push(_this.getButton({className:'demote selected',icon:'fa-arrow-circle-up',tip:'Demote',trigger:promotable.controls&&promotable.controls.demote&&promotable.controls.demote.trigger}),_this.getButton({className:'reject',icon:'fa-minus-circle',tip:'Reject',trigger:promotable.controls&&promotable.controls.reject&&promotable.controls.reject.trigger}));break;case'rejected':output.push(_this.getButton({className:'promote',icon:'fa-arrow-circle-up',tip:'Reject',trigger:promotable.controls&&promotable.controls.promote&&promotable.controls.promote.trigger}),_this.getButton({className:'unreject selected',icon:'fa-minus-circle',tip:'Unreject',trigger:promotable.controls&&promotable.controls.unreject&&promotable.controls.unreject.trigger}));break;default:output.push(_this.getButton({className:'promote',icon:'fa-arrow-circle-up',tip:'Promote',trigger:promotable.controls&&promotable.controls.promote&&promotable.controls.promote.trigger}),_this.getButton({className:'reject',icon:'fa-minus-circle',tip:'Reject',trigger:promotable.controls&&promotable.controls.reject&&promotable.controls.reject.trigger}));}return output;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryPromote,[{key:'render',value:function render(){var inSelectMode=this.props.inSelectMode;var promotable=this.props.photo.promotable;var buttons=this.mapStateToButtons();if(!buttons.length){return null;}return _react2.default.createElement('div',{className:'component-gallery-promote '+(promotable.state||'')+' '+(promotable.state?'selected':'')+' '+(inSelectMode?'select-mode':'')},buttons);}}]);return GalleryPromote;}(_react2.default.Component),_class.propTypes={inSelectMode:_propTypes2.default.bool.isRequired,photo:_propTypes2.default.shape({id:_propTypes2.default.string.isRequired,promotable:_propTypes2.default.shape({state:_propTypes2.default.oneOf([null,'promoted','rejected']),controls:_propTypes2.default.shape({reject:_propTypes2.default.shape({trigger:_propTypes2.default.func}),unreject:_propTypes2.default.shape({trigger:_propTypes2.default.func}),promote:_propTypes2.default.shape({trigger:_propTypes2.default.func}),demote:_propTypes2.default.shape({trigger:_propTypes2.default.func})})}).isRequired}).isRequired},_class.defaultProps={},_temp2);exports.default=GalleryPromote;

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _Browser=__webpack_require__(19);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LazyLoadContainer=(_temp=_class=function(_React$PureComponent){_inherits(LazyLoadContainer,_React$PureComponent);function LazyLoadContainer(props){_classCallCheck(this,LazyLoadContainer);var _this=_possibleConstructorReturn(this,(LazyLoadContainer.__proto__||Object.getPrototypeOf(LazyLoadContainer)).call(this,props));_this._isMounted=false;_this.lazyLoadPreloadStateInterval=null;_this.userScrollTimeout=null;_this.componentDidMount=function(){_this._isMounted=true;window.addEventListener('scroll',_this.resetLazyLoadOffset);_this.resetLazyLoadOffset();};_this.componentWillUnmount=function(){_this._isMounted=false;window.removeEventListener('scroll',_this.resetLazyLoadOffset);};_this.componentWillReceiveProps=function(nextProps){_this.setState(_extends({},_this.state,{allImagesLoaded:false}),_this.resetLazyLoadOffset);};_this.resetLazyLoadOffset=function(){if(!(0,_Browser.isBrowser)()){return false;}//Break if wrapper isnt set
if(!_this.refs.wrapper){return false;}//Break if all images has been loaded
if(_this.state.allImagesLoaded){return false;}_this.setState(_extends({},_this.state,{offset:_this.props.baseOffset}),function(){clearTimeout(_this.userScrollTimeout);_this.userScrollTimeout=setTimeout(function(){_this.preloadLazyLoadImages();},500);});};_this.preloadLazyLoadImages=function(){var wrapper=_this.refs.wrapper;clearInterval(_this.lazyLoadPreloadStateInterval);_this.lazyLoadPreloadStateInterval=setInterval(function(){if(!_this._isMounted){clearInterval(_this.lazyLoadPreloadStateInterval);return false;}//Check if some photos are still not loaded
var allImagesReady=true;Array.prototype.forEach.call(wrapper.getElementsByTagName('img'),function(img){//Check if image is visible and has been loaded 
if(!img.complete&&img.offsetParent!==null){allImagesReady=false;}});if(allImagesReady){//Count only visible placeholders
var lazyLoadPlaceholdersCount=0;Array.prototype.forEach.call(wrapper.getElementsByClassName('lazyload-placeholder'),function(placeholder){lazyLoadPlaceholdersCount=placeholder.offsetParent!==null?lazyLoadPlaceholdersCount+1:lazyLoadPlaceholdersCount;});if(lazyLoadPlaceholdersCount&&_this.state.offset<(0,_Browser.getWindowTotalHeight)()){var newOffset=_this.state.offset+_this.props.baseOffset;_this.props.onOffsetChange(newOffset);_this.setState(_extends({},_this.state,{offset:newOffset}));}else{clearInterval(_this.lazyLoadPreloadStateInterval);_this.setState(_extends({},_this.state,{allImagesLoaded:true}));}}},250);};_this.state={offset:100,allImagesLoaded:false};return _this;}_createClass(LazyLoadContainer,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'component-lazy-load-container',ref:'wrapper'},this.props.children);}}]);return LazyLoadContainer;}(_react2.default.PureComponent),_class.propTypes={children:_propTypes2.default.any,onOffsetChange:_propTypes2.default.func.isRequired,baseOffset:_propTypes2.default.number.isRequired},_class.defaultProps={baseOffset:200},_temp);exports.default=LazyLoadContainer;

/***/ }),

/***/ 1307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1308:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);__webpack_require__(1713);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tab=(_temp=_class=function(_Component){_inherits(Tab,_Component);function Tab(){_classCallCheck(this,Tab);return _possibleConstructorReturn(this,(Tab.__proto__||Object.getPrototypeOf(Tab)).apply(this,arguments));}_createClass(Tab,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'component-tab'},this.props.children);}}]);return Tab;}(_react.Component),_class.propTypes={children:_propTypes2.default.any},_class.defaultProps={},_temp);exports.default=Tab;

/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactLazyload=__webpack_require__(1250);__webpack_require__(1714);var _Uri=__webpack_require__(17);var _Tab=__webpack_require__(1548);var _Tab2=_interopRequireDefault(_Tab);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tabs=(_temp=_class=function(_Component){_inherits(Tabs,_Component);function Tabs(props){_classCallCheck(this,Tabs);var _this=_possibleConstructorReturn(this,(Tabs.__proto__||Object.getPrototypeOf(Tabs)).call(this,props));_initialiseProps.call(_this);_this.state={tabs:_this.getTabs(props)};return _this;}_createClass(Tabs,[{key:'render',value:function render(){var _this2=this;var tabs=this.state.tabs;return _react2.default.createElement('div',{className:'component-tabs'},_react2.default.createElement('header',{className:'tabs-header custom-scrollbar hidden align-titles-'+this.props.alignTitles},tabs.map(function(tab){return tab.hidden?null:_react2.default.createElement('a',{key:tab.index,className:'tab-trigger  '+(tab.active?'active':''),onClick:function onClick(){return _this2.switchTab(tab);}},_react2.default.createElement('h6',{className:'tab-title'},tab.title));}),_react2.default.createElement('div',{className:'border'})),_react2.default.createElement('div',{className:'tabs-wrapper'},tabs.map(function(tab){return _react2.default.createElement('div',{key:tab.index,className:'tab-wrapper '+(tab.active?'active':'')},tab.element);})));}}]);return Tabs;}(_react.Component),_class.propTypes={children:_propTypes2.default.any,alignTitles:_propTypes2.default.oneOf(['left','center','right'])},_class.defaultProps={alignTitles:'center'},_initialiseProps=function _initialiseProps(){var _this3=this;this.getTabs=function(props){var forceActive=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var tabs=[];_react2.default.Children.map(props.children,function(child,index){var active=false;if(forceActive){if(forceActive===index){active=true;}}else{active=typeof child.props.active!=='undefined'&&child.props.active;}tabs.push({index:index,title:child.props.title,to:child.props.to,active:active,hidden:!(typeof child.props.hidden==='undefined'||!child.props.hidden),element:child});});return tabs;};this.componentDidMount=function(){_this3.setState(_extends({},_this3.state,{tabs:_this3.getTabs(_this3.props)}));};this.componentWillReceiveProps=function(props){_this3.setState(_extends({},_this3.state,{tabs:_this3.getTabs(props)}));};this.switchTab=function(tab){//Hack to lazy load photos on tab change
(0,_reactLazyload.forceCheck)();if(tab.to){(0,_Uri.redirect)(tab.to);}else{_this3.setState(_extends({},_this3.state,{tabs:_this3.getTabs(_this3.props,tab.index)}));}};},_temp);exports.default=Tabs;

/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default="\n    fragment creditPackageBasics on CreditPackage { \n        id\n        price\n        credits\n        name\n        worthPhotos\n        discountPercentage\n    }\n";

/***/ }),

/***/ 1653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default="\n    query %name% {\n        creditPackages: creditPackages {\n            %fields%\n        }\n    }\n    %fragments%\n";

/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchCreditPackages=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _creditPackages=__webpack_require__(415);var types=_interopRequireWildcard(_creditPackages);var _yup=__webpack_require__(54);var _yup2=_interopRequireDefault(_yup);var _Graphql=__webpack_require__(53);var _creditPackages2=__webpack_require__(1653);var _creditPackages3=_interopRequireDefault(_creditPackages2);var _creditPackage=__webpack_require__(1641);var _creditPackage2=_interopRequireDefault(_creditPackage);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}var fetchCreditPackages=exports.fetchCreditPackages=function fetchCreditPackages(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var req=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch){params=_extends({},params);return(0,_Graphql.requestOptions)({req:req,type:types.FETCH_CREDITS_PACKAGES,onRetry:fetchCreditPackages,name:'creditPackages',validationSchema:_yup2.default.object().shape({data:_yup2.default.object().shape({creditPackages:_yup2.default.array().of(_yup2.default.object().shape({id:_yup2.default.string().required(),credits:_yup2.default.number().integer().required(),discountPercentage:_yup2.default.number().integer().required(),name:_yup2.default.string().required(),price:_yup2.default.number().integer().required(),worthPhotos:_yup2.default.number().integer().required()}).required()).ensure()}).required()}),params:params,requestParams:{},query:_creditPackages3.default.replace('%name%','creditPackages').replace('%fields%','\n                ...creditPackageBasics\n            ').replace('%fragments%','\n                '+_creditPackage2.default+'\n            ')});};};

/***/ }),

/***/ 1713:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1714:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2726:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3162:
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "8f36d23c-5056-43df-9711-751903aaa43a",
		"albumId": "8f36d23c-5056-43df-9711-751903aaa43a",
		"slug": "farming-in-the-world",
		"caption": "Farming in the world",
		"alt": "Norwegian cottage",
		"username": "cabday",
		"width": 1920,
		"height": 1280,
		"imageUrl": "https://images01.foap.com/images/966e9af7-b64b-43bf-a0e6-312b858e49f5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Farming in the world"
	},
	{
		"id": "c3124ef4-23e5-4320-a617-bbe296ce185d",
		"albumId": "c3124ef4-23e5-4320-a617-bbe296ce185d",
		"slug": "food-market",
		"caption": "Food market",
		"alt": "Halfs",
		"username": "cabday",
		"width": 1920,
		"height": 1280,
		"imageUrl": "https://images02.foap.com/images/2d684a32-7ee3-4a95-84e6-713a870ba63b/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Food market"
	},
	{
		"id": "21c631b3-e282-4168-ac78-42d52050bff3",
		"albumId": "21c631b3-e282-4168-ac78-42d52050bff3",
		"slug": "good-eats",
		"caption": "Good Eats",
		"alt": "Food for a diet: grilled fish. White plate with grilled mackerel, rocket salad and boiled rice over white background. Dish for dieting. Healthy food.",
		"username": "catherine.douma",
		"width": 2592,
		"height": 3888,
		"imageUrl": "https://images01.foap.com/images/a3e14318-adf8-4bcc-b925-a00e8a86860c/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Good Eats"
	},
	{
		"id": "4f04e6f3-bd14-4f4d-b0df-3613a78f7c07",
		"albumId": "4f04e6f3-bd14-4f4d-b0df-3613a78f7c07",
		"slug": "perfectly-arranged-breakfast-photos",
		"caption": "Perfectly arranged breakfast photos",
		"alt": null,
		"username": "akilles",
		"width": 4528,
		"height": 2548,
		"imageUrl": "https://images01.foap.com/images/10b8cc37-f5a3-4ed9-a885-46b865e1bdf5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Perfectly arranged breakfast photos"
	},
	{
		"id": "5213f477-b1cc-436c-aa72-88f62c941e32",
		"albumId": "5213f477-b1cc-436c-aa72-88f62c941e32",
		"slug": "beautiful-lisbon-lisboa",
		"caption": "Beautiful Lisbon / Lisboa",
		"alt": "Christ the king statue in lisbon ",
		"username": "julieweiss10",
		"width": 3644,
		"height": 5460,
		"imageUrl": "https://images01.foap.com/images/ec9ae1fa54c94f5a80c5985b12c3a49d/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Beautiful Lisbon / Lisboa"
	},
	{
		"id": "13a7190c-a528-438d-abbc-66fc34f1efbe",
		"albumId": "13a7190c-a528-438d-abbc-66fc34f1efbe",
		"slug": "beautiful-scotland",
		"caption": "Beautiful Scotland ",
		"alt": "Highland Country fence ",
		"username": "julieweiss10",
		"width": 5464,
		"height": 3624,
		"imageUrl": "https://images01.foap.com/images/c69342ea-9236-45e3-b370-acc48c613b33/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Beautiful Scotland "
	},
	{
		"id": "be3020c4-ecb5-4d43-94b4-d45e4fae6994",
		"albumId": "be3020c4-ecb5-4d43-94b4-d45e4fae6994",
		"slug": "beautiful-prague-praha",
		"caption": "Beautiful Prague / Praha",
		"alt": "Metal dog statue",
		"username": "julieweiss10",
		"width": 3648,
		"height": 5472,
		"imageUrl": "https://images03.foap.com/images/a3ecc62ed7f64d3f9cbf970ea3fd718e/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Beautiful Prague / Praha"
	},
	{
		"id": "487a2581-b89d-4358-a7f4-554645c51302",
		"albumId": "487a2581-b89d-4358-a7f4-554645c51302",
		"slug": "summer-vacations",
		"caption": "Summer & Vacations",
		"alt": "Little girl",
		"username": "przemekklos",
		"width": 2048,
		"height": 2048,
		"imageUrl": "https://images01.foap.com/images/01d77fd32d954c01b72a27f03b569024/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Summer & Vacations"
	},
	{
		"id": "54ae83b1-d2e6-4c65-bcd9-01248504d08c",
		"albumId": "54ae83b1-d2e6-4c65-bcd9-01248504d08c",
		"slug": "nature",
		"caption": "Nature",
		"alt": "Lush greenery on a river",
		"username": "przemekklos",
		"width": 3264,
		"height": 2448,
		"imageUrl": "https://images03.foap.com/images/d550ce960b214a808c3299f970191a80/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Nature"
	},
	{
		"id": "e0573704-747d-4bc5-94aa-9636172ff496",
		"albumId": "e0573704-747d-4bc5-94aa-9636172ff496",
		"slug": "food-drinks",
		"caption": "Food & Drinks",
		"alt": "Dried tomatoes. Dried tomatoes on baking parchment paper",
		"username": "przemekklos",
		"width": 3648,
		"height": 5472,
		"imageUrl": "https://images03.foap.com/images/166ed1cf-d062-4a7d-b90d-e76bf499e1c4/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Food & Drinks"
	},
	{
		"id": "ce547271-53d9-4393-935a-b84c88bcfb98",
		"albumId": "ce547271-53d9-4393-935a-b84c88bcfb98",
		"slug": "christmas",
		"caption": "Christmas",
		"alt": "Girl decorating baked Christmas gingerbread cookies with frosting writing pen",
		"username": "przemekklos",
		"width": 3648,
		"height": 5472,
		"imageUrl": "https://images01.foap.com/images/616d06a6-46f5-4655-a40b-c75ead796142/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Christmas"
	},
	{
		"id": "159e6bc8-78e9-47dd-a13f-8a1c080ec5f4",
		"albumId": "159e6bc8-78e9-47dd-a13f-8a1c080ec5f4",
		"slug": "pacific-northwest",
		"caption": "Pacific Northwest",
		"alt": "Fog",
		"username": "mbocast",
		"width": 2304,
		"height": 1536,
		"imageUrl": "https://images01.foap.com/images/2c823131-18e2-4c00-835e-13886d2661b5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Pacific Northwest"
	},
	{
		"id": "8fba80d3-7102-42bd-893a-fcac0e2104c2",
		"albumId": "8fba80d3-7102-42bd-893a-fcac0e2104c2",
		"slug": "underwater-world",
		"caption": "Underwater world",
		"alt": "cebu silhouette diving underwater by paulcowell",
		"username": "paulcowell",
		"width": 2304,
		"height": 1536,
		"imageUrl": "https://images01.foap.com/images/bdbd7a8e63da4a4299e776fc45be2489/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Underwater world"
	},
	{
		"id": "e7d91e55-ce91-4a24-8624-bb7626f8bd86",
		"albumId": "e7d91e55-ce91-4a24-8624-bb7626f8bd86",
		"slug": "fireworks",
		"caption": "Fireworks",
		"alt": "Color fest",
		"username": "laf",
		"width": 2048,
		"height": 1536,
		"imageUrl": "https://images03.foap.com/images/e70d08f00bc74a6e8623ca6bba1e80a7/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Fireworks"
	},
	{
		"id": "ebad50b0-e431-4529-8423-c9500202549f",
		"albumId": "ebad50b0-e431-4529-8423-c9500202549f",
		"slug": "typical-swedish",
		"caption": "Typical Swedish",
		"alt": "Bun",
		"username": "somliga2",
		"width": 3300,
		"height": 2200,
		"imageUrl": "https://images02.foap.com/images/c9ab91bc4b0a456d83d6899e3c86995a/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Typical Swedish"
	},
	{
		"id": "89ad4340-0b95-4a0d-821c-0384cf056f5a",
		"albumId": "89ad4340-0b95-4a0d-821c-0384cf056f5a",
		"slug": "bucket-list-destinations",
		"caption": "Bucket List Destinations",
		"alt": "Rocky coast",
		"username": "pieces.of.my.life",
		"width": 3024,
		"height": 4032,
		"imageUrl": "https://images01.foap.com/images/7ba652a7-d8f0-4c86-b914-82020daca7af/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Bucket List Destinations"
	},
	{
		"id": "66b3636d-d064-47ba-940c-37f5119596c1",
		"albumId": "66b3636d-d064-47ba-940c-37f5119596c1",
		"slug": "traditional-christmas",
		"caption": "Traditional Christmas ",
		"alt": "Winter ",
		"username": "upyanose",
		"width": 2048,
		"height": 1536,
		"imageUrl": "https://images01.foap.com/images/47b8750e-669e-4f8c-be55-75a134378af9/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Traditional Christmas "
	},
	{
		"id": "fdb29790-fa17-4f22-b389-c68d172195a8",
		"albumId": "fdb29790-fa17-4f22-b389-c68d172195a8",
		"slug": "light-trees",
		"caption": "Light & trees",
		"alt": "Fall in Innsbruck. Taken on my backpacking trip across Europe in Innsbruck, Austria. ",
		"username": "greendub",
		"width": 2448,
		"height": 3264,
		"imageUrl": "https://images01.foap.com/images/7ca1df68-089c-4941-ac0a-3b31ceddf0a1/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Light & trees"
	},
	{
		"id": "4f21ea29-dcd8-431e-b3f4-1d225eab18fb",
		"albumId": "4f21ea29-dcd8-431e-b3f4-1d225eab18fb",
		"slug": "bangkok",
		"caption": "Bangkok",
		"alt": "food boats bangkok thailand by paulcowell",
		"username": "lironialessandro",
		"width": 1536,
		"height": 2304,
		"imageUrl": "https://images01.foap.com/images/f0af402c475d4e3b8650f3e8c05301c9/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Bangkok"
	},
	{
		"id": "81ea9efc-808b-416a-af4c-b4ca98881d21",
		"albumId": "81ea9efc-808b-416a-af4c-b4ca98881d21",
		"slug": "birds",
		"caption": "Birds",
		"alt": "Cedar waxwing",
		"username": "jlmcanally",
		"width": 640,
		"height": 960,
		"imageUrl": "https://images02.foap.com/images/f22bffd5652e47359b0e531eec1db813/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Birds"
	},
	{
		"id": "6eb41f88-08b8-4be2-958e-c78c9e53fc3e",
		"albumId": "6eb41f88-08b8-4be2-958e-c78c9e53fc3e",
		"slug": "poland",
		"caption": "Poland",
		"alt": "Winter in Poland",
		"username": "adrianwerner",
		"width": 2982,
		"height": 2982,
		"imageUrl": "https://images02.foap.com/images/2bc17707-761d-483d-bf37-c84b6647caa5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Poland"
	},
	{
		"id": "928fd7d3-69af-426c-b17f-10a96d676d6d",
		"albumId": "928fd7d3-69af-426c-b17f-10a96d676d6d",
		"slug": "flat-laying-in-the-kitchen",
		"caption": "Flat laying in the kitchen",
		"alt": "Himalayan salt",
		"username": "happytails",
		"width": 2304,
		"height": 1536,
		"imageUrl": "https://images02.foap.com/images/699819f0-8f18-4f84-b600-15ab2880e760/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Flat laying in the kitchen"
	},
	{
		"id": "631090e4-0bb6-41e9-9f3c-74a3a2b4be43",
		"albumId": "631090e4-0bb6-41e9-9f3c-74a3a2b4be43",
		"slug": "adventure",
		"caption": "Adventure",
		"alt": "Crazy morning fog. ",
		"username": "ican",
		"width": 5440,
		"height": 3627,
		"imageUrl": "https://images03.foap.com/images/9bbc2d82-d6aa-4f8d-ad4c-170b9c0ab0eb/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Adventure"
	},
	{
		"id": "0505aa9f-7fa1-48d1-9cfa-5d3a7fbfe9eb",
		"albumId": "0505aa9f-7fa1-48d1-9cfa-5d3a7fbfe9eb",
		"slug": "wildlife",
		"caption": "Wildlife",
		"alt": "Wildlife",
		"username": "ican",
		"width": 1984,
		"height": 1488,
		"imageUrl": "https://images01.foap.com/images/859bda8b-5311-4930-be7b-836ee0d26d84/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Wildlife"
	},
	{
		"id": "b9cda7a2-8bfc-44e2-b045-7d185892328a",
		"albumId": "b9cda7a2-8bfc-44e2-b045-7d185892328a",
		"slug": "lovely-garden-flowers",
		"caption": "Lovely garden flowers",
		"alt": "Pion flower\n",
		"username": "christina_fs",
		"width": 3888,
		"height": 2592,
		"imageUrl": "https://images02.foap.com/images/f26373a6-d144-4987-9261-8a2bf11eea69/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Lovely garden flowers"
	},
	{
		"id": "f15b8627-d0a4-4812-a0ce-28da02f7369a",
		"albumId": "f15b8627-d0a4-4812-a0ce-28da02f7369a",
		"slug": "pets",
		"caption": "Pets",
		"alt": "Oxen. My friends cute dog",
		"username": "ananasska",
		"width": 4912,
		"height": 3264,
		"imageUrl": "https://images02.foap.com/images/8c866f09-b029-4a48-88b1-43f4244cfff2/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Pets"
	},
	{
		"id": "b952f3e1-b6c6-4e84-8032-cb28f35315b9",
		"albumId": "b952f3e1-b6c6-4e84-8032-cb28f35315b9",
		"slug": "childhood",
		"caption": "childhood",
		"alt": "Boy... sea",
		"username": "ananasska",
		"width": 1535,
		"height": 2308,
		"imageUrl": "https://images03.foap.com/images/66c6c6b64a4043599ef747a1b1558b0a/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "childhood"
	},
	{
		"id": "53ee5fdb-0aed-4f8b-9cc2-49f8469ea978",
		"albumId": "53ee5fdb-0aed-4f8b-9cc2-49f8469ea978",
		"slug": "monochrome",
		"caption": "Monochrome",
		"alt": "Carlton hill",
		"username": "dmzelman",
		"width": 2000,
		"height": 1325,
		"imageUrl": "https://images03.foap.com/images/c7dfd88a-bba9-422f-b085-fb5d247a63f5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Monochrome"
	},
	{
		"id": "cf6a8d1f-7114-47a5-ba34-96d0cfc1232b",
		"albumId": "cf6a8d1f-7114-47a5-ba34-96d0cfc1232b",
		"slug": "roads-of-bliss",
		"caption": "Roads of bliss",
		"alt": "Point Reyes",
		"username": "hddatmyers",
		"width": 2268,
		"height": 4032,
		"imageUrl": "https://images03.foap.com/images/8b3a6c36-5a4b-44b1-a649-4c1fec9b6a29/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Roads of bliss"
	},
	{
		"id": "e0bb5d66-a3ef-4416-a06d-ac38d979717f",
		"albumId": "e0bb5d66-a3ef-4416-a06d-ac38d979717f",
		"slug": "fresh-fruits-vegetables",
		"caption": "Fresh Fruits & Vegetables ",
		"alt": "Harvested onions, apples and squash in a pile of produce.",
		"username": "shannonfieldsphoto",
		"width": 4096,
		"height": 2730,
		"imageUrl": "https://images01.foap.com/images/183a5e2f-9413-433f-8130-29bcf88fb2e5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Fresh Fruits & Vegetables "
	},
	{
		"id": "63ff22d7-4723-4c2f-8651-bb0c708a2f8b",
		"albumId": "63ff22d7-4723-4c2f-8651-bb0c708a2f8b",
		"slug": "animals",
		"caption": "Animals",
		"alt": "geese",
		"username": "pieces.of.my.life",
		"width": 1600,
		"height": 1066,
		"imageUrl": "https://images02.foap.com/images/7f46e51d-969a-4e0d-a9c3-57e511dc3533/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Animals"
	},
	{
		"id": "99c9198f-82f1-44cd-9197-1be8a41357dc",
		"albumId": "99c9198f-82f1-44cd-9197-1be8a41357dc",
		"slug": "stylish-food",
		"caption": "Stylish food",
		"alt": "cornflakes",
		"username": "bussardel",
		"width": 2089,
		"height": 2089,
		"imageUrl": "https://images02.foap.com/images/72fd598a-7bcd-46a1-b718-12d1239bdb45/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Stylish food"
	}
];

/***/ }),

/***/ 3163:
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "2b997c87-c6e8-4d41-a604-b803e94f4447",
		"albumId": "2b997c87-c6e8-4d41-a604-b803e94f4447",
		"slug": "holding-food",
		"caption": "Holding food",
		"alt": "Hands holding a cup of tea",
		"username": "foap",
		"width": 5760,
		"height": 3840,
		"imageUrl": "https://images02.foap.com/images/d0772de5-7d60-4a8b-85f3-49da9290ee9a/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Holding food"
	},
	{
		"id": "4eb79d19-c1ae-49fa-89b0-0791d4962d64",
		"albumId": "4eb79d19-c1ae-49fa-89b0-0791d4962d64",
		"slug": "let-me-have-a-coffee",
		"caption": "Let me have a  coffee",
		"alt": "Fresh coffee",
		"username": "foap",
		"width": 4288,
		"height": 2848,
		"imageUrl": "https://images01.foap.com/images/0b3803f9-b9b5-4b3d-9029-c0ab9520e6d7/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Let me have a  coffee"
	},
	{
		"id": "87ab1ce0-8c9f-4c39-818b-3ad28e0ab047",
		"albumId": "87ab1ce0-8c9f-4c39-818b-3ad28e0ab047",
		"slug": "delicious-pizza",
		"caption": "Delicious Pizza",
		"alt": null,
		"username": "foap",
		"width": 3264,
		"height": 2176,
		"imageUrl": "https://images03.foap.com/images/b7d81cb0-9ca4-480d-8c24-c710e1d3ad19/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Delicious Pizza"
	},
	{
		"id": "d8859682-1211-4131-97bb-ee2f56bbb493",
		"albumId": "d8859682-1211-4131-97bb-ee2f56bbb493",
		"slug": "pregnant-women",
		"caption": "Pregnant Women",
		"alt": "Precious baby boy is almost here ",
		"username": "foap",
		"width": 2294,
		"height": 1536,
		"imageUrl": "https://images01.foap.com/images/64d7e717-10c2-499b-9e5c-482d2a0526e4/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Pregnant Women"
	},
	{
		"id": "04970dd3-b8b9-43cd-baf0-c844bf160020",
		"albumId": "04970dd3-b8b9-43cd-baf0-c844bf160020",
		"slug": "foggy-mornings",
		"caption": "Foggy mornings ",
		"alt": "Mountain ranges in thailand",
		"username": "foap",
		"width": 4608,
		"height": 3456,
		"imageUrl": "https://images02.foap.com/images/9a75fce4-e2a3-4b74-b79c-70cf38b1cca9/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Foggy mornings "
	},
	{
		"id": "c1e35c95-2598-458d-bbd7-91a75444f2df",
		"albumId": "c1e35c95-2598-458d-bbd7-91a75444f2df",
		"slug": "magical-iris",
		"caption": "Magical iris",
		"alt": "Eye on you",
		"username": "foap",
		"width": 3320,
		"height": 2070,
		"imageUrl": "https://images03.foap.com/images/7c880698-e855-4b55-a4dc-ed26f2bde1fe/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Magical iris"
	},
	{
		"id": "3cdb6cb8-718a-4c50-bac2-aca6fd64fe9f",
		"albumId": "3cdb6cb8-718a-4c50-bac2-aca6fd64fe9f",
		"slug": "from-where-i-stand",
		"caption": "From where I stand",
		"alt": null,
		"username": "foap",
		"width": 3264,
		"height": 2448,
		"imageUrl": "https://images01.foap.com/images/f159d5e2-fa41-4b84-bfcb-78a07084a41d/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "From where I stand"
	},
	{
		"id": "41584269-1df1-47fb-83af-08a62e9c5935",
		"albumId": "41584269-1df1-47fb-83af-08a62e9c5935",
		"slug": "majestic-horses",
		"caption": "Majestic Horses",
		"alt": "Horse portrait ",
		"username": "foap",
		"width": 4126,
		"height": 3493,
		"imageUrl": "https://images01.foap.com/images/43227022-576c-46ec-b49a-5c1d6acd49e8/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Majestic Horses"
	},
	{
		"id": "5c999954-0765-428c-a8e7-46022a11fe33",
		"albumId": "5c999954-0765-428c-a8e7-46022a11fe33",
		"slug": "working-hands-close-up",
		"caption": "Working Hands Close-up",
		"alt": null,
		"username": "foap",
		"width": 2832,
		"height": 4256,
		"imageUrl": "https://images03.foap.com/images/bdee23db-aa4c-4230-8a1d-d1bb70819daa/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Working Hands Close-up"
	},
	{
		"id": "30534bdc-073b-4f36-aee1-75136cbd18b2",
		"albumId": "30534bdc-073b-4f36-aee1-75136cbd18b2",
		"slug": "warm-up-flat-lays",
		"caption": "Warm Up Flat lays",
		"alt": null,
		"username": "foap",
		"width": 3264,
		"height": 2448,
		"imageUrl": "https://images02.foap.com/images/7ca22e4b-2ca4-48a0-94a2-04529d8e8d13/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Warm Up Flat lays"
	},
	{
		"id": "fd6d24a7-7a55-40e8-aec5-819dc2f9d6bc",
		"albumId": "fd6d24a7-7a55-40e8-aec5-819dc2f9d6bc",
		"slug": "photo-stories-in-my-city",
		"caption": "Photo Stories in My City",
		"alt": "Not a bad place to stop and enjoy the view. Game rules. ",
		"username": "foap",
		"width": 6000,
		"height": 4000,
		"imageUrl": "https://images03.foap.com/images/7fc686e0-a1cb-4668-a0c9-30e3c69c52cf/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Photo Stories in My City"
	},
	{
		"id": "5ec7f915-2920-4504-8765-4d51e1cc1350",
		"albumId": "5ec7f915-2920-4504-8765-4d51e1cc1350",
		"slug": "amazing-silhouettes",
		"caption": "Amazing Silhouettes!",
		"alt": "On the sunset beach",
		"username": "foap",
		"width": 3264,
		"height": 4928,
		"imageUrl": "https://images03.foap.com/images/4d4615f2-10ad-4974-9b9a-5410bf2fc355/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Amazing Silhouettes!"
	},
	{
		"id": "f1a2389b-6cb6-4f8b-9527-a8971c43d938",
		"albumId": "f1a2389b-6cb6-4f8b-9527-a8971c43d938",
		"slug": "creative-textures",
		"caption": "Creative textures ",
		"alt": "A layer of Stones",
		"username": "foap",
		"width": 3024,
		"height": 4032,
		"imageUrl": "https://images01.foap.com/images/65951abd-67d2-4521-8e8b-9a266e994e2f/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Creative textures "
	},
	{
		"id": "6e0fc49c-506c-4941-8aee-533f0864ecd9",
		"albumId": "6e0fc49c-506c-4941-8aee-533f0864ecd9",
		"slug": "arts-crafts-supply",
		"caption": "Arts & Crafts Supply",
		"alt": "Pencils",
		"username": "foap",
		"width": 1896,
		"height": 1896,
		"imageUrl": "https://images02.foap.com/images/cb2ad689-0184-4589-a112-c8596fef1227/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Arts & Crafts Supply"
	},
	{
		"id": "b023fd5e-91c5-48bd-aac9-19cb2a5a7d4c",
		"albumId": "b023fd5e-91c5-48bd-aac9-19cb2a5a7d4c",
		"slug": "delicious-street-food",
		"caption": "Delicious Street Food",
		"alt": "Donut worry, be happy",
		"username": "foap",
		"width": 2448,
		"height": 3264,
		"imageUrl": "https://images01.foap.com/images/8485e5b7-0541-4c46-b0c2-52584c90ed01/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Delicious Street Food"
	},
	{
		"id": "ebc817cc-36d2-4a2a-914b-58f911a258b4",
		"albumId": "ebc817cc-36d2-4a2a-914b-58f911a258b4",
		"slug": "summertime-ice-cream",
		"caption": "Summertime Ice cream",
		"alt": "Pastel Ice Pop",
		"username": "foap",
		"width": 2905,
		"height": 4351,
		"imageUrl": "https://images02.foap.com/images/791bbe42-fa9a-448b-ada2-23d8b20c36a4/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Summertime Ice cream"
	},
	{
		"id": "4a4ac64f-0aa3-4fe0-8093-548f81ca665b",
		"albumId": "4a4ac64f-0aa3-4fe0-8093-548f81ca665b",
		"slug": "macro-shots",
		"caption": "Macro shots! ",
		"alt": "The entire universe in one tiny spec",
		"username": "foap",
		"width": 2173,
		"height": 1449,
		"imageUrl": "https://images01.foap.com/images/61bea989-7679-46d5-a9ee-f78bfe03b181/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Macro shots! "
	},
	{
		"id": "6d66f163-98e2-4c1f-9367-b307c028870a",
		"albumId": "6d66f163-98e2-4c1f-9367-b307c028870a",
		"slug": "red-color-story",
		"caption": "Red color story",
		"alt": null,
		"username": "foap",
		"width": 2731,
		"height": 2731,
		"imageUrl": "https://images01.foap.com/images/329c5d74-75e6-4d8d-a990-182cb5bfca22/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Red color story"
	},
	{
		"id": "812bb3d9-7a57-462e-a35f-a30339111de4",
		"albumId": "812bb3d9-7a57-462e-a35f-a30339111de4",
		"slug": "fun-with-nails",
		"caption": "Fun with nails",
		"alt": "in the grass",
		"username": "foap",
		"width": 4272,
		"height": 2848,
		"imageUrl": "https://images02.foap.com/images/936ecdee-971f-4932-aea9-787b17a87b22/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Fun with nails"
	},
	{
		"id": "b2f3463f-ac72-400b-81e6-fa1d4306a4e4",
		"albumId": "b2f3463f-ac72-400b-81e6-fa1d4306a4e4",
		"slug": "ingredients",
		"caption": "Ingredients",
		"alt": "Avocado ",
		"username": "foap",
		"width": 2738,
		"height": 1825,
		"imageUrl": "https://images03.foap.com/images/2bb9b142-b783-4748-99b2-fea0b37a5c80/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Ingredients"
	}
];

/***/ }),

/***/ 3164:
/***/ (function(module, exports) {

module.exports = [
	{
		"user": {
			"id": "23544852-e97b-4f66-b209-a62d2814b175",
			"username": "muzikalmermaid",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/23544852-e97b-4f66-b209-a62d2814b175/w120.?1434169621"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.88461538461539,
		"ratingsCount": 26,
		"resolutions": {
			"w640": "https://images01.foap.com/images/bf7561ef-0300-4830-a6a0-1f4b43e33e36/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/bf7561ef-0300-4830-a6a0-1f4b43e33e36/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Looking for Love",
		"suggestedCaption": "Portrait, Cute, Fun, People, Little",
		"curatedCaption": null,
		"id": "9f0061be-1ef2-4ba2-9c96-c1adb75b1ae5",
		"slug": "looking-for-love",
		"width": 2848,
		"height": 2848,
		"selectedCaption": "Looking for Love"
	},
	{
		"user": {
			"id": "2704c671-01ec-4ae5-9aad-a906d2fb423f",
			"username": "djmon1que",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/2704c671-01ec-4ae5-9aad-a906d2fb423f/w120.?1475435139"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.83191609977327,
		"ratingsCount": 3528,
		"resolutions": {
			"w640": "https://images03.foap.com/images/779b284b-9906-447a-9fe5-a1f940660014/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/779b284b-9906-447a-9fe5-a1f940660014/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Stairs",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "d732f95a-5341-4594-aaa6-bf85f0f4d802",
		"slug": "stairs",
		"width": 3024,
		"height": 4032,
		"selectedCaption": "Stairs"
	},
	{
		"user": {
			"id": "08ef0a4b-6fff-4ea4-b978-fed8659726a5",
			"username": "pieces.of.my.life",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/08ef0a4b-6fff-4ea4-b978-fed8659726a5/w120.jpg?1510696949"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.64999999999999,
		"ratingsCount": 20,
		"resolutions": {
			"w640": "https://images02.foap.com/images/7f37d19a-ef46-476a-b462-bce19ea72d74/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/7f37d19a-ef46-476a-b462-bce19ea72d74/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Pink Lips",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "cd4fee4f-c86f-42c5-99f8-bbb6c798d961",
		"slug": "pink-lips",
		"width": 2212,
		"height": 3318,
		"selectedCaption": "Pink Lips"
	},
	{
		"user": {
			"id": "53c1999d-4724-4560-ace2-da6b2370be05",
			"username": "jenniferlie",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/53c1999d-4724-4560-ace2-da6b2370be05/w120.?1499092039"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.91666666666666,
		"ratingsCount": 12,
		"resolutions": {
			"w640": "https://images03.foap.com/images/b101b41f-286e-4602-9f61-b7681991a7b0/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/b101b41f-286e-4602-9f61-b7681991a7b0/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Cookies for life.",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "da670f85-bb2f-4f65-9b00-48700f0060d2",
		"slug": "cookies-for-life",
		"width": 3264,
		"height": 3264,
		"selectedCaption": "Cookies for life."
	},
	{
		"user": {
			"id": "85961ab5-0852-4746-b82e-93a1605e8575",
			"username": "rickycs",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/85961ab5-0852-4746-b82e-93a1605e8575/w120.?1464206539"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.45454545454545,
		"ratingsCount": 11,
		"resolutions": {
			"w640": "https://images03.foap.com/images/8d7f0d5c-a3fe-4b6b-be1a-8caedd346baa/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/8d7f0d5c-a3fe-4b6b-be1a-8caedd346baa/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "flower inthe dark",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "933890d9-497a-4619-a309-5711f3dfcfd5",
		"slug": "flower-inthe-dark",
		"width": 1664,
		"height": 1664,
		"selectedCaption": "flower inthe dark"
	},
	{
		"user": {
			"id": "d0c9efcc-aa17-4003-9859-2e914388323a",
			"username": "hamacle",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/d0c9efcc-aa17-4003-9859-2e914388323a/w120.?1432651917"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.6470588235294,
		"ratingsCount": 17,
		"resolutions": {
			"w640": "https://images02.foap.com/images/3b3aa576-a689-4f4e-b5c0-72e43a79ec9a/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/3b3aa576-a689-4f4e-b5c0-72e43a79ec9a/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Playing music on a quiet lazy afternoon",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "83f63f12-818e-4b60-8e00-56bf7ca248e6",
		"slug": "playing-music-on-a-quiet-lazy-afternoon",
		"width": 1780,
		"height": 1188,
		"selectedCaption": "Playing music on a quiet lazy afternoon"
	},
	{
		"user": {
			"id": "94687212-dd14-42bc-af0a-2f7fc2fbc505",
			"username": "best_helen",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/94687212-dd14-42bc-af0a-2f7fc2fbc505/w120.jpg?1503043943"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 4.95833333333333,
		"ratingsCount": 48,
		"resolutions": {
			"w640": "https://images02.foap.com/images/b3e37cb3-4a05-4223-b925-56eeb1d3de41/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/b3e37cb3-4a05-4223-b925-56eeb1d3de41/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "Food, Fruit, No Person, Sweet, Healthy",
		"curatedCaption": null,
		"id": "5a2be2e9-f413-4fc1-999b-3d40c2c262fc",
		"slug": "food-fruit-no-person-sweet-healthy",
		"width": 2396,
		"height": 3396,
		"selectedCaption": "Food, Fruit, No Person, Sweet, Healthy"
	},
	{
		"user": {
			"id": "94687212-dd14-42bc-af0a-2f7fc2fbc505",
			"username": "best_helen",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/94687212-dd14-42bc-af0a-2f7fc2fbc505/w120.jpg?1503043943"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.94285714285714,
		"ratingsCount": 35,
		"resolutions": {
			"w640": "https://images03.foap.com/images/ca200d48-9adb-498f-805a-11d34a8349e9/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/ca200d48-9adb-498f-805a-11d34a8349e9/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "macarons",
		"suggestedCaption": null,
		"curatedCaption": "Close-up of a macaroons",
		"id": "dc97757c-000a-46bb-8d90-1e9bb4c251ac",
		"slug": "close-up-of-a-macaroons",
		"width": 2624,
		"height": 3280,
		"selectedCaption": "Close-up of a macaroons"
	},
	{
		"user": {
			"id": "c950e69c-cc94-449b-ba3f-96f6688e5903",
			"username": "thayra",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/c950e69c-cc94-449b-ba3f-96f6688e5903/w120.jpg?1488397045"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.76923076923076,
		"ratingsCount": 26,
		"resolutions": {
			"w640": "https://images01.foap.com/images/f040e076-03f3-4ebb-880f-c96537a56716/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/f040e076-03f3-4ebb-880f-c96537a56716/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Homemade chocolate mini tarts on dark wooden background",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "9901d36f-a340-4252-8a56-308b520c5bb4",
		"slug": "homemade-chocolate-mini-tarts-on-dark-wooden-background",
		"width": 6000,
		"height": 4000,
		"selectedCaption": "Homemade chocolate mini tarts on dark wooden background"
	},
	{
		"user": {
			"id": "4cb896dc-151e-4170-a884-fbd70dda8aca",
			"username": "rainbowsprinklesphoto",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/4cb896dc-151e-4170-a884-fbd70dda8aca/w120.?1539203818"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.61538461538462,
		"ratingsCount": 13,
		"resolutions": {
			"w640": "https://images02.foap.com/images/05dab959-8a09-46ed-a069-38f231ce6da7/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/05dab959-8a09-46ed-a069-38f231ce6da7/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Homemade juice",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "f9234afd-aa4a-430e-8581-553525498ada",
		"slug": "homemade-juice",
		"width": 5472,
		"height": 3648,
		"selectedCaption": "Homemade juice"
	},
	{
		"user": {
			"id": "8f312987-c51d-4cb8-9462-f696ac5048cc",
			"username": "kaser",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/8f312987-c51d-4cb8-9462-f696ac5048cc/w120.JPG?1574852149"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.14661791590502,
		"ratingsCount": 2735,
		"resolutions": {
			"w640": "https://images02.foap.com/images/ced1a002-5fe7-4d06-b407-106040a5122b/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/ced1a002-5fe7-4d06-b407-106040a5122b/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "when you see something really disgusting :)",
		"suggestedCaption": null,
		"curatedCaption": "Boy using computer",
		"id": "55281040-314f-4fb4-bb0d-667e847dde14",
		"slug": "boy-using-computer",
		"width": 6000,
		"height": 4000,
		"selectedCaption": "Boy using computer"
	},
	{
		"user": {
			"id": "c1ff8e29-71dd-4aa6-86a1-0774bad33102",
			"username": "primadoribeiro",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/c1ff8e29-71dd-4aa6-86a1-0774bad33102/w120.jpg?1507912342"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.75292242295435,
		"ratingsCount": 1882,
		"resolutions": {
			"w640": "https://images01.foap.com/images/6eb4a5f9-4726-4658-a3ac-92c8d91e222c/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/6eb4a5f9-4726-4658-a3ac-92c8d91e222c/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Pôr do Sol em Pico Alto, Guaramiranga - Ce.",
		"suggestedCaption": "Sunset, Dawn, Sun, Backlit, Landscape",
		"curatedCaption": null,
		"id": "2aebfca1-bde6-4468-b6c8-d242516692b7",
		"slug": "por-do-sol-em-pico-alto-guaramiranga-ce",
		"width": 4160,
		"height": 2340,
		"selectedCaption": "Pôr do Sol em Pico Alto, Guaramiranga - Ce."
	},
	{
		"user": {
			"id": "e3e2be89-a5cf-4992-acbb-cddfb937fdde",
			"username": "little_klein",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/e3e2be89-a5cf-4992-acbb-cddfb937fdde/w120.jpg?1499108076"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 5,
		"ratingsCount": 10,
		"resolutions": {
			"w640": "https://images02.foap.com/images/526effd0-736c-46a2-8612-bfe173a3e81e/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/526effd0-736c-46a2-8612-bfe173a3e81e/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "happy girl",
		"suggestedCaption": "Nature, Summer, Outdoors, Grass, Flora",
		"curatedCaption": null,
		"id": "40891553-a6cf-477a-84b8-f379e5fb82fb",
		"slug": "happy-girl",
		"width": 6016,
		"height": 4000,
		"selectedCaption": "happy girl"
	},
	{
		"user": {
			"id": "e3e2be89-a5cf-4992-acbb-cddfb937fdde",
			"username": "little_klein",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/e3e2be89-a5cf-4992-acbb-cddfb937fdde/w120.jpg?1499108076"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.69169960474311,
		"ratingsCount": 759,
		"resolutions": {
			"w640": "https://images02.foap.com/images/b8b05057-1cd5-46c6-b4ef-e30ff05a1ae4/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/b8b05057-1cd5-46c6-b4ef-e30ff05a1ae4/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "girls have fun",
		"suggestedCaption": "Fun, Joy, Child, Nature, Summer",
		"curatedCaption": null,
		"id": "cef2de38-6422-4013-ac36-92bde4064774",
		"slug": "girls-have-fun",
		"width": 6016,
		"height": 4000,
		"selectedCaption": "girls have fun"
	},
	{
		"user": {
			"id": "b54a7e8e-0462-4523-819c-aeb7664f1086",
			"username": "athalan",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/b54a7e8e-0462-4523-819c-aeb7664f1086/w120.jpg?1496873857"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.45833333333333,
		"ratingsCount": 24,
		"resolutions": {
			"w640": "https://images01.foap.com/images/f4c63eb7-54de-4fa6-95cc-c9cc40f0d667/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/f4c63eb7-54de-4fa6-95cc-c9cc40f0d667/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "cute baby",
		"suggestedCaption": "Christmas, Celebration, Festival, People, Light",
		"curatedCaption": "Cute baby with pacifier",
		"id": "bed3d345-c307-4e87-9b9a-898389135519",
		"slug": "cute-baby-with-pacifier",
		"width": 4928,
		"height": 3264,
		"selectedCaption": "Cute baby with pacifier"
	},
	{
		"user": {
			"id": "47832253-de5f-47c5-8224-d834bbe2defa",
			"username": "krislu",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/47832253-de5f-47c5-8224-d834bbe2defa/w120.jpg?1501665484"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 2,
		"ratingsCount": 1,
		"resolutions": {
			"w640": "https://images01.foap.com/images/f081a7f1-4a9a-4d7d-9ed0-0cb95624b287/original.jpeg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/f081a7f1-4a9a-4d7d-9ed0-0cb95624b287/original.jpeg?filename=w1920&dw=1920"
		},
		"caption": "Little boy in the playground",
		"suggestedCaption": "Child, People, One, Portrait, Indoors",
		"curatedCaption": null,
		"id": "3f71c54b-c392-48b8-a99d-ceb18672ca52",
		"slug": "little-boy-in-the-playground",
		"width": 2048,
		"height": 1367,
		"selectedCaption": "Little boy in the playground"
	},
	{
		"user": {
			"id": "4dc84158-c116-4914-887c-cc9a3a8ac8f5",
			"username": "lizzie.favaro",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/4dc84158-c116-4914-887c-cc9a3a8ac8f5/w120.?1486482366"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.55611222444896,
		"ratingsCount": 998,
		"resolutions": {
			"w640": "https://images02.foap.com/images/9d659c5c-3dc0-49fd-a169-4739d6ed6a12/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/9d659c5c-3dc0-49fd-a169-4739d6ed6a12/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Stone \n\n",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "43dd57d0-6983-4251-9c00-0c508722cf9e",
		"slug": "stone",
		"width": 2048,
		"height": 1152,
		"selectedCaption": "Stone \n\n"
	},
	{
		"user": {
			"id": "11b64c92-10b4-416f-ab8f-9b68fba9e418",
			"username": "lesiavalentain",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/11b64c92-10b4-416f-ab8f-9b68fba9e418/w120.?1564494743"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.71056241426613,
		"ratingsCount": 729,
		"resolutions": {
			"w640": "https://images03.foap.com/images/2dfecee1-b911-46dd-9b33-e95acb86f293/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/2dfecee1-b911-46dd-9b33-e95acb86f293/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Celebration",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "34e7fb6e-20fe-46f3-ae2e-796a31c880f5",
		"slug": "celebration",
		"width": 5616,
		"height": 3744,
		"selectedCaption": "Celebration"
	},
	{
		"user": {
			"id": "c1ff8e29-71dd-4aa6-86a1-0774bad33102",
			"username": "primadoribeiro",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/c1ff8e29-71dd-4aa6-86a1-0774bad33102/w120.jpg?1507912342"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.925,
		"ratingsCount": 40,
		"resolutions": {
			"w640": "https://images03.foap.com/images/9f7de5cf-01e9-41c7-bdc4-a8b493250b3d/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/9f7de5cf-01e9-41c7-bdc4-a8b493250b3d/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Sertão 🌵",
		"suggestedCaption": "Woman, Summer, Nature, Girl, Outdoors",
		"curatedCaption": null,
		"id": "34614392-649d-407a-b5d4-fe963613e4c0",
		"slug": "sertao",
		"width": 3648,
		"height": 5472,
		"selectedCaption": "Sertão 🌵"
	},
	{
		"user": {
			"id": "83d098cf-6c12-4a97-90e6-18ab721cd962",
			"username": "jilliangomez",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/83d098cf-6c12-4a97-90e6-18ab721cd962/w120.?1476385264"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.59200695047811,
		"ratingsCount": 5755,
		"resolutions": {
			"w640": "https://images01.foap.com/images/ac34ba90-169e-4c3e-8fd0-4d17cfa5d8fd/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/ac34ba90-169e-4c3e-8fd0-4d17cfa5d8fd/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Fog",
		"suggestedCaption": null,
		"curatedCaption": "A man playing basketball doing a slam dunk. A city covered in fog is in the background.",
		"id": "ceabd55c-7d2d-4a76-b68e-976a9171f0ca",
		"slug": "a-man-playing-basketball-doing-a-slam-dunk-a-city-covered-in-fog-is-in-the-background",
		"width": 4358,
		"height": 3117,
		"selectedCaption": "A man playing basketball doing a slam dunk. A city covered in fog is in the background."
	},
	{
		"user": {
			"id": "d5af3635-cfec-4fcc-a135-072c9f2e6ea3",
			"username": "vollygda",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/d5af3635-cfec-4fcc-a135-072c9f2e6ea3/w120.?1501174867"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.75144508670516,
		"ratingsCount": 519,
		"resolutions": {
			"w640": "https://images01.foap.com/images/fb122174-5cae-4ed0-9b10-77796757715d/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/fb122174-5cae-4ed0-9b10-77796757715d/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Light",
		"suggestedCaption": null,
		"curatedCaption": "Woman holding a illuminated light",
		"id": "12c27512-96c7-4288-9f90-305e87a1fd01",
		"slug": "woman-holding-a-illuminated-light",
		"width": 4032,
		"height": 3024,
		"selectedCaption": "Woman holding a illuminated light"
	},
	{
		"user": {
			"id": "c950e69c-cc94-449b-ba3f-96f6688e5903",
			"username": "thayra",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/c950e69c-cc94-449b-ba3f-96f6688e5903/w120.jpg?1488397045"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.76315789473685,
		"ratingsCount": 38,
		"resolutions": {
			"w640": "https://images03.foap.com/images/c8b78d1d-2450-433b-961b-57ec23766c74/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/c8b78d1d-2450-433b-961b-57ec23766c74/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Breakfast with love",
		"suggestedCaption": "Relaxation, Bed, Family, Dawn, Indoors",
		"curatedCaption": "relaxation",
		"id": "4be5ece6-ec53-4b03-9938-952c1d7a4ecc",
		"slug": "breakfast-with-love",
		"width": 2736,
		"height": 3648,
		"selectedCaption": "relaxation"
	},
	{
		"user": {
			"id": "11b64c92-10b4-416f-ab8f-9b68fba9e418",
			"username": "lesiavalentain",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/11b64c92-10b4-416f-ab8f-9b68fba9e418/w120.?1564494743"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.77777777777778,
		"ratingsCount": 9,
		"resolutions": {
			"w640": "https://images01.foap.com/images/1eaf2ede-669a-43d1-97d8-de92222ac41b/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/1eaf2ede-669a-43d1-97d8-de92222ac41b/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Holiday pie",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "f02d2474-f5d3-43a0-a3a9-201ceb220aa0",
		"slug": "holiday-pie",
		"width": 2160,
		"height": 2160,
		"selectedCaption": "Holiday pie"
	},
	{
		"user": {
			"id": "0cefbb89-abd7-4996-93e4-2d338ee41abc",
			"username": "lucaselias",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/0cefbb89-abd7-4996-93e4-2d338ee41abc/w120.?1507511079"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.93333333333335,
		"ratingsCount": 15,
		"resolutions": {
			"w640": "https://images01.foap.com/images/6c08fe91-0cdf-466f-95cd-c262099688f6/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/6c08fe91-0cdf-466f-95cd-c262099688f6/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Love ",
		"suggestedCaption": "Dog, Mammal, Portrait, Pet, One",
		"curatedCaption": null,
		"id": "20cce51b-7503-4e73-8fbb-a542e948f70f",
		"slug": "love",
		"width": 4032,
		"height": 3024,
		"selectedCaption": "Love "
	},
	{
		"user": {
			"id": "005d2c23-59aa-4cae-be6e-dfbc7654351b",
			"username": "davidpenna313",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/005d2c23-59aa-4cae-be6e-dfbc7654351b/w120.?1452847706"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 4.63934426229507,
		"ratingsCount": 61,
		"resolutions": {
			"w640": "https://images03.foap.com/images/62c2c976-b2cd-4211-89b3-81369993a698/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/62c2c976-b2cd-4211-89b3-81369993a698/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "People, Rock, One, Climber, Adult",
		"curatedCaption": null,
		"id": "50cd10b5-10b6-4494-bc07-2d41844b6add",
		"slug": "",
		"width": 2560,
		"height": 1707,
		"selectedCaption": "People, Rock, One, Climber, Adult"
	},
	{
		"user": {
			"id": "005d2c23-59aa-4cae-be6e-dfbc7654351b",
			"username": "davidpenna313",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/005d2c23-59aa-4cae-be6e-dfbc7654351b/w120.?1452847706"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.74404761904756,
		"ratingsCount": 504,
		"resolutions": {
			"w640": "https://images02.foap.com/images/2115cae6-0b46-4764-829e-158787845207/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/2115cae6-0b46-4764-829e-158787845207/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Big sur",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "8eb7532f-3ff4-4617-a02f-a600ca86be0e",
		"slug": "big-sur",
		"width": 4988,
		"height": 3325,
		"selectedCaption": "Big sur"
	},
	{
		"user": {
			"id": "005d2c23-59aa-4cae-be6e-dfbc7654351b",
			"username": "davidpenna313",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/005d2c23-59aa-4cae-be6e-dfbc7654351b/w120.?1452847706"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.66666666666667,
		"ratingsCount": 9,
		"resolutions": {
			"w640": "https://images03.foap.com/images/c59ded9f-f76f-4094-8033-25b5a837fe7f/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/c59ded9f-f76f-4094-8033-25b5a837fe7f/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Idaho ",
		"suggestedCaption": "Water, Lake, Recreation, People, Outdoors",
		"curatedCaption": null,
		"id": "1d14ac51-3b06-4f78-90c3-265fdc21f539",
		"slug": "idaho",
		"width": 2560,
		"height": 1707,
		"selectedCaption": "Idaho "
	},
	{
		"user": {
			"id": "4cb896dc-151e-4170-a884-fbd70dda8aca",
			"username": "rainbowsprinklesphoto",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/4cb896dc-151e-4170-a884-fbd70dda8aca/w120.?1539203818"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.71343008523369,
		"ratingsCount": 4341,
		"resolutions": {
			"w640": "https://images03.foap.com/images/e8327b4d-1fa8-4c4e-8229-2db9d0efe2e6/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/e8327b4d-1fa8-4c4e-8229-2db9d0efe2e6/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Lily",
		"suggestedCaption": "Dog, Portrait, Nature, Outdoors, Girl",
		"curatedCaption": null,
		"id": "d2c6116d-3132-487b-828d-e5169e78414c",
		"slug": "lily",
		"width": 3265,
		"height": 4898,
		"selectedCaption": "Lily"
	},
	{
		"user": {
			"id": "ef1e3acf-f862-4021-8dd0-64c7103dc1d3",
			"username": "michaelii",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/ef1e3acf-f862-4021-8dd0-64c7103dc1d3/w120.?1470846602"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 3.94736842105262,
		"ratingsCount": 19,
		"resolutions": {
			"w640": "https://images01.foap.com/images/74754208-bf91-4d17-8218-3ba86068a7c4/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/74754208-bf91-4d17-8218-3ba86068a7c4/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "Man, People, Battle, Military, Outdoors",
		"curatedCaption": null,
		"id": "c199b648-e361-4cf5-85d4-412e51cb6d83",
		"slug": "",
		"width": 2448,
		"height": 3264,
		"selectedCaption": "Man, People, Battle, Military, Outdoors"
	},
	{
		"user": {
			"id": "8b3de93a-7118-45d1-8e17-7e6891f63691",
			"username": "aschuring",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/8b3de93a-7118-45d1-8e17-7e6891f63691/w120.?1441411523"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.54999999999997,
		"ratingsCount": 480,
		"resolutions": {
			"w640": "https://images02.foap.com/images/cd15ead2-dede-4d2b-9b76-7a1254183392/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/cd15ead2-dede-4d2b-9b76-7a1254183392/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Friends ",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "bd7862d1-d216-4a53-93df-9f63027c2e69",
		"slug": "friends",
		"width": 2537,
		"height": 3806,
		"selectedCaption": "Friends "
	},
	{
		"user": {
			"id": "ef1e3acf-f862-4021-8dd0-64c7103dc1d3",
			"username": "michaelii",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/ef1e3acf-f862-4021-8dd0-64c7103dc1d3/w120.?1470846602"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 4.40000000000001,
		"ratingsCount": 15,
		"resolutions": {
			"w640": "https://images01.foap.com/images/a6f52241-95d3-4988-b811-b36203ff8023/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/a6f52241-95d3-4988-b811-b36203ff8023/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "People, Street, One, Woman, Adult",
		"curatedCaption": "A young man walking down the street wearing white clothes.  Cool, urban city vibe.",
		"id": "7f817ede-a5d1-41ba-a369-81d3fb5fbf13",
		"slug": "a-young-man-walking-down-the-street-wearing-white-clothes-cool-urban-city-vibe",
		"width": 2448,
		"height": 3264,
		"selectedCaption": "A young man walking down the street wearing white clothes.  Cool, urban city vibe."
	},
	{
		"user": {
			"id": "ef1e3acf-f862-4021-8dd0-64c7103dc1d3",
			"username": "michaelii",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/ef1e3acf-f862-4021-8dd0-64c7103dc1d3/w120.?1470846602"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.56795679567955,
		"ratingsCount": 1111,
		"resolutions": {
			"w640": "https://images02.foap.com/images/05bb6875-4ab6-4efc-a649-d1a7e9019d44/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/05bb6875-4ab6-4efc-a649-d1a7e9019d44/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "New York ",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "32510969-99e9-4d35-9282-d4c08323e11d",
		"slug": "new-york",
		"width": 2448,
		"height": 2448,
		"selectedCaption": "New York "
	},
	{
		"user": {
			"id": "672eaffd-f2d7-4b57-b87b-44fc953aeb08",
			"username": "patrickhardy",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/672eaffdf2d74b57b87b44fc953aeb08/x166.jpg?1397975210"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.69383003492434,
		"ratingsCount": 859,
		"resolutions": {
			"w640": "https://images03.foap.com/images/5ab37806-c955-40fc-adcd-b67a90884c24/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/5ab37806-c955-40fc-adcd-b67a90884c24/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Cold brew with milk moving into glass. ",
		"suggestedCaption": null,
		"curatedCaption": "Person's hand pouring milk over iced coffee",
		"id": "1b5a4fd7-43a5-4b96-b251-10414c498944",
		"slug": "person-s-hand-pouring-milk-over-iced-coffee",
		"width": 3264,
		"height": 4896,
		"selectedCaption": "Person's hand pouring milk over iced coffee"
	},
	{
		"user": {
			"id": "672eaffd-f2d7-4b57-b87b-44fc953aeb08",
			"username": "patrickhardy",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/672eaffdf2d74b57b87b44fc953aeb08/x166.jpg?1397975210"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.44444444444444,
		"ratingsCount": 18,
		"resolutions": {
			"w640": "https://images02.foap.com/images/7bfa565d-ba0a-40f9-bfad-f848703c5e4d/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/7bfa565d-ba0a-40f9-bfad-f848703c5e4d/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Things will be fine.",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "962d8648-382d-4b42-b6ef-1f2aec094882",
		"slug": "things-will-be-fine",
		"width": 2448,
		"height": 3264,
		"selectedCaption": "Things will be fine."
	},
	{
		"user": {
			"id": "e8dcf202-4c02-4b9e-8bad-44a58786df47",
			"username": "hkaplan0727",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/e8dcf202-4c02-4b9e-8bad-44a58786df47/w120.jpg?1539906945"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.58791208791207,
		"ratingsCount": 182,
		"resolutions": {
			"w640": "https://images02.foap.com/images/c2ff6875-10a4-408b-aafd-825bc2988956/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/c2ff6875-10a4-408b-aafd-825bc2988956/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Breakfast Waffles Food Flat Lay",
		"suggestedCaption": null,
		"curatedCaption": "Waffles and ingredients",
		"id": "c4873566-e99d-4a7f-91cc-1169ccd5d100",
		"slug": "waffles-and-ingredients",
		"width": 2564,
		"height": 2564,
		"selectedCaption": "Waffles and ingredients"
	},
	{
		"user": {
			"id": "3f0d860d-2544-4cb2-82a7-d4523720d97a",
			"username": "seedjan",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/3f0d860d25444cb282a7d4523720d97a/x166.jpg?1421260466"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.55766621438264,
		"ratingsCount": 737,
		"resolutions": {
			"w640": "https://images02.foap.com/images/5bf58baf-3089-4f67-8ee4-545e3a8e036d/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/5bf58baf-3089-4f67-8ee4-545e3a8e036d/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Awesome Food Flats Lays : Healthy breakfast with R2E2 mango, yogurt, chia seed and perilla seed.",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "ddc6d590-10b3-430d-8ac2-6618cc7531ee",
		"slug": "awesome-food-flats-lays-healthy-breakfast-with-r2e2-mango-yogurt-chia-seed-and-perilla-seed",
		"width": 3024,
		"height": 3024,
		"selectedCaption": "Awesome Food Flats Lays : Healthy breakfast with R2E2 mango, yogurt, chia seed and perilla seed."
	},
	{
		"user": {
			"id": "7834e1a3-f2ca-4634-88f5-117fb0858562",
			"username": "ifreebirdtheworld",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/7834e1a3-f2ca-4634-88f5-117fb0858562/w120.?1473197901"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.3728813559322,
		"ratingsCount": 59,
		"resolutions": {
			"w640": "https://images03.foap.com/images/80c7ee46-0b82-41c0-b0c4-5122d709f1af/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/80c7ee46-0b82-41c0-b0c4-5122d709f1af/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Japanese sushi!",
		"suggestedCaption": "Food, Fruit, Plate, Sweet, Dish",
		"curatedCaption": null,
		"id": "a8eb04c4-d14e-4eb8-aa73-e226a3bcea83",
		"slug": "japanese-sushi",
		"width": 1982,
		"height": 1500,
		"selectedCaption": "Japanese sushi!"
	},
	{
		"user": {
			"id": "176a52c1-2269-4d11-802d-ed33063670d9",
			"username": "alidover",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/176a52c122694d11802ded33063670d9/x166.jpg?1403636049"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.91525423728812,
		"ratingsCount": 59,
		"resolutions": {
			"w640": "https://images03.foap.com/images/d9a90feb-9379-4171-b504-d05bd108d1f3/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/d9a90feb-9379-4171-b504-d05bd108d1f3/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Sunset cowgirl",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "0388c195-1e48-4c94-9ea0-531e0450440a",
		"slug": "sunset-cowgirl",
		"width": 1664,
		"height": 1664,
		"selectedCaption": "Sunset cowgirl"
	},
	{
		"user": {
			"id": "005d2c23-59aa-4cae-be6e-dfbc7654351b",
			"username": "davidpenna313",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/005d2c23-59aa-4cae-be6e-dfbc7654351b/w120.?1452847706"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.8,
		"ratingsCount": 30,
		"resolutions": {
			"w640": "https://images02.foap.com/images/906c0b72-7bd2-43d3-b3bb-7cdb381b1926/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/906c0b72-7bd2-43d3-b3bb-7cdb381b1926/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Los Angeles",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "fb09ae77-5615-4fda-a672-141ee836cd44",
		"slug": "los-angeles",
		"width": 5184,
		"height": 3456,
		"selectedCaption": "Los Angeles"
	},
	{
		"user": {
			"id": "2ccf136b-4fea-4e84-a9d6-c9fed23bd36f",
			"username": "viktorholm",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/2ccf136b4fea4e84a9d6c9fed23bd36f/x166.jpg?1408573858"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.7073002754822,
		"ratingsCount": 1452,
		"resolutions": {
			"w640": "https://images01.foap.com/images/2abadf635c324d93a79d57aca77d8987/original.jpg?filename=web_review&dw=640",
			"w1920": "https://images01.foap.com/images/2abadf635c324d93a79d57aca77d8987/original.jpg?filename=web_review&dw=1920"
		},
		"caption": "Sunset selfie ",
		"suggestedCaption": "Silhouette, Bike, Sunset, People, Sky",
		"curatedCaption": null,
		"id": "2abadf63-5c32-4d93-a79d-57aca77d8987",
		"slug": "sunset-selfie",
		"width": 2258,
		"height": 2258,
		"selectedCaption": "Sunset selfie "
	},
	{
		"user": {
			"id": "926d86bf-5d67-4467-914a-2a93619746e2",
			"username": "ninjacentral",
			"avatar": {
				"w120": "https://api.foap.com/images/default_user_avatar.png"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 5,
		"ratingsCount": 15,
		"resolutions": {
			"w640": "https://images03.foap.com/images/482e2c71-f87a-4ba6-91a0-7ddb6bfd41fa/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/482e2c71-f87a-4ba6-91a0-7ddb6bfd41fa/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Southern California Vibe",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "cb0a667b-48d2-4321-8e89-de7da0573779",
		"slug": "southern-california-vibe",
		"width": 6000,
		"height": 4000,
		"selectedCaption": "Southern California Vibe"
	},
	{
		"user": {
			"id": "005d2c23-59aa-4cae-be6e-dfbc7654351b",
			"username": "davidpenna313",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/005d2c23-59aa-4cae-be6e-dfbc7654351b/w120.?1452847706"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.78146611341629,
		"ratingsCount": 723,
		"resolutions": {
			"w640": "https://images01.foap.com/images/fb57f6ec-3dca-40f4-8ce4-93a72894b778/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/fb57f6ec-3dca-40f4-8ce4-93a72894b778/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Skydiving without a parachute",
		"suggestedCaption": null,
		"curatedCaption": "Man diving into sea",
		"id": "55045f00-b19f-4044-88f1-f46bb0c35cef",
		"slug": "man-diving-into-sea",
		"width": 4988,
		"height": 3325,
		"selectedCaption": "Man diving into sea"
	},
	{
		"user": {
			"id": "8c25dfbd-f0fb-494c-bb03-d9192dfb6c44",
			"username": "keilyhotchkin",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/8c25dfbd-f0fb-494c-bb03-d9192dfb6c44/w120.?1544809090"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.42588235294123,
		"ratingsCount": 425,
		"resolutions": {
			"w640": "https://images01.foap.com/images/74c3a2d3-0746-4488-93a1-ebd7c1a56144/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/74c3a2d3-0746-4488-93a1-ebd7c1a56144/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Ry.",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "7429daf3-1fbd-48f6-8461-c281fc55030b",
		"slug": "ry",
		"width": 4096,
		"height": 2730,
		"selectedCaption": "Ry."
	},
	{
		"user": {
			"id": "ed6a7d75-ee93-49f1-a5ac-d2aa56d275db",
			"username": "phoenixproduction",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/ed6a7d75-ee93-49f1-a5ac-d2aa56d275db/w120.?1484326375"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.81102362204722,
		"ratingsCount": 127,
		"resolutions": {
			"w640": "https://images02.foap.com/images/a22ede3f-cc0b-4140-9d68-73571b910df3/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/a22ede3f-cc0b-4140-9d68-73571b910df3/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Palms",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "1d3ce3f0-15e3-43e4-8427-5a604b0fed63",
		"slug": "palms",
		"width": 3264,
		"height": 2448,
		"selectedCaption": "Palms"
	},
	{
		"user": {
			"id": "83d098cf-6c12-4a97-90e6-18ab721cd962",
			"username": "jilliangomez",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/83d098cf-6c12-4a97-90e6-18ab721cd962/w120.?1476385264"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 5,
		"ratingsCount": 9,
		"resolutions": {
			"w640": "https://images02.foap.com/images/d8dd773b-67cd-4fbf-af2c-b4bde19e0727/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/d8dd773b-67cd-4fbf-af2c-b4bde19e0727/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Montauk",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "4a3084b0-8759-40b9-8790-dbf09e49e97f",
		"slug": "montauk",
		"width": 2173,
		"height": 1449,
		"selectedCaption": "Montauk"
	},
	{
		"user": {
			"id": "160a6661-22ac-465b-812b-2bf4f063e974",
			"username": "frednik",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/160a6661-22ac-465b-812b-2bf4f063e974/w120.jpg?1452650924"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.90909090909091,
		"ratingsCount": 22,
		"resolutions": {
			"w640": "https://images01.foap.com/images/90b49400-dba6-4a44-abc7-d15ee216d5d7/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/90b49400-dba6-4a44-abc7-d15ee216d5d7/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "telescope view",
		"suggestedCaption": "No Person, Travel, Landscape, Vehicle, Vintage",
		"curatedCaption": null,
		"id": "72bb728c-d50d-4ec1-b705-8a40a9679b72",
		"slug": "telescope-view",
		"width": 1931,
		"height": 1280,
		"selectedCaption": "telescope view"
	},
	{
		"user": {
			"id": "3eed6719-ba8d-4d36-8592-c0ea560ddf21",
			"username": "snapzak",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/3eed6719-ba8d-4d36-8592-c0ea560ddf21/w120.jpg?1437537224"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 4.4,
		"ratingsCount": 45,
		"resolutions": {
			"w640": "https://images03.foap.com/images/ec857066-da97-48ff-b042-2daa5bbb7cdd/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/ec857066-da97-48ff-b042-2daa5bbb7cdd/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Hold onto the moment. Snap - busy streets, the drizzle of Tokyo's peeps always in style. Even their umbrellas are on point",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "ae571642-7db9-4f13-9a87-4d8fa9d0852e",
		"slug": "hold-onto-the-moment-snap-busy-streets-the-drizzle-of-tokyo-s-peeps-always-in-style-even-their-umbrellas-are-on-point",
		"width": 6000,
		"height": 4000,
		"selectedCaption": "Hold onto the moment. Snap - busy streets, the drizzle of Tokyo's peeps always in style. Even their umbrellas are on point"
	},
	{
		"user": {
			"id": "99e573b8-4b24-4a05-85c2-1070b09de8e9",
			"username": "mrquinley",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/99e573b8-4b24-4a05-85c2-1070b09de8e9/w120.?1543949207"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.7422680412371,
		"ratingsCount": 97,
		"resolutions": {
			"w640": "https://images03.foap.com/images/cfb624b5-eb48-4aac-88c0-0495017cf31f/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/cfb624b5-eb48-4aac-88c0-0495017cf31f/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "smiles and love. family shoot",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "2bac814e-4583-42f0-be3c-d0bad47c6e9b",
		"slug": "smiles-and-love-family-shoot",
		"width": 6016,
		"height": 4000,
		"selectedCaption": "smiles and love. family shoot"
	},
	{
		"user": {
			"id": "01194c45-2210-49bb-8f5b-b1a62f4b46be",
			"username": "alexleedy",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/01194c45-2210-49bb-8f5b-b1a62f4b46be/w120.?1462832209"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.81249999999999,
		"ratingsCount": 16,
		"resolutions": {
			"w640": "https://images02.foap.com/images/68600bb2-dfd6-449a-9ac0-98dcda1f31b9/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/68600bb2-dfd6-449a-9ac0-98dcda1f31b9/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Birthday boy ",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "2d4b0a32-a133-4348-a312-da7bc3625d52",
		"slug": "birthday-boy",
		"width": 3724,
		"height": 2483,
		"selectedCaption": "Birthday boy "
	},
	{
		"user": {
			"id": "969f62b1-6007-48c3-ab49-71f3e93abda9",
			"username": "jshiuk",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/969f62b1-6007-48c3-ab49-71f3e93abda9/w120.?1485826557"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.30930930930936,
		"ratingsCount": 666,
		"resolutions": {
			"w640": "https://images03.foap.com/images/3b97dfde-1886-431c-ab9d-0c5369165061/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/3b97dfde-1886-431c-ab9d-0c5369165061/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Skateboarding ",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "2e5e7d36-2960-48cf-9db4-b429ef7a4d86",
		"slug": "skateboarding",
		"width": 4898,
		"height": 3265,
		"selectedCaption": "Skateboarding "
	},
	{
		"user": {
			"id": "672eaffd-f2d7-4b57-b87b-44fc953aeb08",
			"username": "patrickhardy",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/672eaffdf2d74b57b87b44fc953aeb08/x166.jpg?1397975210"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 5,
		"ratingsCount": 12,
		"resolutions": {
			"w640": "https://images01.foap.com/images/8808f452-f7ea-4490-8213-8198c5861fa2/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/8808f452-f7ea-4490-8213-8198c5861fa2/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Two people and a pink wall.",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "65d956ed-f04b-4ea9-b821-a78823dbde44",
		"slug": "two-people-and-a-pink-wall",
		"width": 2172,
		"height": 2895,
		"selectedCaption": "Two people and a pink wall."
	},
	{
		"user": {
			"id": "0f0e6c57-3056-4e66-98fd-17aa10eae1c9",
			"username": "carole.sullivan.puryear",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/0f0e6c57-3056-4e66-98fd-17aa10eae1c9/w120.jpg?1437330612"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.72222222222223,
		"ratingsCount": 18,
		"resolutions": {
			"w640": "https://images02.foap.com/images/263d700d-329c-4826-8168-7aca7a53bf40/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/263d700d-329c-4826-8168-7aca7a53bf40/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Grandma's love",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "4dc7a49c-ef93-4719-818b-56fa1e0538c8",
		"slug": "grandma-s-love",
		"width": 3456,
		"height": 2304,
		"selectedCaption": "Grandma's love"
	},
	{
		"user": {
			"id": "435bad97-66af-4c43-9732-ebf291ce6107",
			"username": "estranged",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/435bad97-66af-4c43-9732-ebf291ce6107/w120.?1464872094"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.73913043478261,
		"ratingsCount": 23,
		"resolutions": {
			"w640": "https://images02.foap.com/images/6da563be-7f33-4ce6-b6a2-6962b18adbc8/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/6da563be-7f33-4ce6-b6a2-6962b18adbc8/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Freckles ",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "07002abb-9400-407d-a041-9a4e79455b2d",
		"slug": "freckles",
		"width": 4256,
		"height": 2832,
		"selectedCaption": "Freckles "
	},
	{
		"user": {
			"id": "5f388c65-552d-40db-ada2-f589bc404f1a",
			"username": "dantes1401",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/5f388c65-552d-40db-ada2-f589bc404f1a/w120.?1445019840"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.68181818181818,
		"ratingsCount": 22,
		"resolutions": {
			"w640": "https://images02.foap.com/images/cd04cca7-04d7-4931-ad7d-be3c45d86f24/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/cd04cca7-04d7-4931-ad7d-be3c45d86f24/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Colors of Life...",
		"suggestedCaption": null,
		"curatedCaption": "Close-up of hand holding colorful pencils ",
		"id": "fd5b7138-2e70-4f59-ab8b-2142bc3c4ee4",
		"slug": "close-up-of-hand-holding-colorful-pencils",
		"width": 4617,
		"height": 3078,
		"selectedCaption": "Close-up of hand holding colorful pencils "
	},
	{
		"user": {
			"id": "a7b71d2e-d1f3-4556-9fa6-35e73f3d19ae",
			"username": "urban.pics",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/a7b71d2e-d1f3-4556-9fa6-35e73f3d19ae/w120.?1454469885"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.57142857142857,
		"ratingsCount": 14,
		"resolutions": {
			"w640": "https://images03.foap.com/images/b94ace50-21df-427d-8e85-b0f5d0205c3c/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/b94ace50-21df-427d-8e85-b0f5d0205c3c/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Manhattan ",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "4d7dbaad-d111-4eb8-80c1-a79b37d56586",
		"slug": "manhattan",
		"width": 2638,
		"height": 1536,
		"selectedCaption": "Manhattan "
	},
	{
		"user": {
			"id": "3d303ca8-4d75-4260-9d54-4264cf29f54d",
			"username": "aix124",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/3d303ca8-4d75-4260-9d54-4264cf29f54d/w120.jpg?1485249136"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.5508474576271,
		"ratingsCount": 118,
		"resolutions": {
			"w640": "https://images01.foap.com/images/75cb980d-6867-4313-a3e0-07d59fd8d97c/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/75cb980d-6867-4313-a3e0-07d59fd8d97c/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Love lock",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "014d9cd2-0ff2-41b8-aeea-99f3f2e6e90e",
		"slug": "love-lock",
		"width": 3264,
		"height": 2448,
		"selectedCaption": "Love lock"
	},
	{
		"user": {
			"id": "95e6c19b-37b0-4603-83c5-d179888e9acd",
			"username": "newnow",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/95e6c19b-37b0-4603-83c5-d179888e9acd/w120.?1475176134"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.41053787047198,
		"ratingsCount": 911,
		"resolutions": {
			"w640": "https://images03.foap.com/images/3dc5462e-6a64-4240-b8a6-ac8d4a48ef10/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/3dc5462e-6a64-4240-b8a6-ac8d4a48ef10/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Capturing street life on a smartphone",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "16bef8d9-d8dd-4084-9213-a7dfd615efd7",
		"slug": "capturing-street-life-on-a-smartphone",
		"width": 6000,
		"height": 4000,
		"selectedCaption": "Capturing street life on a smartphone"
	},
	{
		"user": {
			"id": "07259665-04f8-4b84-b0a6-9e6db45ec1bf",
			"username": "amy_em",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/07259665-04f8-4b84-b0a6-9e6db45ec1bf/w120.?1549863641"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.1869918699187,
		"ratingsCount": 123,
		"resolutions": {
			"w640": "https://images02.foap.com/images/d9552d53-0a11-4c16-ae0d-273d7040a47e/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/d9552d53-0a11-4c16-ae0d-273d7040a47e/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Businesswoman typing in her laptop",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "0035c46b-5568-4046-a290-e7280fed8a24",
		"slug": "businesswoman-typing-in-her-laptop",
		"width": 4928,
		"height": 3264,
		"selectedCaption": "Businesswoman typing in her laptop"
	},
	{
		"user": {
			"id": "05472658-25f3-4dc2-b469-ca8364625ca4",
			"username": "cebas",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/05472658-25f3-4dc2-b469-ca8364625ca4/w120.jpg?1426405233"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.74418604651163,
		"ratingsCount": 43,
		"resolutions": {
			"w640": "https://images01.foap.com/images/d5a99d9a-3d67-4704-bb23-ea25d0bc47b8/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/d5a99d9a-3d67-4704-bb23-ea25d0bc47b8/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Young man at subway station with moving train in background",
		"suggestedCaption": null,
		"curatedCaption": "Man standing in front of moving train on platform",
		"id": "173ba62a-886b-412f-a047-b42050c07426",
		"slug": "man-standing-in-front-of-moving-train-on-platform",
		"width": 3000,
		"height": 2000,
		"selectedCaption": "Man standing in front of moving train on platform"
	},
	{
		"user": {
			"id": "4cdd567e-d3d4-4224-b8c5-4573068a3425",
			"username": "shubhamphotography",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/4cdd567e-d3d4-4224-b8c5-4573068a3425/w120.?1436637187"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.74480712166174,
		"ratingsCount": 337,
		"resolutions": {
			"w640": "https://images03.foap.com/images/f72be941-569c-485e-b7f6-9856f01f9c9d/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/f72be941-569c-485e-b7f6-9856f01f9c9d/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Switzerland ",
		"suggestedCaption": null,
		"curatedCaption": "Bird flying over the mountain during winter",
		"id": "e3e279d6-24df-4743-8f28-14d2bbcb8393",
		"slug": "bird-flying-over-the-mountain-during-winter",
		"width": 4096,
		"height": 2730,
		"selectedCaption": "Bird flying over the mountain during winter"
	},
	{
		"user": {
			"id": "3f0d860d-2544-4cb2-82a7-d4523720d97a",
			"username": "seedjan",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/3f0d860d25444cb282a7d4523720d97a/x166.jpg?1421260466"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.86666666666666,
		"ratingsCount": 15,
		"resolutions": {
			"w640": "https://images01.foap.com/images/02c3fc41-a765-4aba-b443-6f2d4fdf367e/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/02c3fc41-a765-4aba-b443-6f2d4fdf367e/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Red color story : Strawberry watercolor painting.",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "6b0be9bd-5cd0-4416-8c82-5b7dc706a277",
		"slug": "red-color-story-strawberry-watercolor-painting",
		"width": 2448,
		"height": 2448,
		"selectedCaption": "Red color story : Strawberry watercolor painting."
	},
	{
		"user": {
			"id": "86e2a26a-a56a-4e86-8c0c-526be47f4d2d",
			"username": "andreas.wolden",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/86e2a26a-a56a-4e86-8c0c-526be47f4d2d/w120.jpg?1511754154"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.94736842105265,
		"ratingsCount": 114,
		"resolutions": {
			"w640": "https://images03.foap.com/images/ad66f748-bca9-44fc-a4ed-ae3dae4be93b/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/ad66f748-bca9-44fc-a4ed-ae3dae4be93b/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "skier",
		"suggestedCaption": "No Person, Travel, Moon, Landscape, Sunset",
		"curatedCaption": null,
		"id": "844fd8f2-dfbc-43af-a5e6-a55a040c3dcf",
		"slug": "skier",
		"width": 6462,
		"height": 4313,
		"selectedCaption": "skier"
	},
	{
		"user": {
			"id": "86e2a26a-a56a-4e86-8c0c-526be47f4d2d",
			"username": "andreas.wolden",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/86e2a26a-a56a-4e86-8c0c-526be47f4d2d/w120.jpg?1511754154"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.73721945137159,
		"ratingsCount": 3208,
		"resolutions": {
			"w640": "https://images01.foap.com/images/4ffac74f-14ac-4240-8271-432c19cf3c3b/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/4ffac74f-14ac-4240-8271-432c19cf3c3b/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "lines",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "bdecb940-617d-4f40-9aca-82bf9612decf",
		"slug": "lines",
		"width": 3973,
		"height": 4967,
		"selectedCaption": "lines"
	},
	{
		"user": {
			"id": "672eaffd-f2d7-4b57-b87b-44fc953aeb08",
			"username": "patrickhardy",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/672eaffdf2d74b57b87b44fc953aeb08/x166.jpg?1397975210"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.46153846153845,
		"ratingsCount": 26,
		"resolutions": {
			"w640": "https://images02.foap.com/images/6707d15a-b0a2-4536-9059-a62748153af5/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/6707d15a-b0a2-4536-9059-a62748153af5/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Looking down at my daughter. ",
		"suggestedCaption": null,
		"curatedCaption": "A cute daughter holding his father's hand",
		"id": "800c6def-8ea1-45b4-9516-2824f3e335bc",
		"slug": "a-cute-daughter-holding-his-father-s-hand",
		"width": 3024,
		"height": 4032,
		"selectedCaption": "A cute daughter holding his father's hand"
	},
	{
		"user": {
			"id": "005d2c23-59aa-4cae-be6e-dfbc7654351b",
			"username": "davidpenna313",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/005d2c23-59aa-4cae-be6e-dfbc7654351b/w120.?1452847706"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.48148148148147,
		"ratingsCount": 27,
		"resolutions": {
			"w640": "https://images01.foap.com/images/ce0332f6-28be-4a1c-a882-3542cd149684/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/ce0332f6-28be-4a1c-a882-3542cd149684/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Malibu",
		"suggestedCaption": null,
		"curatedCaption": "Two people jumping off boardwalk",
		"id": "3904e79e-c0b3-49c4-ad9c-f854fa49f810",
		"slug": "two-people-jumping-off-boardwalk",
		"width": 3264,
		"height": 2177,
		"selectedCaption": "Two people jumping off boardwalk"
	},
	{
		"user": {
			"id": "ef1e3acf-f862-4021-8dd0-64c7103dc1d3",
			"username": "michaelii",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/ef1e3acf-f862-4021-8dd0-64c7103dc1d3/w120.?1470846602"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 5,
		"ratingsCount": 1,
		"resolutions": {
			"w640": "https://images03.foap.com/images/c98faf49-12ec-4647-945c-b7fd3c10087a/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/c98faf49-12ec-4647-945c-b7fd3c10087a/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "People, Man, Portrait, Adult, Outdoors",
		"curatedCaption": null,
		"id": "82ba2d00-76de-4437-9d26-8b9a5b533b8e",
		"slug": "",
		"width": 2448,
		"height": 3264,
		"selectedCaption": "People, Man, Portrait, Adult, Outdoors"
	},
	{
		"user": {
			"id": "dd55e6c5-b5d4-4770-977b-8f94c7d313ec",
			"username": "akshaykerlekar",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/dd55e6c5-b5d4-4770-977b-8f94c7d313ec/w120.jpg?1445352667"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.59238363892797,
		"ratingsCount": 2127,
		"resolutions": {
			"w640": "https://images03.foap.com/images/c5981248-0673-454b-9592-71672060da55/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/c5981248-0673-454b-9592-71672060da55/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "It's a prime view. Clicked on 50mm prime Lense ",
		"suggestedCaption": "Lens, Man, Portrait, Face, Studio",
		"curatedCaption": "Man holding camera lens over the eyes",
		"id": "2a67a20f-f29f-411a-b949-adb38e6f3c6a",
		"slug": "man-holding-camera-lens-over-the-eyes",
		"width": 3277,
		"height": 4096,
		"selectedCaption": "Man holding camera lens over the eyes"
	},
	{
		"user": {
			"id": "2ccf136b-4fea-4e84-a9d6-c9fed23bd36f",
			"username": "viktorholm",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/2ccf136b4fea4e84a9d6c9fed23bd36f/x166.jpg?1408573858"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.73295454545449,
		"ratingsCount": 528,
		"resolutions": {
			"w640": "https://images01.foap.com/images/05676050aef84b1abc694b1704eee634/original.jpg?filename=web_review&dw=640",
			"w1920": "https://images01.foap.com/images/05676050aef84b1abc694b1704eee634/original.jpg?filename=web_review&dw=1920"
		},
		"caption": "Flying lady",
		"suggestedCaption": "Architecture, Window, House, Building, People",
		"curatedCaption": null,
		"id": "05676050-aef8-4b1a-bc69-4b1704eee634",
		"slug": "flying-lady",
		"width": 2448,
		"height": 2448,
		"selectedCaption": "Flying lady"
	},
	{
		"user": {
			"id": "51c5cbff-1d79-4e14-a06a-5c902316b95c",
			"username": "lelia_milaya",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/51c5cbff-1d79-4e14-a06a-5c902316b95c/w120.?1576102571"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.61240310077513,
		"ratingsCount": 387,
		"resolutions": {
			"w640": "https://images02.foap.com/images/9600efc0-6d00-4749-940c-cffac0df401f/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/9600efc0-6d00-4749-940c-cffac0df401f/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "pool, leisure, vacation, swimming, swim, swimmer, fun, happy, cool, summer, carefree, children, child, childhood, sun, sunbathing, sunglasses, sun, sunglasses, sunscreen, life preserver, flip flops Slippers, Slippers , hot, diving, Egypt, Turkey, Thailand, UAE, Greece, Cyprus, Turkey, cocktail, coffee, cappuccino, Muslims, Muslim, blue, water, clean, transparent, freshness, beach, happy hour, booze, alcohol, to Shine, beautiful, weekend, yacht, fashion, fashionable, stylish, style, clothing, nationality, black , Africa, African, African, brown, Metis, girl, boy, winter, new year, Christmas, celebration, warm, cozy, bright, colored, heated, heated, Sunny, day, time, journey, crystal, azure, beach, beach, crystal, girl, blonde, brunette, blue, turquoise,",
		"suggestedCaption": null,
		"curatedCaption": "Inflatable ring floating on water",
		"id": "9d72d28d-9771-405f-b074-b4ecffa8594d",
		"slug": "inflatable-ring-floating-on-water",
		"width": 2448,
		"height": 2448,
		"selectedCaption": "Inflatable ring floating on water"
	},
	{
		"user": {
			"id": "23af0644-0028-489c-bb96-9fcc4a129c9b",
			"username": "baseballgrandma",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/23af0644-0028-489c-bb96-9fcc4a129c9b/w120.jpg?1569159521"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.9795918367347,
		"ratingsCount": 49,
		"resolutions": {
			"w640": "https://images03.foap.com/images/417c0ab4-41a6-4b4c-993c-68c5250a8e00/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/417c0ab4-41a6-4b4c-993c-68c5250a8e00/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Reflection of one building within another!",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "8248f3ff-aa4d-46f4-b30f-16df53391031",
		"slug": "reflection-of-one-building-within-another",
		"width": 5312,
		"height": 2988,
		"selectedCaption": "Reflection of one building within another!"
	},
	{
		"user": {
			"id": "3f0d860d-2544-4cb2-82a7-d4523720d97a",
			"username": "seedjan",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/3f0d860d25444cb282a7d4523720d97a/x166.jpg?1421260466"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.63636363636365,
		"ratingsCount": 22,
		"resolutions": {
			"w640": "https://images01.foap.com/images/e88d2a85-727e-4ea1-9a5f-d01f1269eef3/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/e88d2a85-727e-4ea1-9a5f-d01f1269eef3/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Purple hull peas collage. Purple hull peas collage on a white paper background ",
		"suggestedCaption": null,
		"curatedCaption": "Purple hull peas collage on a white background",
		"id": "76e66074-ee86-4719-a2c9-fe10c6b31456",
		"slug": "purple-hull-peas-collage-on-a-white-background",
		"width": 2448,
		"height": 3264,
		"selectedCaption": "Purple hull peas collage on a white background"
	},
	{
		"user": {
			"id": "506df335-4cf6-435b-86b8-fad8765e853f",
			"username": "alex.dulin.3",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/506df335-4cf6-435b-86b8-fad8765e853f/w120.?1484209349"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.8062015503876,
		"ratingsCount": 129,
		"resolutions": {
			"w640": "https://images01.foap.com/images/3d64e854-0a55-435d-9ec7-9c36abd41a71/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/3d64e854-0a55-435d-9ec7-9c36abd41a71/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Jump!",
		"suggestedCaption": "People, Action, Adult, One, Competition",
		"curatedCaption": null,
		"id": "dc877915-6bdf-4259-9a79-678bac0e3466",
		"slug": "jump",
		"width": 1647,
		"height": 1647,
		"selectedCaption": "Jump!"
	},
	{
		"user": {
			"id": "277c9b3e-a920-4a86-858b-257bbd9a448e",
			"username": "kshapley",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/277c9b3e-a920-4a86-858b-257bbd9a448e/w120.?1575851063"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.54241908006809,
		"ratingsCount": 2935,
		"resolutions": {
			"w640": "https://images02.foap.com/images/be091ec5-5411-4bbf-8533-f31cdb8bfc92/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/be091ec5-5411-4bbf-8533-f31cdb8bfc92/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Blue tourist boats moored for the end of season at Arashiyama. ",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "6bb89e14-612a-4938-a09a-461212deee66",
		"slug": "blue-tourist-boats-moored-for-the-end-of-season-at-arashiyama",
		"width": 4096,
		"height": 2730,
		"selectedCaption": "Blue tourist boats moored for the end of season at Arashiyama. "
	},
	{
		"user": {
			"id": "0f98f202-f0c0-4420-86c4-a8ede1ef141f",
			"username": "bri.d",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/0f98f202-f0c0-4420-86c4-a8ede1ef141f/w120.?1491713681"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 4.72968749999999,
		"ratingsCount": 640,
		"resolutions": {
			"w640": "https://images03.foap.com/images/4d5b43ea-65b6-49b5-bc3b-aee298db7a02/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/4d5b43ea-65b6-49b5-bc3b-aee298db7a02/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "Cute, Child, Girl, Woman, Fun",
		"curatedCaption": null,
		"id": "26853b69-e5a2-45ef-bd0b-e2eb3977cf71",
		"slug": "",
		"width": 3024,
		"height": 3779,
		"selectedCaption": "Cute, Child, Girl, Woman, Fun"
	},
	{
		"user": {
			"id": "efbfd324-7fc8-4e0e-b778-08254bb81e2c",
			"username": "sarinita",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/efbfd324-7fc8-4e0e-b778-08254bb81e2c/w120.jpg?1477876433"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.91666666666666,
		"ratingsCount": 24,
		"resolutions": {
			"w640": "https://images01.foap.com/images/ccfc3d7e-2875-447a-9cd2-63460ccc364c/original.jpeg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/ccfc3d7e-2875-447a-9cd2-63460ccc364c/original.jpeg?filename=w1920&dw=1920"
		},
		"caption": "white chair",
		"suggestedCaption": "Minimalism, Light, Room, Minimalist, Family",
		"curatedCaption": null,
		"id": "70690609-5995-4a7b-b502-4e4a40b1bf72",
		"slug": "white-chair",
		"width": 3024,
		"height": 4032,
		"selectedCaption": "white chair"
	},
	{
		"user": {
			"id": "86e2a26a-a56a-4e86-8c0c-526be47f4d2d",
			"username": "andreas.wolden",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/86e2a26a-a56a-4e86-8c0c-526be47f4d2d/w120.jpg?1511754154"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 4.79029850746268,
		"ratingsCount": 1340,
		"resolutions": {
			"w640": "https://images02.foap.com/images/310a7bb6-0375-4ed1-b1ad-cab7879843e3/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/310a7bb6-0375-4ed1-b1ad-cab7879843e3/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "No Person, Mountain, Travel, Landscape, Outdoors",
		"curatedCaption": null,
		"id": "4cc3a8f1-dc53-4346-8f14-1b05b7a358e8",
		"slug": "",
		"width": 7360,
		"height": 4912,
		"selectedCaption": "No Person, Mountain, Travel, Landscape, Outdoors"
	},
	{
		"user": {
			"id": "99ca00f2-6827-4f6d-8f69-575a49f8af54",
			"username": "t_wethand",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/99ca00f268274f6d8f69575a49f8af54/x166.jpg?1408106208"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.56899224806194,
		"ratingsCount": 1935,
		"resolutions": {
			"w640": "https://images01.foap.com/images/e5053da357a047b78b750b1ba53e3180/original.jpg?filename=web_review&dw=640",
			"w1920": "https://images01.foap.com/images/e5053da357a047b78b750b1ba53e3180/original.jpg?filename=web_review&dw=1920"
		},
		"caption": "smile",
		"suggestedCaption": "Child, People, Street, Woman, Outdoors",
		"curatedCaption": null,
		"id": "e5053da3-57a0-47b7-8b75-0b1ba53e3180",
		"slug": "smile",
		"width": 2300,
		"height": 1536,
		"selectedCaption": "smile"
	},
	{
		"user": {
			"id": "64839f0a-3e5e-4b0e-b113-4a3cf1cffadc",
			"username": "priscilaluna",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/64839f0a-3e5e-4b0e-b113-4a3cf1cffadc/w120.jpg?1443478438"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.24649859943981,
		"ratingsCount": 1071,
		"resolutions": {
			"w640": "https://images01.foap.com/images/20cfbbba-323b-4df1-90cb-f2b6fed1cee5/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/20cfbbba-323b-4df1-90cb-f2b6fed1cee5/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Smile",
		"suggestedCaption": "Woman, People, Portrait, Girl, Fashion",
		"curatedCaption": "Smiling woman wearing sunglasses",
		"id": "e34363c3-05d5-4098-82f6-7a57474b63e4",
		"slug": "smiling-woman-wearing-sunglasses",
		"width": 3240,
		"height": 2160,
		"selectedCaption": "Smiling woman wearing sunglasses"
	},
	{
		"user": {
			"id": "fde580a8-a0b4-45ba-8f95-cf869a263c3b",
			"username": "piepernunes",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/fde580a8a0b445ba8f95cf869a263c3b/x166.jpg?1368006114"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.53571428571429,
		"ratingsCount": 28,
		"resolutions": {
			"w640": "https://images02.foap.com/images/ce6d5361-b0e4-4f28-b005-9524fb07adbe/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/ce6d5361-b0e4-4f28-b005-9524fb07adbe/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Smile",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "1c6176de-3079-46cf-a2ae-c8452650a7ed",
		"slug": "smile",
		"width": 2000,
		"height": 1239,
		"selectedCaption": "Smile"
	},
	{
		"user": {
			"id": "5c604d74-7d81-45ae-bdb8-9b62dac63e24",
			"username": "mohd.hakimi.haslan",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/5c604d74-7d81-45ae-bdb8-9b62dac63e24/w120.?1478834022"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 5,
		"ratingsCount": 1,
		"resolutions": {
			"w640": "https://images01.foap.com/images/cc22a73f-28d1-41e3-91ba-89fb8886de92/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/cc22a73f-28d1-41e3-91ba-89fb8886de92/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Smile",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "b4b02524-310d-4b1f-bc5c-6ca079967700",
		"slug": "smile",
		"width": 2576,
		"height": 2576,
		"selectedCaption": "Smile"
	},
	{
		"user": {
			"id": "c44b1e0f-316a-42c2-9230-4f011913df51",
			"username": "suebarr",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/c44b1e0f-316a-42c2-9230-4f011913df51/w120.?1469882855"
			}
		},
		"license": "Commercial",
		"price": 60,
		"averageRating": 4.54237288135595,
		"ratingsCount": 885,
		"resolutions": {
			"w640": "https://images03.foap.com/images/39ff9f6a-3ec2-446b-b129-16af637dc933/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/39ff9f6a-3ec2-446b-b129-16af637dc933/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Road trip",
		"suggestedCaption": "Vehicle, Car, Transportation System, Pet, Mammal",
		"curatedCaption": null,
		"id": "53dae930-70cd-49b2-b04c-20caee63c0f7",
		"slug": "road-trip",
		"width": 1860,
		"height": 1140,
		"selectedCaption": "Road trip"
	},
	{
		"user": {
			"id": "a5819f3b-b5db-4bb6-90ab-b5b7d5ccf7ee",
			"username": "thejosiahmcdonald",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/a5819f3b-b5db-4bb6-90ab-b5b7d5ccf7ee/w120.?1539308505"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 5,
		"ratingsCount": 5,
		"resolutions": {
			"w640": "https://images03.foap.com/images/8db10d2a-4c07-4604-921e-98eb10654a4a/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/8db10d2a-4c07-4604-921e-98eb10654a4a/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Korean Mountain View!",
		"suggestedCaption": "People, Tree, Two, Adult, Landscape",
		"curatedCaption": null,
		"id": "ca7f0b40-8d66-4313-80b1-99184386f061",
		"slug": "korean-mountain-view",
		"width": 3264,
		"height": 2448,
		"selectedCaption": "Korean Mountain View!"
	},
	{
		"user": {
			"id": "ff8f3d70-6891-45a8-92d2-349f517c7670",
			"username": "sasuphoto",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/ff8f3d70-6891-45a8-92d2-349f517c7670/w120.JPG?1495407819"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.90000000000001,
		"ratingsCount": 20,
		"resolutions": {
			"w640": "https://images01.foap.com/images/ae590a4b-9d2e-4989-a5fc-34a4606c87a7/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/ae590a4b-9d2e-4989-a5fc-34a4606c87a7/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Red breakfast. Jam and strawberry with bread.",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "b22d8b61-0415-493e-a878-91840b03674c",
		"slug": "red-breakfast-jam-and-strawberry-with-bread",
		"width": 4479,
		"height": 2986,
		"selectedCaption": "Red breakfast. Jam and strawberry with bread."
	},
	{
		"user": {
			"id": "db0a95cf-31db-44f1-8421-3e27f5c83fb6",
			"username": "mcarley",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/db0a95cf-31db-44f1-8421-3e27f5c83fb6/w120.jpg?1538584346"
			}
		},
		"license": "Commercial",
		"price": 60,
		"averageRating": 4.94117647058825,
		"ratingsCount": 17,
		"resolutions": {
			"w640": "https://images01.foap.com/images/2130cd4e-ef2c-40d9-8a7c-df72fbb8066a/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/2130cd4e-ef2c-40d9-8a7c-df72fbb8066a/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Chocolate lab jumping into clear Idaho mountain lake with forest fire cloud billowing in the background. ",
		"suggestedCaption": "Water, Lake, Reflection, Nature, Sky",
		"curatedCaption": null,
		"id": "a0419e9f-7319-4dda-a778-0c9ef70ae711",
		"slug": "chocolate-lab-jumping-into-clear-idaho-mountain-lake-with-forest-fire-cloud-billowing-in-the-background",
		"width": 4032,
		"height": 3024,
		"selectedCaption": "Chocolate lab jumping into clear Idaho mountain lake with forest fire cloud billowing in the background. "
	},
	{
		"user": {
			"id": "a1fab01f-1490-4d56-961e-1583e5710265",
			"username": "ashleymariexo",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/a1fab01f-1490-4d56-961e-1583e5710265/w120.?1513310917"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.92307692307692,
		"ratingsCount": 13,
		"resolutions": {
			"w640": "https://images02.foap.com/images/52e2f016-0560-4e13-9c23-8e699ac1c17b/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/52e2f016-0560-4e13-9c23-8e699ac1c17b/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Just a girl loving the outdoors. ",
		"suggestedCaption": "Nature, Child, Outdoors, Summer, Beautiful",
		"curatedCaption": null,
		"id": "9fb5ee4b-9e33-4580-8a1f-8dadbb892f28",
		"slug": "just-a-girl-loving-the-outdoors",
		"width": 2048,
		"height": 1365,
		"selectedCaption": "Just a girl loving the outdoors. "
	},
	{
		"user": {
			"id": "48d4152b-ab80-46e1-8362-d501b82d3b8b",
			"username": "bbaysphoto",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/48d4152b-ab80-46e1-8362-d501b82d3b8b/w120.?1508286117"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.95238095238096,
		"ratingsCount": 21,
		"resolutions": {
			"w640": "https://images01.foap.com/images/9535dfca-d38d-48d4-bd66-494441bad478/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/9535dfca-d38d-48d4-bd66-494441bad478/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Leisure ",
		"suggestedCaption": "People, Adult, Woman, Outdoors, Two",
		"curatedCaption": null,
		"id": "8f1df0fb-4a1f-4744-b77a-d402fd104072",
		"slug": "leisure",
		"width": 2048,
		"height": 1359,
		"selectedCaption": "Leisure "
	},
	{
		"user": {
			"id": "85961ab5-0852-4746-b82e-93a1605e8575",
			"username": "rickycs",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/85961ab5-0852-4746-b82e-93a1605e8575/w120.?1464206539"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.96296296296296,
		"ratingsCount": 27,
		"resolutions": {
			"w640": "https://images03.foap.com/images/375fa5b0-fb07-414a-83c9-af779c0b39be/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/375fa5b0-fb07-414a-83c9-af779c0b39be/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "love",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "e70fef50-31a3-47cf-84c8-fde34ab846f4",
		"slug": "love",
		"width": 2000,
		"height": 1333,
		"selectedCaption": "love"
	},
	{
		"user": {
			"id": "5e32c68d-1ead-4dcc-8cd5-a670d21f5f00",
			"username": "leischu",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/5e32c68d-1ead-4dcc-8cd5-a670d21f5f00/w120.?1501181006"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.625,
		"ratingsCount": 8,
		"resolutions": {
			"w640": "https://images01.foap.com/images/b2fe5faa-e6fd-42e8-b370-0f195d452646/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/b2fe5faa-e6fd-42e8-b370-0f195d452646/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Wild flowers for wild hearts ",
		"suggestedCaption": "Flower, Nature, Landscape, Outdoors, Summer",
		"curatedCaption": null,
		"id": "6c85cf49-9090-4241-bc36-0383842b73d7",
		"slug": "wild-flowers-for-wild-hearts",
		"width": 6000,
		"height": 4000,
		"selectedCaption": "Wild flowers for wild hearts "
	}
];

/***/ }),

/***/ 3165:
/***/ (function(module, exports) {

module.exports = [
	{
		"user": {
			"id": "3f0d860d-2544-4cb2-82a7-d4523720d97a",
			"username": "seedjan",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/3f0d860d25444cb282a7d4523720d97a/x166.jpg?1421260466"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 5,
		"ratingsCount": 1,
		"resolutions": {
			"w640": "https://images01.foap.com/images/d43aa7cc-c526-43c6-94e8-0f1e2bb259a6/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/d43aa7cc-c526-43c6-94e8-0f1e2bb259a6/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "Food, Plate, Dish, Healthy, Cup",
		"curatedCaption": "Healthy breakfast ready to eat",
		"id": "fcde2c62-4ad1-4fdb-be51-6bf42ffdd4ff",
		"slug": "healthy-breakfast-ready-to-eat",
		"width": 2447,
		"height": 2447,
		"userId": "fcde2c62-4ad1-4fdb-be51-6bf42ffdd4ff",
		"selectedCaption": "Healthy breakfast ready to eat"
	},
	{
		"user": {
			"id": "2704c671-01ec-4ae5-9aad-a906d2fb423f",
			"username": "djmon1que",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/2704c671-01ec-4ae5-9aad-a906d2fb423f/w120.?1475435139"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.90322580645162,
		"ratingsCount": 62,
		"resolutions": {
			"w640": "https://images02.foap.com/images/5acab548-b72b-4d4e-97d8-2c87b0650211/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/5acab548-b72b-4d4e-97d8-2c87b0650211/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Fruits",
		"suggestedCaption": null,
		"curatedCaption": "Person's hand picking orange",
		"id": "6540e2e1-4153-429c-a458-e14ac8a775f7",
		"slug": "person-s-hand-picking-orange",
		"width": 3001,
		"height": 2251,
		"userId": "6540e2e1-4153-429c-a458-e14ac8a775f7",
		"selectedCaption": "Person's hand picking orange"
	},
	{
		"user": {
			"id": "11b64c92-10b4-416f-ab8f-9b68fba9e418",
			"username": "lesiavalentain",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/11b64c92-10b4-416f-ab8f-9b68fba9e418/w120.?1564494743"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.80000000000002,
		"ratingsCount": 30,
		"resolutions": {
			"w640": "https://images01.foap.com/images/e3b068f0-bd36-4f98-adf2-00ac9d278ff9/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/e3b068f0-bd36-4f98-adf2-00ac9d278ff9/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Girl in a cafe",
		"suggestedCaption": null,
		"curatedCaption": "Women in a cafe",
		"id": "32140ec6-0041-41a4-850e-c335ca2c2aa5",
		"slug": "women-in-a-cafe",
		"width": 2560,
		"height": 1707,
		"userId": "32140ec6-0041-41a4-850e-c335ca2c2aa5",
		"selectedCaption": "Women in a cafe"
	},
	{
		"user": {
			"id": "94687212-dd14-42bc-af0a-2f7fc2fbc505",
			"username": "best_helen",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/94687212-dd14-42bc-af0a-2f7fc2fbc505/w120.jpg?1503043943"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.67218543046365,
		"ratingsCount": 906,
		"resolutions": {
			"w640": "https://images02.foap.com/images/4603e2d9-5b35-4db1-8c45-1231e0585cea/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/4603e2d9-5b35-4db1-8c45-1231e0585cea/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "cherry on gray plate above",
		"suggestedCaption": null,
		"curatedCaption": "Cherries in the plate",
		"id": "c64e28ef-c42b-41b5-a5e1-1c50035d0433",
		"slug": "cherries-in-the-plate",
		"width": 2624,
		"height": 3280,
		"userId": "c64e28ef-c42b-41b5-a5e1-1c50035d0433",
		"selectedCaption": "Cherries in the plate"
	},
	{
		"user": {
			"id": "7c2655d9-d211-4401-8fff-e2127d240469",
			"username": "daniellebhogan",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/7c2655d9-d211-4401-8fff-e2127d240469/w120.jpg?1521209418"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.71153846153844,
		"ratingsCount": 52,
		"resolutions": {
			"w640": "https://images02.foap.com/images/0b051f2a-8fc0-423b-bf06-41526ccff7c3/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/0b051f2a-8fc0-423b-bf06-41526ccff7c3/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "A cute fluffy cat",
		"suggestedCaption": "Cat, Cute, Portrait, Eye, Pet",
		"curatedCaption": "Portrait of cat",
		"id": "3fdfbdae-7340-4c44-ad2f-9d3375160e80",
		"slug": "portrait-of-cat",
		"width": 5760,
		"height": 3840,
		"userId": "3fdfbdae-7340-4c44-ad2f-9d3375160e80",
		"selectedCaption": "Portrait of cat"
	},
	{
		"user": {
			"id": "5487f1f9-d6ca-4a11-8223-82f13561aedb",
			"username": "deanna93",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/5487f1f9-d6ca-4a11-8223-82f13561aedb/w120.?1478724601"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.79096045197739,
		"ratingsCount": 177,
		"resolutions": {
			"w640": "https://images01.foap.com/images/0ce9a9cc-2c71-4591-a895-37ccfc32d9dc/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/0ce9a9cc-2c71-4591-a895-37ccfc32d9dc/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Tapas for two ",
		"suggestedCaption": null,
		"curatedCaption": "Tapas on table",
		"id": "ab479da6-8a74-4aa5-af17-9d6b3d0800f9",
		"slug": "tapas-on-table",
		"width": 3149,
		"height": 2223,
		"userId": "ab479da6-8a74-4aa5-af17-9d6b3d0800f9",
		"selectedCaption": "Tapas on table"
	},
	{
		"user": {
			"id": "81654e89-67c7-490f-a434-62685f0a12b5",
			"username": "jamie1young1",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/81654e89-67c7-490f-a434-62685f0a12b5/w120.?1492182525"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.65078236130864,
		"ratingsCount": 1406,
		"resolutions": {
			"w640": "https://images03.foap.com/images/748ec1e1-4803-4635-8f9a-54f27077ec15/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/748ec1e1-4803-4635-8f9a-54f27077ec15/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "1, 2, 3 jump!",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "ef9f3968-dcef-4af6-8d2d-05a71a9dc378",
		"slug": "1-2-3-jump",
		"width": 4752,
		"height": 3168,
		"userId": "ef9f3968-dcef-4af6-8d2d-05a71a9dc378",
		"selectedCaption": "1, 2, 3 jump!"
	},
	{
		"user": {
			"id": "86e2a26a-a56a-4e86-8c0c-526be47f4d2d",
			"username": "andreas.wolden",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/86e2a26a-a56a-4e86-8c0c-526be47f4d2d/w120.jpg?1511754154"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.97500000000002,
		"ratingsCount": 40,
		"resolutions": {
			"w640": "https://images01.foap.com/images/bfa4cd9d-50ae-490a-9c71-7a1964b3ca50/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/bfa4cd9d-50ae-490a-9c71-7a1964b3ca50/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "hiking",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "1487fdce-bf4d-4d82-b7c2-5d499662ae48",
		"slug": "hiking",
		"width": 7360,
		"height": 4912,
		"userId": "1487fdce-bf4d-4d82-b7c2-5d499662ae48",
		"selectedCaption": "hiking"
	},
	{
		"user": {
			"id": "672eaffd-f2d7-4b57-b87b-44fc953aeb08",
			"username": "patrickhardy",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/672eaffdf2d74b57b87b44fc953aeb08/x166.jpg?1397975210"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.82352941176471,
		"ratingsCount": 17,
		"resolutions": {
			"w640": "https://images02.foap.com/images/46f6e98c-c299-4e22-ba27-4dcdaea850a9/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/46f6e98c-c299-4e22-ba27-4dcdaea850a9/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Barista pouring latte art. ",
		"suggestedCaption": null,
		"curatedCaption": "Barista pouring latte art",
		"id": "6990c74b-e060-478c-9888-d3847e5fdcda",
		"slug": "barista-pouring-latte-art",
		"width": 2611,
		"height": 2602,
		"userId": "6990c74b-e060-478c-9888-d3847e5fdcda",
		"selectedCaption": "Barista pouring latte art"
	},
	{
		"user": {
			"id": "a69b11d6-a725-43b0-9f2e-db51dff4719b",
			"username": "junpinzon",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/a69b11d6-a725-43b0-9f2e-db51dff4719b/w120.jpg?1449500876"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 4.65909090909092,
		"ratingsCount": 44,
		"resolutions": {
			"w640": "https://images01.foap.com/images/4bde357f-a787-4ed3-9f61-34cb86af9fff/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/4bde357f-a787-4ed3-9f61-34cb86af9fff/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "man writing on a desk in a basement",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "554344d7-9c96-46c7-b471-b0c46c01cc50",
		"slug": "man-writing-on-a-desk-in-a-basement",
		"width": 4032,
		"height": 3024,
		"userId": "554344d7-9c96-46c7-b471-b0c46c01cc50",
		"selectedCaption": "man writing on a desk in a basement"
	},
	{
		"user": null,
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.56451612903226,
		"ratingsCount": 248,
		"resolutions": {
			"w640": "https://images03.foap.com/images/f0b012ff37e445309d243ce5999fdf07/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/f0b012ff37e445309d243ce5999fdf07/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "sky happy smile air by katringomonova",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "f0b012ff-37e4-4530-9d24-3ce5999fdf07",
		"slug": "sky-happy-smile-air-by-katringomonova",
		"width": 2304,
		"height": 1536,
		"userId": "f0b012ff-37e4-4530-9d24-3ce5999fdf07",
		"selectedCaption": "sky happy smile air by katringomonova"
	},
	{
		"user": {
			"id": "beab1a5d-dbc4-49d8-a671-87cdff1dc1f7",
			"username": "ventanamedia",
			"avatar": {
				"w120": "https://cdn2.foap.com/users/beab1a5ddbc449d8a67187cdff1dc1f7/x166.jpg?1387738369"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 3.94827586206897,
		"ratingsCount": 58,
		"resolutions": {
			"w640": "https://images01.foap.com/images/a55decfa3c7f4f639e8762f60a5c8046/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/a55decfa3c7f4f639e8762f60a5c8046/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "valencia spain sport street road by ventanamedia",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "a55decfa-3c7f-4f63-9e87-62f60a5c8046",
		"slug": "valencia-spain-sport-street-road-by-ventanamedia",
		"width": 5184,
		"height": 3295,
		"userId": "a55decfa-3c7f-4f63-9e87-62f60a5c8046",
		"selectedCaption": "valencia spain sport street road by ventanamedia"
	},
	{
		"user": {
			"id": "bf2a9559-7464-466b-b6b5-719e8bdac69e",
			"username": "suryaganesh.m",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/bf2a9559-7464-466b-b6b5-719e8bdac69e/w120.?1568719677"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.37406855439643,
		"ratingsCount": 671,
		"resolutions": {
			"w640": "https://images02.foap.com/images/d31d1fd2-8175-4f9d-8c61-642b0a215e59/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/d31d1fd2-8175-4f9d-8c61-642b0a215e59/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Happy childhood days",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "045db46f-1563-41d8-9119-83ab8eb08272",
		"slug": "happy-childhood-days",
		"width": 5184,
		"height": 3456,
		"userId": "045db46f-1563-41d8-9119-83ab8eb08272",
		"selectedCaption": "Happy childhood days"
	},
	{
		"user": {
			"id": "810d8c3b-c44a-4534-9dfe-754611c38c69",
			"username": "mbocast",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/810d8c3b-c44a-4534-9dfe-754611c38c69/w120.?1472055011"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.92063492063492,
		"ratingsCount": 63,
		"resolutions": {
			"w640": "https://images02.foap.com/images/1ced8173-44ec-418e-b22c-8b02efb06776/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/1ced8173-44ec-418e-b22c-8b02efb06776/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Silly Dog",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "977cd7aa-5c5c-419f-b736-036a1bbc92de",
		"slug": "silly-dog",
		"width": 2304,
		"height": 1536,
		"userId": "977cd7aa-5c5c-419f-b736-036a1bbc92de",
		"selectedCaption": "Silly Dog"
	},
	{
		"user": {
			"id": "e86cee6a-45cc-4622-af13-243b020e5620",
			"username": "akilles",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/e86cee6a-45cc-4622-af13-243b020e5620/w120.?1432291933"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.95081967213118,
		"ratingsCount": 61,
		"resolutions": {
			"w640": "https://images01.foap.com/images/25796529-a8a7-4f47-93fa-f4eec72a1a20/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images01.foap.com/images/25796529-a8a7-4f47-93fa-f4eec72a1a20/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Fluffy cat",
		"suggestedCaption": "Animal, Cute, Pet, Mammal, Young",
		"curatedCaption": "Close-up of lying cat",
		"id": "c127d190-2d8d-4383-8866-a4dab4d8d50f",
		"slug": "close-up-of-lying-cat",
		"width": 3670,
		"height": 2492,
		"userId": "c127d190-2d8d-4383-8866-a4dab4d8d50f",
		"selectedCaption": "Close-up of lying cat"
	},
	{
		"user": {
			"id": "11664036-e9f6-4be4-a7e1-91ce90e75efc",
			"username": "susanne.jordan",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/11664036-e9f6-4be4-a7e1-91ce90e75efc/w120.jpg?1424524273"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.70833333333332,
		"ratingsCount": 24,
		"resolutions": {
			"w640": "https://images02.foap.com/images/3d15f2e4-fe50-432a-b5a2-56bd83db85ad/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/3d15f2e4-fe50-432a-b5a2-56bd83db85ad/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "The girl and the puppy! ",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "8ec14ff4-370c-44b3-a132-e47ed5d32886",
		"slug": "the-girl-and-the-puppy",
		"width": 2448,
		"height": 3264,
		"userId": "8ec14ff4-370c-44b3-a132-e47ed5d32886",
		"selectedCaption": "The girl and the puppy! "
	},
	{
		"user": {
			"id": "27beeeca-abdf-4791-9ae3-d6c674d1b699",
			"username": "voss",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/27beeeca-abdf-4791-9ae3-d6c674d1b699/w120.?1474622251"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.81818181818182,
		"ratingsCount": 22,
		"resolutions": {
			"w640": "https://images03.foap.com/images/3fc7a849-25d3-49ce-9f76-b31269c6d1b7/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/3fc7a849-25d3-49ce-9f76-b31269c6d1b7/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Snowy Mountains",
		"suggestedCaption": null,
		"curatedCaption": "View of frozen trees",
		"id": "3882bd11-f4b8-4c1c-b7bb-770809776ed1",
		"slug": "view-of-frozen-trees",
		"width": 3840,
		"height": 2160,
		"userId": "3882bd11-f4b8-4c1c-b7bb-770809776ed1",
		"selectedCaption": "View of frozen trees"
	},
	{
		"user": {
			"id": "0fb395f4-e1b1-4b01-96eb-fbf54d008f8f",
			"username": "catherine.douma",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/0fb395f4-e1b1-4b01-96eb-fbf54d008f8f/w120.jpg?1521469680"
			}
		},
		"license": "Editorial",
		"price": 10,
		"averageRating": 4.79411764705883,
		"ratingsCount": 34,
		"resolutions": {
			"w640": "https://images02.foap.com/images/da109a81-87dd-410a-af47-6641261edd72/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/da109a81-87dd-410a-af47-6641261edd72/original.jpg?filename=w1920&dw=1920"
		},
		"caption": null,
		"suggestedCaption": "Bed, Family, Bedroom, Child, Pillow",
		"curatedCaption": null,
		"id": "647d78ff-ca03-4ba5-a9d3-7df464f85ef8",
		"slug": "",
		"width": 4096,
		"height": 2730,
		"userId": "647d78ff-ca03-4ba5-a9d3-7df464f85ef8",
		"selectedCaption": "Bed, Family, Bedroom, Child, Pillow"
	},
	{
		"user": {
			"id": "00c66192-3285-41aa-a9aa-2a64aa69540d",
			"username": "woffka_ru",
			"avatar": {
				"w120": "https://cdn3.foap.com/users/00c66192-3285-41aa-a9aa-2a64aa69540d/w120.jpg?1533232402"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.2,
		"ratingsCount": 15,
		"resolutions": {
			"w640": "https://images03.foap.com/images/f108eb6c-ba3f-4fa5-b9d9-240cb21d71b1/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images03.foap.com/images/f108eb6c-ba3f-4fa5-b9d9-240cb21d71b1/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Happiness",
		"suggestedCaption": "Outdoors, People, Summer, Two, Woman",
		"curatedCaption": null,
		"id": "42b1d125-23ce-43c8-8d0c-d594e82b0896",
		"slug": "happiness",
		"width": 3344,
		"height": 2035,
		"userId": "42b1d125-23ce-43c8-8d0c-d594e82b0896",
		"selectedCaption": "Happiness"
	},
	{
		"user": {
			"id": "83c1cc11-dfee-4f0d-ada3-a280d8c759a2",
			"username": "maryg0r0und",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/83c1cc11-dfee-4f0d-ada3-a280d8c759a2/w120.?1494313356"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.42857142857142,
		"ratingsCount": 14,
		"resolutions": {
			"w640": "https://images02.foap.com/images/c7622f7e-6147-4c9c-a0d0-e5a3b3437d85/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/c7622f7e-6147-4c9c-a0d0-e5a3b3437d85/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Yellow!",
		"suggestedCaption": null,
		"curatedCaption": null,
		"id": "5c2eee18-036e-462c-96c4-2497e7025124",
		"slug": "yellow",
		"width": 3896,
		"height": 2922,
		"userId": "5c2eee18-036e-462c-96c4-2497e7025124",
		"selectedCaption": "Yellow!"
	},
	{
		"user": {
			"id": "4b94933d-5866-443b-9c15-b75730993920",
			"username": "marina.peteoaca",
			"avatar": {
				"w120": "https://cdn1.foap.com/users/4b94933d-5866-443b-9c15-b75730993920/w120.?1500625083"
			}
		},
		"license": "Commercial",
		"price": 10,
		"averageRating": 4.68750000000001,
		"ratingsCount": 16,
		"resolutions": {
			"w640": "https://images02.foap.com/images/5eccf66a-9964-41e0-a661-023b661fa248/original.jpg?filename=w1920&dw=640",
			"w1920": "https://images02.foap.com/images/5eccf66a-9964-41e0-a661-023b661fa248/original.jpg?filename=w1920&dw=1920"
		},
		"caption": "Part of the sea",
		"suggestedCaption": "Shell, Seashell, Shellfish, Marine, Clam",
		"curatedCaption": null,
		"id": "74fb870a-eb1e-4745-8242-aaf7aecf2194",
		"slug": "part-of-the-sea",
		"width": 4928,
		"height": 3264,
		"userId": "74fb870a-eb1e-4745-8242-aaf7aecf2194",
		"selectedCaption": "Part of the sea"
	}
];

/***/ })

});


// WEBPACK FOOTER //
// build/39.bundle.1ba9cf2e9c755ae27ab1.js